export default {
  locale: 'fr',
  messages: {
	accountMy: 'Mon compte',
	actions: 'Actions',
	add: 'Ajouter',
	addressAddNew: 'Ajouter une nouvelle adresse',
	addressCity: 'Ville',
	addressCountries: 'Pays',
	addressCountry: 'Pays',
	addressDeleteConfirmTitle: 'Supprimer une adresse',
	addressDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
	addressDeleteSuccess: 'Adresse supprimée avec succès !',
	addressEdit: 'Modifier l\'adresse',
	addressFlags: 'Drapeaux',
	addressInvoice: 'Adresse de facturation',
	addressInvoiceDifferentAsShippingLabel: 'Les données de facturation sont-elles identiques à l\'adresse de livraison ?',
	addressInvoiceSelectionTitle: 'Sélectionnez votre adresse de facturation',
	addressInvoiceUsedFor: 'Utilisé pour la facture',
	addressInvoiceUse: 'Utiliser pour la facture',
	addressLabel: 'Intitulé de l\'adresse (ex: Maison)',
	addressLegalInformation: 'Informations légales',
	addressMy: 'Mes adresses',
	addressName: 'Nom & prénom du destinataire',
	addressNoItems: 'Vous n\'avez pas encore enregistré d\'adresse !',
	addressPhone: 'Téléphone (utile pour la livraison)',
	addressPostalCode: 'Code postal',
	addressRegion: 'État / province',
	addressShipping: 'Adresse de livraison',
	addressShippingSelectionTitle: 'Sélectionnez votre adresse de livraison',
	addressStreet1: 'Adresse',
	addressCustomsHint: 'Requis pour le dédouanement de votre colis.',
	addressStreetNumberHint: 'Pensez au numéro de rue : sans lui, le transporteur ne trouve souvent pas l\'adresse.',
	addressPostalCodeInvalid: 'Ce code postal ne correspond pas au pays sélectionné.',
	addressPhoneInvalid: 'Ce numéro semble incorrect. Le transporteur s\'en sert pour vous joindre.',
	addressPhoneMobileHint: 'Un portable est conseillé : le transporteur envoie l\'avis de passage par SMS.',
	addressIssueTitle: 'Cette adresse doit être complétée avant l\'expédition',
	addressIssueIncomplete: 'Des champs obligatoires sont manquants.',
	addressIssuePostalCode: 'Vérifiez le code postal pour le pays sélectionné.',
	addressIssuePhone: 'Un téléphone joignable est nécessaire : le transporteur vous appelle ou envoie l\'avis de passage.',
	addressIssueRegion: 'Sélectionnez l\'État ou la province demandée par le transporteur.',
	addressIssueTaxId: 'La douane exige un identifiant fiscal pour cette destination.',
	addressIssueComplete: 'Compléter cette adresse',
	addressTaxIdRfc: 'Identifiant fiscal mexicain (RFC)',
	addressTaxIdCpf: 'Identifiant fiscal brésilien (CPF)',
	addressTaxIdRut: 'Identifiant fiscal chilien (RUT)',
	addressTaxIdPccc: 'Code douanier personnel (PCCC)',
	addressTaxIdCuil: 'Identifiant fiscal argentin (CUIL)',
	addressTaxIdNationalId: 'Numéro d\'identité nationale',
	addressTaxIdNorwayNid: 'Numéro d\'identité norvégien (11 chiffres)',
	shippingPickupSelectedHint: 'Point relais sélectionné. Vous pouvez continuer.',
	shippingPickupMapUnavailable: 'Carte indisponible pour ces points relais. Utilisez la vue liste.',
	shippingPickupSelectedLabel: 'Point relais',
	shippingPickupNoResultHomeHint: 'Aucun point relais trouvé près de cette adresse. Essayez un autre code postal, ou choisissez la livraison à domicile ci-dessus.',
	shippingPickupErrorHomeHint: 'Impossible de charger les points relais. Réessayez, ou choisissez la livraison à domicile ci-dessus.',
	shippingProviderSendcloudInfoDefault: 'Livraison à domicile. Fabrication sous environ 2 jours ouvrés (lun-ven, hors jours fériés en France), puis transit transporteur. Le transporteur final est choisi à la création de l\'étiquette.',
	shippingProviderSendcloudPickupInfoDefault: 'Choisissez un point relais proche. Fabrication sous environ 2 jours ouvrés (lun-ven, hors jours fériés en France), puis transit. Le transporteur final est choisi à la création de l\'étiquette.',
	shippingLabelGenerateError: 'Échec de génération d\'étiquette. Vérifiez l\'adresse, le point relais et les identifiants Sendcloud, puis réessayez.',
	shippingSendcloudPickLog: 'Méthode Sendcloud utilisée',
	shippingSendcloudMethodOverride: 'Transporteur Sendcloud (étiquette)',
	shippingSendcloudMethodAuto: 'Automatique (meilleur match)',
	shippingSendcloudMethodOverrideHint: 'Laissez automatique, ou forcez une autre méthode Sendcloud avant de générer l\'étiquette.',
	orderShippingManualFlag: 'Aucun transporteur de nos contrats ne correspond à cette destination (pays, poids ou point relais). Choisissez une méthode Sendcloud ci-dessous, puis générez l\'étiquette.',
	shippingLegacyChronopostPaused: 'Cette commande est encore sur l\'ancien Chronopost. Passez le mode de livraison sur une offre Sendcloud avec Modifier, puis générez l\'étiquette.',
	orderShippingFedexPickupFlag: 'Expédition FedEx : la relève sera programmée automatiquement entre 18h et 21h (heure de Paris) pour le prochain jour ouvré.',
	orderShippingFedexPickupBookedFlag: 'Relève FedEx programmée pour le {date} (Sendcloud n°{id}).',
	shippingSurchargeCorsica: 'Ce tarif inclut un supplément Corse de {price}.',
	shippingSurchargeOverseas: 'Ce tarif inclut un supplément outre-mer de {price}.',
	shippingSurchargeRemote: 'Ce tarif inclut un supplément zone difficile d\'accès de {price}.',
	orderWeightHint: 'Total = poids unitaire × quantité ({quantity} articles → {weight} kg)',
	orderWeightHintPages: 'Estimé d\'après les pages ({grams} g/page) : {pages} pages → {weight} kg',
	shippingDeliveryApproxOn: 'Vers le {date}',
	shippingDeliveryApproxBetween: 'Entre le {date1} et le {date2}',
	addressStreet2: 'Complément d\'adresse (appartement, digicode, ...)',
	administrationTitle: 'Administration',
	affiliationComment: 'Commentaire',
	affiliationCommission: 'Commission',
	affiliationCommissionMultiplePendingAlert: 'Cette liste est une estimation: Les commandes & commissions ne sont pas consolidées !',
	affiliationCommissionPendingAlert: 'Cette commande est en attente de validation',
	affiliationDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette affiliation ?',
	affiliationInvoiceTotalTitle: 'Total TTC à encaisser',
	affiliationKey: 'Clé de l\'affilié',
	affiliationLegalApplyVAT: 'Appliquer la TVA ?',
	affiliationLegalInformations: 'Informations légales (facturation, Siret, ...)',
	affiliationMy: 'Mes affiliations',
	affiliationOptionValidityDays: 'Validité du lien d\'affiliation (jours)',
	affiliationSince: 'Membre depuis',
	affiliationViewResultsMy: 'Voir les recettes d\'affiliation',
	affiliations: 'Affiliations',
	alertContactError: 'Impossible d\'envoyer votre message ! Veuillez réessayer...',
	alertContactSuccess: 'Bien reçu !',
	alertConversationNoExists: 'Cette conversation n\'existe pas !',
	alertFetchApiError: 'Le serveur est actuellement hors service...',
	alertFormRequiredFieldsError: 'Veuillez remplir tous les champs obligatoires !',
	alertGenericError: 'Une erreur s\'est produite ! Veuillez essayer plus tard...',
	alertInstitutionAlreadyExists: 'Cette institution existe déjà !',
	alertJsonParseError: 'Le serveur a retourné une mauvaise réponse...',
	alertOrderValid: 'Votre commande est prête à être préparée !',
	alertUnauthorized: 'Votre session a expiré ! Veuillez vous reconnecter s\'il vous plaît',
	alertUserAlreadyExists: 'Un compte existe déjà avec cette adresse email !',
	alertUserRegisterSuccess: 'Bienvenue !',
	app404ErrorText: 'Nous ne trouvons pas ce que vous cherchez ! Retourner à la page d\'accueil ou à votre compte',
	app404ErrorTitle: 'Mauvaise route...',
	appAccessButton: 'Accéder à {app}',
	appAgreementAcceptButton: 'Lire les conditions générales d\'utilisation',
	appAgreementAcceptHelp: 'Vous avez la possibilité de lire les conditions en cliquant sur ce lien',
	appAgreementAcceptClickHint: 'Cliquez ici pour cocher et accepter',
	appAgreementAcceptLabel: 'J\'ai lu et accepte les conditions générales',
	appApplication: 'Application',
	appBackHomeButton: 'Retour à l\'accueil',
	appBackHomeTitle: 'Mauvais chemin...',
	appBugErrorText: 'Un problème s\'est produit.... DÉSOLÉ ! Veuillez cliquer sur le lien ci-dessous pour recharger cette page...',
	appConditionsAcceptTitle: 'Conditions générales d\'utilisation',
	appConditionsCheckError: 'Veuillez cocher avoir pris connaissance des conditions générales d\'utilisation !',
	appConditionsCheckLabel: 'J\'ai lu et j\'accepte les conditions générales d\'utilisation',
	appConditionsCheckSuccess: 'Bien reçu !',
	appConditionsUpdateDate: 'Mise à jour le {date}',
	appConfig: 'Config',
	appConfiguration: 'Configuration',
	appCookieConsentPrivacyLink: 'Consultez notre politique de confidentialité',
	appCookieConsentText: 'En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies à des fins de bon fonctionnement du service proposé et de statistiques. Aucune donnée personnelle ne sera communiquée sans votre accord préalable.',
	appCreateIndexButton: 'Créer l\'index de la base de données',
	appDataPrivacyCheckButton: 'Lisez notre politique de protection des données',
	appDatabase: 'Base de données',
	appErrorAlertText: 'Quelque chose d\'inattendu s\'est produit... Pas de panique ! Contactez-nous et nous résoudrons votre problème dans les plus brefs délais !',
	appErrorAlertTitle: 'Une erreur s\'est produite !',
	appForceUpdateApp: 'Forcer la mise à jour de l\'application',
	appForceUpdateAppWeb: 'Forcer la mise à jour de l\'application Web',
	appHome: 'Accueil',
	appMaintenanceModeText: 'Veuillez patienter un moment et revenez dans quelques instants...',
	appMaintenanceModeTitle: 'Nous sommes en cours de maintenance',
	appProcessLaunch: 'Processus de lancement',
	appQuestionLink: 'Des questions ?',
	appRewiewsHeaderText: 'Fabriqué en France 🇫🇷 avec Amour ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 avis Trustpilot',
	appShopOrderHistory: 'Suivi de commande',
	appStart: 'Créez votre livre',
	appVersion: 'Version',
	appVersionCurrent: 'Version actuelle de l\'application: {version}',
	appWebsiteAboutUs: 'Notre histoire',
	appWebsiteBlog: 'Blog',
	appWebsiteBook: 'Le livre',
	appWebsiteConversationAndroid: 'Imprimer ses SMS d\'Android',
	appWebsiteConversationInstagram: 'Imprimer ses messages Instagram',
	appWebsiteConversationIos: 'Imprimer des iMessages/SMS d\'iPhone',
	appWebsiteConversationMessenger: 'Imprimer ses messages Messenger',
	appWebsiteConversationWhatsapp: 'Imprimer ses messages WhatsApp',
	appWebsiteConversations: 'Choix de la messagerie',
	appWebsiteFaq: 'FAQ',
	appFooterQuestion: 'Une question ?',
	appFooterTerms: 'Conditions d\'utilisation',
	appWebsitePrices: 'Tarifs',
	appWelcomeTitle: 'Bienvenue sur {name}',
	autocompleteSearch: 'Saisir pour rechercher…',
	apply: 'Appliquer',
	back: 'Retour',
	by: 'par',
	cancel: 'Annuler',
	cartAddTo: 'Ajouter au panier',
	cartAuthInfo: 'Veuillez remplir votre email pour continuer...',
	cartContinuePurchase: 'Poursuivre mes achats',
	cartEmptyError: 'Votre panier est vide...',
	cartItemsRemoveAll: 'Tout supprimer',
	cartMy: 'Mon panier',
	cartMyEdit: 'Modifier mon panier',
	cartNextStepButton: 'Passez à l\'étape suivante',
	cartNoItems: 'Il n\'y a aucun article dans votre panier. .',
	cartNote: 'Remarque',
	cartProgression: 'Progression du panier',
	cartSalesConditionsAccept: 'En validant votre commande vous acceptez nos conditions de vente.',
	cartSee: 'Voir mon panier',
	cartShipping: 'Livraison',
	cartShippingFeeError: 'Nous ne pouvons pas livrer cette adresse ! Veuillez renseigner une autre adresse !',
	cartStepConfirmationTitle: 'Confirmation',
	cartStepInvoiceTitle: 'Facturation',
	cartStepPaymentTitle: 'Paiement',
	cartStepPreviewTitle: 'Panier',
	cartStepShippingTitle: 'Livraison',
	cartTotalShipping: 'Frais d\'expédition',
	cartTotalSubTotal: 'Sous-total',
	cartTotalTax: 'TVA',
	cartTotalTotal: 'Total',
	cartValidButton: 'Valider ma commande',
	checkoutEyebrow: 'Votre commande',
	checkoutStepUpsellTitle: 'Un exemplaire, ou deux ?',
	checkoutStepUpsellTitleGroup: 'Un exemplaire, ou deux ? Ou plus ?',
	checkoutStepUpsellHint: 'Gardez-le pour vous, offrez-le à un proche, ou les deux.',
	checkoutStepUpsellHintGroup: 'Chacun le sien : réduction dès le deuxième exemplaire.',
	checkoutStepShippingTitle: 'Où recevoir votre livre ?',
	checkoutStepShippingHint: 'Nous l\'imprimons avec soin et vous l\'envoyons partout dans le monde.',
	checkoutStepInvoiceTitle: 'Vos informations',
	checkoutStepInvoiceHint: 'Pour votre facture et le suivi de votre commande.',
	checkoutStepPaymentTitle: 'Régler en toute sécurité',
	checkoutStepPaymentHint: 'Carte bancaire, Apple Pay, Google Pay : paiement chiffré.',
	checkoutPdfReadyTitle: 'Votre eBook est prêt',
	checkoutPdfReadyHint: 'Aucune livraison nécessaire : finalisez votre commande.',
	checkoutSummaryEyebrow: 'Récapitulatif',
	cartReassuranceSecure: 'Paiement sécurisé',
	cartReassuranceReturn: 'Satisfait ou remboursé',
	cartReassuranceSupport: 'Support disponible',
	checkoutPromoEyebrow: 'Code promo',
	checkoutGiftEyebrow: 'Carte cadeau',
	checkoutGiftCodeLabel: 'Code cadeau',
	checkoutGiftCodePlaceholder: 'Saisissez votre code cadeau',
	checkoutGiftCodeHint: 'Vous avez reçu une carte cadeau ? Entrez votre code ici.',
	checkoutGiftToggle: 'Vous avez une carte cadeau ?',
	checkoutAddCopy: 'Ajouter un exemplaire',
	checkoutSecondCopyKicker: 'Pour vous, ou pour offrir',
	checkoutSecondCopyKickerGroup: 'Chacun le sien',
	checkoutSecondCopyTitle: 'L\'exemplaire en plus, à moitié prix',
	checkoutSecondCopyTitlePercent: 'L\'exemplaire en plus',
	checkoutSecondCopyFor: 'cet exemplaire',
	checkoutSecondCopyForGroup: 'le 2ᵉ',
	checkoutSecondCopyChip: '2ᵉ à moitié prix',
	checkoutSecondCopyChipPercent: '2ᵉ à −{percent} %',
	checkoutSecondCopySet: 'Les {count} tomes, ensemble',
	checkoutSecondCopyPerBook: 'le livre',
	checkoutSecondCopySetPrice: 'soit {price} les {count} tomes',
	checkoutExtraBooksChip: 'livres en plus à moitié prix',
	checkoutExtraBooksChipPercent: 'livres en plus à −{percent} %',
	checkoutGroupQtyHint: 'Le 3ᵉ aussi : chaque livre en plus, à −{percent} %.',
	productExtraCopyRate: 'Livres en plus, en % du prix d\'un tome',
	productExtraCopyRateHelp: 'Chaque livre au-delà du premier exemplaire est à ce pourcentage du prix d\'un tome. Vide : 50 %. 0 : paliers de quantité.',
	checkoutGroupPicksLabel: 'Exemplaires',
	checkoutGroupAddSecond: '2ᵉ',
	checkoutGroupAddThird: '3',
	checkoutGroupAddSecondAria: 'Ajouter le deuxième exemplaire à moitié prix',
	checkoutGroupAddThirdAria: 'Passer à trois exemplaires',
	checkoutQtyGroupHint: 'Chacun le sien : la remise s\'applique dès le deuxième exemplaire.',
	checkoutQtyPdfSingle: '1 eBook',
	checkoutQtyMoreAriaLabel: 'Autre quantité',
	checkoutQtyVolumeBreakdown: '{copies} exemplaires × {volumes} tomes = {total} livres',
	checkoutOfferBookCount: '{count, plural, one {# livre} other {# livres}}',
	checkoutUpsellTwoHint: 'Idéal pour offrir : ajoutez un deuxième exemplaire, la réduction s\'applique automatiquement.',
	checkoutEmptyTitle: 'Aucune commande en cours',
	checkoutEmptyHint: 'Retournez à votre livre pour choisir votre édition.',
	checkoutEmptyCta: 'Voir mes conversations',
	checkoutBookAsideEyebrow: 'Votre livre',
	checkoutBookAsideEyebrowPlural: 'Vos livres',
	checkoutBookAsideVolume: 'tome',
	checkoutBookAsideVolumes: 'tomes',
	checkoutBookAsideShelfLabel: 'Les {count} tomes de votre commande',
	checkoutBookAsideEbook: 'eBook',
	checkoutBookAsidePaper: 'Livre papier',
	checkToggler: 'Tout Sélectionner/Déselectionner',
	choose: 'Choisir',
	close: 'Fermer',
	code: 'Code',
	cmsDeleteConfirmTitle: 'Supprimer le contenu',
	cmsDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce contenu ?',
	cms: 'CMS',
	cmsAdminListHint: 'Modifier les pages, panneaux et traductions. Les drapeaux indiquent le statut de traduction par langue.',
	cmsPageAdd: 'Ajouter une page',
	cmsContentDuplicateSuccess: 'Contenu CMS dupliqué !',
	companyShippingEdit: 'Modifier le transport',
	conditions: 'Conditions',
	configMissingKeyAlert: 'La propriété de clé de configuration est manquante !',
	configAdminHint: 'Paramètres de l\'application, affiliations, processus en arrière-plan et clés de configuration brutes.',
	configuration: 'Configuration',
	confirm: 'Confirmer',
	confirmMessage: 'Veuillez confirmer votre action.',
	confirmTitle: 'Êtes-vous sûr ?',
	contactButton: 'Contactez-nous',
	contactMessage: 'Message',
	contactPageButton: 'Envoyer',
	contactPageText1: 'Besoin d\'aide ? D\'information ? Nous sommes là pour vous aider !',
	contactPageTitle: 'Contactez-nous',
	contactSend: 'Envoyer',
	continue: 'Poursuivre',
	console: 'Console',
	country: 'Pays',
	conversationActionContinue: 'Poursuivre',
	conversationActionRestart: 'Recommencer',
	conversationAddTitle: 'Ajouter une conversation',
	conversationAdminDeleteConfirmTitle: 'Supprimer la conversation',
	conversationAdminDeleteConfirmMessage: 'Cette conversation et tous ses médias seront définitivement supprimés. Cette action est irréversible.',
	conversationAdminListHint: 'Parcourez, filtrez et gérez toutes les conversations clients. Utilisez les onglets de statut pour cibler une étape du pipeline.',
	conversationArchiveError: 'Nous ne pouvons lire votre archive ! Veuillez nous contacter pour résoudre le problème s\'il vous plaît...',
	conversationBookOrderTypeBook: 'Livre + eBook(s) offert',
	conversationBookOrderTypePdf: 'eBook(s) seulement',
	conversationBookPreview: 'Aperçu',
	conversationBookPreviewSelected: 'Aperçu du livre n°{number}',
	conversationBookSelector: 'Sélectionnez le livre à modifier',
	conversationBookTypeLabelBook: 'Papier + Ebook',
	conversationBookTypeLabelPdf: 'Ebook seulement',
	conversationBooks: 'Livres',
	conversationCollectorArchiveSelectButton: 'Téléverser une archive',
	conversationCollectorInitWaiting: 'Nous initialisons certaines données ... Veuillez patienter',
	conversationCollectorUseArchive: 'Téléverser une sauvegarde de données (archive)',
	conversationCoverBookEdit: 'Personnaliser la couverture',
	conversationCoverBookReset: 'Réinitialiser la couverture de ce livre',
	conversationCoverApplyToAllBooks: 'Appliquer cette couverture à tous les tomes',
	conversationCoverAutoAppliedToAllBooks: 'Couverture appliquée aux autres tomes.',
	conversationCoverApplyToAllBooksTitle: 'Appliquer cette couverture à tous les tomes ?',
	conversationCoverApplyToAllBooksMessage: 'Choisissez les éléments à appliquer à tous les autres tomes.',
	conversationCoverApplyOptionColor: 'Couleur',
	conversationCoverApplyOptionPhoto: 'Photo',
	conversationCoverApplyOptionTitle: 'Titre',
	conversationCoverApplyOptionSubtitle: 'Sous-titre',
	conversationCoverBookSwitchAlertMessage: 'Les informations de couverture pour ce livre uniquement seront sauvegardées.',
	conversationCoverBookSwitchAlertTitle: 'Voulez-vous enregistrer la couverture pour ce livre ?',
	conversationCoverColorEditTitle: 'Choix de la couverture',
	conversationCoverLuxEyebrow: 'Votre couverture',
	conversationCoverLuxHint: 'Choisissez le modèle et la couleur, puis personnalisez le plat.',
	conversationCoverResumeLuxEyebrow: 'Préface',
	conversationCoverResumeLuxHint: 'Facultatif : ce texte sera imprimé en deuxième de couverture.',
	conversationCoverBookNumber: 'Tome {number}',
	conversationCreationDate: 'Date de création',
	conversationCustomImportUpload: 'Importer le fichier généré',
	conversationCoverFooterPrefaceGuide: 'Retour à l’aperçu pour passer la préface, ou continuez pour la rédiger (facultatif, imprimée en deuxième de couverture).',
	conversationCoverFooterNextPreface: 'Préface (facultatif)',
	conversationCoverFooterSkipPreface: 'Passer la préface · retour à l’aperçu',
	conversationCoverFooterBackToCover: 'Retour à la couverture',
	conversationCoverFooterFinishPreview: 'Terminer · retour à l’aperçu',
	conversationCoverFooterGoPreview: 'Retour à l’aperçu',
	conversationCoverEditionTypeTitle: 'Type d\'édition du livre',
	conversationCoverEditionTypeBookHelp: 'En collection complète, personnalisez la couverture de chaque tome.',
	conversationCoverColorSelectorHelp: 'Choisissez la couleur de la couverture',
	conversationCoverStyleSelectorHelp: 'Choisissez le modèle de couverture',
	conversationCoverStylePhoto: 'Polaroid',
	conversationCoverStyleIncipit: '1er message',
	conversationCoverPickMessageTitle: 'Choisir un message',
	conversationCoverEditQuote: 'Modifier la phrase',
	conversationCoverPickMessageHint: 'Elle s\'affiche en grand sur la couverture.',
	conversationCoverPickMessageSearch: 'Chercher un message',
	conversationCoverPickMessageEmpty: 'Aucun message ne correspond.',
	conversationCoverAddQuote: 'Ajouter une phrase',
	conversationCoverHourLabel: 'Heure',
	conversationCoverDateLabel: 'Date',
	conversationCoverGroupNameLabel: 'Nom du groupe',
	conversationCoverSpanLabel: 'Dates du premier et du dernier message',
	conversationCoverApplyOptionStyle: 'Modèle',
	conversationCoverApplyOptionQuote: 'Phrase',
	conversationCoverDragNDropFiles: 'Glissez/Déposez une image ici',
	conversationCoverTapToSelectPhoto: 'Appuyez pour choisir une photo',
	conversationCoverOpenFinder: 'Sélectionnez une image',
	conversationCoverPhotoSelectorTitle: 'Choisissez une photo',
	conversationCoverPhotoEditHint: 'Cliquez pour changer la photo',
	conversationCoverPhotoChoose: 'Cliquez pour choisir une photo',
	conversationPreviewSwipeHint: 'Glissez pour tourner les pages',
	conversationPreviewOpenBookHint: 'Glissez la couverture pour ouvrir le livre',
	conversationPreviewDiscoverBook: 'Découvrir mon livre',
	conversationPreviewVolumesLabel: 'Votre collection : {count} livres',
	conversationPreviewVolumesHint: 'Touchez une couverture pour ouvrir ce tome.',
	conversationCoverResumeEditTitle: 'Écrivez une préface (facultatif)',
	conversationCoverResumeError: 'Préface trop longue pour tenir sur une page : raccourcis le texte ou réduis les retours à la ligne.',
	conversationCoverResumeNearLimit: 'Tu approches de la limite d\'une page ({lines}/{max} lignes).',
	conversationCoverResumeHelp: 'Cette préface sera imprimée sur la seconde de couverture.',
	conversationCoverResumePlaceholder: 'Écrivez une préface pour votre livre',
	conversationCoverResumeReset: 'Réinitialiser le CV de ce livre',
	conversationCoverTitleError: 'Titre trop long (max: {max} caractères)',
	conversationCoverTitleHelp: 'Cliquez pour modifier le titre du livre',
	conversationCoverTitlePlaceholder: 'Entrez un titre...',
	conversationCoverDefaultTitleTwoNames: '{name1} et {name2}',
	conversationCoverDefaultTitleGroup: 'Notre groupe',
	conversationCoverDefaultTitleSingle: 'Mes messages',
	conversationCoverWaitingForCustomization: 'Vous pourrez personnaliser votre couverture à la prochaine étape...',
	conversationCreateInfoText: 'Créez un nouveau livre de messages en cliquant sur les icônes ici',
	conversationCreateMyBookTitle: 'Je crée mon livre',
	conversationCreateTitle: 'Créer un livre',
	conversationDateCreation: 'Date de création',
	conversationDateDownloadedInfo: 'Le livre a été téléchargé le {downloaded}',
	conversationDateEnd: 'Fin de la conversation',
	conversationDateEndInfo: 'Le livre termine le {end}',
	conversationDateEndLabel: 'Sélectionner la date de fin',
	conversationDateEndMessageSelection: 'Finir le livre ici',
	conversationDateGeneratedInfo: 'Le livre a été généré le {generated}',
	conversationDateRange: 'Du {start} au {end}',
	conversationDeleteConfirmation: 'La conversation a été supprimée !',
	conversationDateSelectionAlert: 'Il semblerait que votre conversation ait été endommagée durant le transfert. Veuillez essayer à nouveau en restant sur la page lors du transfert et en ayant une bonne connexion internet.',
	conversationDateSimulatedInfo: 'Le livre a été visualisé le {simulated}',
	conversationDateStart: 'Début de la conversation',
	conversationDateStartInfo: 'Le livre débute le {start}',
	conversationDateStartLabel: 'Sélectionner la date de début',
	conversationDateStartMessageSelection: 'Commencer le livre ici',
	conversationDatesLuxEyebrow: 'Votre histoire',
	conversationDatesLuxHint: 'Choisissez la date de début et de fin du livre. Cliquez sur un message pour affiner la sélection.',
	conversationDatesLuxNextEnd: 'Date de fin',
	conversationDatesLuxBackStart: 'Date de début',
	conversationDatesLuxSavePreview: 'Enregistrer · retour à l’aperçu',
	conversationDatesPresetsLabel: 'Sélection rapide de période',
	conversationDatesPreset_all: 'Toute la conversation',
	conversationDatesPreset_year: 'Dernière année',
	conversationDatesPreset_sixMonths: '6 derniers mois',
	conversationDatesSelectionCount: '{count, number} {count, plural, one {message} other {messages}}',
	conversationDatesSelectionPeriod: 'du {start} au {end}',
	conversationDatesStoryDuration: 'Cette sélection couvre {duration}',
	conversationDatesStartCaption: 'Votre tout premier message',
	conversationDatesEndCaption: 'Votre tout dernier message',
	conversationDatesBookMessages: '{messages, number} {messages, plural, one {message} other {messages}}, {photos, number} {photos, plural, one {photo} other {photos}} et {medias, number} {medias, plural, one {média} other {médias}} dans votre sélection',
	conversationDateSelectionEmpty: 'Aucun message sur cette période. Élargissez la sélection.',
	conversationDatesEditTitle: 'Sélection de date',
	conversationDemoAlert: 'Vous allez pouvoir découvrir les premieres pages de votre livre.<br></br>Une fois commandé, vous recevrez la version complète pour vérifier avant l\'impression.',
	conversationDemoEndAlert: 'Vous pourrez découvrir le reste de vos messages après confirmation de votre achat.',
	conversationPreviewEndTitle: 'La suite vous attend',
	conversationPreviewEndBody: 'Le reste de vos messages vous est réservé. Commandez pour accéder à la version intégrale de votre livre.',
	conversationPreviewEndCta: 'Commander maintenant',
	conversationPreviewEndBodyPaused: 'Validez vos modifications. La version numérique vous arrive par email juste après, pour la vérifier.',
	conversationPreviewEndCtaPaused: 'Valider mes modifications',
	conversationPreviewPrefaceOptionalBadge: 'Facultatif',
	conversationPreviewPrefaceEmptyTitle: 'Une préface, si vous le souhaitez',
	conversationPreviewPrefaceEmptyText: 'Quelques mots pour introduire votre livre : totalement facultatif.',
	conversationPreviewPrefaceEmptyButton: 'Ajouter une préface',
	conversationPreviewPrefaceEditButton: 'Modifier la préface',
	conversationPreviewCoverEditButton: 'Modifier la couverture',
	conversationPreviewCoverOpenLabel: 'Ouvrir le livre',

	conversationDisclaimerSubtitle: 'Choisissez votre format pour accéder à votre atelier de personnalisation.',
	conversationDisclaimerTitle: `{count} {count, plural,
		=0 {message}
		=1 {message}
		other {messages}
	}: une histoire qui mérite d'être lue`,
	conversationDisclaimerSavings: 'Vous économisez {value}',
	conversationDisclaimerEBookIncluded: 'Édition Ebook incluse',
	conversationDisclaimerGenerating: 'Génération de votre livre en cours...',

	conversationDisclaimerPlanSingleTitle: 'Le Tome 1',
	conversationDisclaimerPlanSingleDescription: "L'Essentiel",
	conversationDisclaimerPlanSingleButtonText: 'Créer mon livre',
	conversationDisclaimerPlanSingleFeaturePages: 'Le livre de votre choix (400 pages) livré',
	conversationDisclaimerPlanSingleFeatureQuality: '',
	conversationDisclaimerPlanSingleFeatureEvolutive: 'Évolutif : complétez la suite plus tard',
	conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Papier Premium',
	conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Impression sur Papier Premium',
	conversationDisclaimerPlanSingleFeaturePdfIncluded: 'Version PDF incluse (Valeur {price})',
	conversationDisclaimerPlanSingleFeatureWorkshop: 'Personnalisation complète offerte',
	conversationDisclaimerPlanSingleFeatureMedia: 'Photos, Vidéos & Audios inclus',

	conversationDisclaimerPlanCollectionTitle: 'La Collection complète',
	conversationDisclaimerPlanCollectionDescription: 'L\'Intégrale',
	conversationDisclaimerPlanCollectionButtonText: 'Conserver toute notre histoire',
	conversationDisclaimerPlanCollectionBadge: 'OFFRE PACK -{percentage}%',
	conversationDisclaimerPlanCollectionFeatureBox: 'Vos {count} livres imprimés & livrés',
	conversationDisclaimerPlanCollectionFeatureDiscount: 'Tarif Collection -{percentage}% (-{amount} inclus)',
	conversationDisclaimerPlanCollectionFeatureDigital: 'Édition numérique offerte',
	conversationDisclaimerPlanCollectionFeatureWorkshop: 'Personnalisation complète offerte',
	conversationDisclaimerPlanCollectionFeatureMedia: 'Photos, Vidéos & Audios inclus',

	conversationDisclaimerPlanEbookTitle: "L'Édition Ebook",
	conversationDisclaimerPlanEbookDescription: 'Le Numérique',
	conversationDisclaimerPlanEbookButtonText: 'Sauvegarder en PDF',
	conversationDisclaimerPlanEbookFeaturePdf: 'PDF Haute Définition immédiat',
	conversationDisclaimerPlanEbookFeatureShare: 'Partage facile',
	conversationDisclaimerPlanEbookFeatureMessages: "L'intégralité de vos {count} messages",
	conversationDisclaimerPlanEbookFeatureMedia: 'Photos, Vidéos & Audios inclus',

	conversationDisclaimerReassuranceGuaranteeTitle: 'Garantie Satisfait ou Remboursé',
	conversationDisclaimerReassuranceGuaranteeDescription: "Remboursement sur simple demande jusqu'à la validation finale.",
	conversationDisclaimerReassuranceCustomTitle: 'Personnalisation Libre',
	conversationDisclaimerReassuranceCustomDescription: 'Modifiez couverture et messages après le paiement',
	conversationDisclaimerReassuranceSecureTitle: 'Paiement 100% Sécurisé',
	conversationDisclaimerReassuranceSecureDescription: 'Carte bancaire, Apple Pay, Google Pay, Link',
	conversationDisclaimerReassuranceDeliveryTitle: 'Livraison Rapide',
	conversationDisclaimerReassuranceDeliveryDescription: 'Livraison sous 5 jours ouvrés',

	conversationDisclaimerReviewSuffix: 'sur +{count} livres imprimés',

	conversationDowloadUnableAlert: 'Vous ne pouvez plus télécharger les livres de conversation... Contactez-nous pour résoudre votre problème.',
	conversationDownloadBackPreview: 'Revoir l\'aperçu de mon livre',
	conversationDownloadDeadlineInfo: 'Vous pouvez télécharger vos fichiers jusqu\'au {date}',
	conversationDownloadEyebrow: 'Votre livre est prêt',
	conversationDownloadHint: 'Téléchargez votre PDF et conservez une copie numérique de votre conversation.',
	conversationDownloadLoading: 'Préparation de vos fichiers…',
	conversationDownloadLink: 'Télécharger mon livre N°{index}',
	conversationDownloadFileCoverLink: 'Télécharger la couverture {name}',
	conversationDownloadFileSourceLink: 'Télécharger la source {name}',
	conversationDownloadPdfButton: 'Télécharger l\'E-book',
	conversationDownloadPdfWaitingMessage: 'Attendez 5 minutes pour télécharger à nouveau',
	conversationEditStart: 'Éditer le livre',
	conversationEditSuccess: 'La conversation a été modifiée !',
	conversationFlags: 'Drapeaux',
	conversationImages: 'Images',
	conversationMedias: 'Médias',
	'conversationFormatLabelA4-1': 'Chroniques de vos souvenirs',
	'conversationFormatLabelA4-2': '(album A4)',
	'conversationFormatLabelA5-1': 'Le petit trésor',
	'conversationFormatLabelA5-2': '(carnet A5)',
	conversationGeneratedSuccess: 'Félicitations ! <br></br> Votre conversation a bien été généré !',
	conversationGenerationAlert: 'Nous composons votre livre…',
	conversationGenerationAlert2: 'Restez avec nous, cela ne prend que quelques instants.',
	conversationGenerationFailed: 'La composition de votre livre s\'est interrompue.',
	conversationGenerationFailedHint: 'Vos messages sont bien enregistrés. Relancez la composition. Si cela recommence, écrivez-nous et nous regardons avec vous.',
	conversationGenerationRetry: 'Relancer',
	conversationHelpBooksText: 'Basculez entre vos livres pour modifier leurs propres informations',
	conversationHelpBooksTitle: 'Sélection du livre',
	conversationHelpCoverColorText: 'Vous pouvez changer la couleur de fond de la couverture en cliquant sur le cercle.',
	conversationHelpCoverColorTitle: 'Couleur de la couverture',
	conversationHelpCoverImageText: 'Vous pouvez glisser et déposer n’importe quel fichier image dans cet espace pour l’ajouter à votre couverture.',
	conversationHelpCoverImageTitle: 'Image de couverture',
	conversationHelpCoverTitleText: 'Cliquez sur le titre pour le modifier ! Vous avez 2 lignes à modifier : Titre et Sous-titre',
	conversationHelpCoverTitleTitle: 'Titre de la couverture',
	conversationHelpDatePreviewText: 'Sélectionnez la date de début de votre livre.',
	conversationHelpDatePreviewTitle: 'Date',
	conversationHelpDateSelectorText: 'En changeant la date, vos premiers/derniers messages s\'affichent ici !',
	conversationHelpDateSelectorTitle: 'Aperçu du message',
	conversationHelpParticipantColorText: 'Vous pouvez changer la couleur des bulles de chaque participant',
	conversationHelpParticipantColorTitle: 'Couleur des participants',
	conversationHelpParticipantNameText: 'Modifiez le nom du participant comme vous le souhaitez !',
	conversationHelpParticipantNameTitle: 'Nom du participant',
	conversationHelpParticipantPositionText: 'Choisissez si vous préférez afficher le participant de Bubble à gauche ou à droite',
	conversationHelpParticipantPositionTitle: 'Position du participant',
	conversationHelpMessagesToolsTitle: 'Outils',
	conversationHelpMessagesToolsText: 'Touchez une tuile pour rechercher, filtrer par médias ou dates, ou masquer des messages.',
	conversationHelpMessagesSearchTitle: 'Recherche',
	conversationHelpMessagesSearchText: 'Tapez un mot ou un prénom pour retrouver un message rapidement.',
	conversationHelpMessagesMediasTitle: 'Médias',
	conversationHelpMessagesMediasText: 'Filtrez les messages qui contiennent des photos, vidéos, audios ou liens.',
	conversationHelpMessagesDatesTitle: 'Dates',
	conversationHelpMessagesDatesText: 'Gardez seulement les messages entre deux dates pour vous concentrer sur une partie de la conversation.',
	conversationHelpMessagesHidePeriodTitle: 'Masquer une période',
	conversationHelpMessagesHidePeriodText: 'Choisissez deux dates pour masquer (ou réafficher) toute une période d\'un coup.',
	conversationHelpMessagesHiddenTitle: 'Affichage',
	conversationHelpMessagesHiddenText: 'Affichez tous les messages, seulement les visibles, ou seulement les masqués.',
	conversationHelpMessagesListTitle: 'Modifier un message',
	conversationHelpMessagesListText: 'Sur chaque bulle : sélectionner, masquer, modifier le texte ou en ajouter un.',
	conversationHelpMessagesFooterTitle: 'Retour à l\'aperçu',
	conversationHelpMessagesFooterText: 'Quand c\'est bon, revenez à l\'aperçu pour voir votre livre à jour.',
	conversationHelpPreviewBookCoverText: 'Donnez-lui une couverture unique. Cliquez pour la personnaliser.',
	conversationHelpPreviewBookCoverTitle: 'Couverture',
	conversationHelpPreviewBookPreviewText: 'Cliquez pour feuilleter ce livre en avant-première.',
	conversationHelpPreviewBookPreviewTitle: 'Aperçu du livre',
	conversationHelpPreviewBookSelectorText: 'Sélectionnez les volumes que vous souhaitez inclure dans votre commande.',
	conversationHelpPreviewBookSelectorTitle: 'Vos livres',
	conversationHelpPreviewBookSplitText: 'En activant cette option, chaque livre contiendra le même nombre de pages.',
	conversationHelpPreviewBookSplitTitle: 'Équilibrer les pages',
	conversationHelpPreviewCopyText: 'Commandez plusieurs exemplaires : pour vous, pour offrir. Réduction dès le 2ème.',
	conversationHelpPreviewCopyTitle: 'Offrir un exemplaire',
	conversationHelpPreviewFormatText: 'Livre papier ou eBook numérique : choisissez ce qui vous ressemble.',
	conversationHelpPreviewFormatTitle: 'Format',
	conversationHelpPreviewRenderText: 'Voici votre livre. Personnalisez la couverture directement dessus, puis feuilletez les pages.',
	conversationHelpPreviewRenderTitle: 'Votre livre',
	conversationHelpPreviewMessagesText: 'Touchez cette carte pour modifier le contenu des messages.',
	conversationHelpPreviewMessagesTitle: 'Messages',
	conversationHelpPreviewDatesText: 'Touchez cette carte pour choisir les dates de début et de fin de votre livre.',
	conversationHelpPreviewDatesTitle: 'Dates',
	conversationHelpPreviewParticipantsText: 'Touchez cette carte pour changer les prénoms et l\'apparence des participants.',
	conversationHelpPreviewParticipantsTitle: 'Participants',
	conversationHelpPreviewCoverTitleText: 'Cliquez sur le titre ou le sous-titre pour les modifier.',
	conversationHelpPreviewCoverTitleTitle: 'Titre et sous-titre',
	conversationHelpPreviewVolumesTitle: 'Plusieurs tomes',
	conversationHelpPreviewVolumesText: 'Votre conversation tient en plusieurs livres. Touchez un numéro pour changer de tome et personnaliser chaque couverture.',
	conversationHelpPreviewCoverImageText: 'Touchez la zone photo pour ajouter ou changer l\'image de couverture.',
	conversationHelpPreviewCoverImageTitle: 'Photo',
	conversationHelpPreviewCoverColorText: 'Touchez une pastille pour changer la couleur de fond de la couverture.',
	conversationHelpPreviewCoverColorTitle: 'Couleur',
	conversationHelpPreviewValidText: 'Quand tout est prêt, validez. Votre eBook arrive par e-mail, votre livre chez vous.',
	conversationHelpPreviewValidTitle: 'C\'est parti !',

	conversationHighlightStartDateTitle: 'Le premier message',
	conversationHighlightStartDateDescription: 'Le premier message est parti ce jour-là. Toute la suite en est née.',
	conversationHighlightDurationTitle: 'Ensemble depuis',
	conversationHighlightDurationDescription: 'Autant de jours ensemble, depuis ce premier message.',
	conversationHighlightMessagesCountTitle: 'Messages',
	conversationHighlightMessagesCountDescription: 'Tous ces messages, échangés depuis le {date}.',
	conversationHighlightImagesCountTitle: 'Photos',
	conversationHighlightImagesCountDescription: 'Ces photos, gardées dans nos échanges.',
	conversationHighlightMediasCountTitle: 'Vidéos et vocaux',
	conversationHighlightMediasCountDescription: 'Pour réentendre une voix et revoir un moment.',
	conversationHighlightSpecialDayMessagesCountTitle: 'En une journée',
	conversationHighlightSpecialDayMessagesCountDescription: 'Notre record de messages, en une seule journée.',
	conversationHighlightSpecialDayTitle: 'Cette journée',
	conversationHighlightSpecialDayDescription: 'Le jour où nous nous sommes le plus écrit.',
	conversationHighlightCharsCountReferenceDiffTitle: 'Roméo et Juliette',
	conversationHighlightCharsCountReferenceDiffDescription: 'Autant de fois le texte de Roméo et Juliette.',
	conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} fois',
	conversationHighlightTypingDurationTitle: 'Écriture',
	conversationHighlightTypingDurationDescription: 'Autant d\'heures passées à nous écrire.',
	conversationHighlightUnitDays: '{count, plural, one {jour} other {jours}}',
	conversationHighlightUnitMessages: '{count, plural, one {message} other {messages}}',
	conversationHighlightUnitHours: '{count, plural, one {heure} other {heures}}',
	conversationHighlightUnitTimes: 'fois',

	conversationHighlightBadge: 'En quelques chiffres',
	conversationHighlightStoryKicker: 'Votre histoire',
	conversationHighlightsMomentsCount: '{count, plural, one {# image à télécharger} other {# images à télécharger}}',
	conversationHighlightShareFormat: 'Format story',
	conversationHighlightsCardFooter: 'Certaines histoires méritent un livre',
	conversationHighlightShareButton: 'Télécharger',
	conversationHighlightShareButtonAlt: 'Voir les statistiques de la conversation',
	conversationHighlightShareImageButton: 'Envoyer l\'image',
	conversationHighlightSubtitle: 'Les chiffres de ce que vous vous êtes dit.',
	conversationHighlightTitle1: 'Vos échanges',
	conversationHighlightTitle2: 'en quelques chiffres',
	conversationHighlightsLoading: 'On rassemble vos chiffres.',
	conversationHighlightsEmpty: 'Pas encore assez d\'échanges pour en tirer des chiffres.',
	conversationHighlightOpenStoryButton: 'Ouvrir cette story',
	conversationHighlightsAtGlanceEyebrow: 'En un regard',
	conversationHighlightsAtGlanceTitle: 'La taille de votre histoire',
	conversationHighlightsNoAiNote: 'Ces statistiques sont calculées automatiquement, sans IA.',
	conversationHighlightsKpiMessages: 'messages',
	conversationHighlightsKpiWords: 'mots écrits',
	conversationHighlightsKpiActiveDays: 'jours actifs',
	conversationHighlightsKpiStreak: 'jours à la suite',
	conversationHighlightsRhythmEyebrow: 'Votre rythme',
	conversationHighlightsRhythmTitle: 'Quand vos messages prennent vie',
	conversationHighlightsTopHour: 'Votre heure',
	conversationHighlightsTopWeekday: 'Votre jour',
	conversationHighlightsNightMessages: 'Messages la nuit',
	conversationHighlightsChartMonths: 'Tous les mois, du premier au dernier message',
	conversationHighlightsChartYears: 'Toutes les années, du premier au dernier message',
	conversationHighlightsLessThanOneMinute: 'moins d’1 min',
	conversationHighlightsSpanLessThanMonth: 'Moins d’un mois',
	conversationHighlightsSpanYears: '{count, plural, one {# an} other {# ans}}',
	conversationHighlightsSpanMonths: '{count, plural, one {# mois} other {# mois}}',
	conversationHighlightsSpanYearsMonths: '{years, plural, one {# an} other {# ans}} et {months, plural, one {# mois} other {# mois}}',
	conversationHighlightsSpanLabel: 'Du premier au dernier message',
	conversationHighlightsBusiestDayLabel: 'Jour le plus bavard',
	conversationHighlightsPhotosLabel: 'Photos',
	conversationHighlightsMediasLabel: 'Vidéos et vocaux',
	conversationHighlightsBookPagesLabel: 'Votre livre',
	conversationHighlightsBookPagesPrefix: 'environ',
	conversationHighlightsBookPagesUnit: '{count, plural, one {page} other {pages}}',
	conversationHighlightsBookPagesNote: 'Estimation à partir de vos messages et de vos photos.',
	conversationHighlightsWritingHours: 'Environ {count, plural, one {# heure à vous écrire} other {# heures à vous écrire}}.',
	conversationHighlightsRomeo: 'Autant que {count} fois Roméo et Juliette.',
	conversationHighlightsDayClockPeak: 'Le plus souvent entre {start} h et {end} h',
	conversationHighlightsLessThanOnePercent: '< 1 %',
	conversationHighlightsWritesLonger: '{name} écrit les messages les plus longs.',
	conversationHighlightsStartsMore: '{name} ouvre le plus souvent la conversation.',
	conversationHighlightsWordsPerMessage: '{count} mots / message',
	conversationHighlightsStartsShare: '{percent} % des débuts',
	conversationHighlightsMedianReply: 'Réponse médiane',
	conversationHighlightsBalanceEyebrow: 'Votre équilibre',
	conversationHighlightsBalanceTitle: 'Chacun a sa façon d\'être là',
	conversationHighlightsWordsShort: 'mots',
	conversationHighlightsStartsShort: 'débuts',
	conversationHighlightsBalanceNote: 'Un pourcentage décrit un rythme, jamais l’importance d’une personne.',
	conversationHighlightsRecordsEyebrow: 'Vos records',
	conversationHighlightsRecordsTitle: 'Les chiffres à retenir',
	conversationHighlightsLongestSession: 'Plus longue série de messages',
	conversationHighlightsIntenseQuarter: 'Record en 15 minutes',
	conversationHighlightsQuestions: 'Messages tendres',
	conversationHighlightsSignsOfInterest: 'cœurs, bisous ou « je t’aime »',
	conversationHighlightsLaughs: 'Messages avec un rire',
	conversationHighlightsSharedSmiles: 'haha, MDR ou emoji de rire',
	conversationHighlightsFavoriteEmojis: 'Vos emojis préférés',
	conversationHighlightsStoriesEyebrow: 'À garder',
	conversationHighlightsStoriesTitle: 'Vos cartes souvenirs',
	conversationHighlightsStoriesText: 'Ouvrez une carte, puis téléchargez-la au format story.',
	conversationHighlightsDeepEyebrow: 'Et après les chiffres ?',
	conversationHighlightsDeepTitle: 'Aimeriez-vous une lecture plus profonde de votre histoire ?',
	conversationHighlightsDeepText: 'Dites-nous si vous aimeriez qu’on aille plus loin un jour. Rien d’autre ne sera analysé pour le moment.',
	conversationHighlightsDeepThanks: 'Merci, votre intérêt est enregistré',
	conversationHighlightsDeepButton: 'Oui, cela m’intéresserait',
	conversationHighlightsDeepNotice: 'Vous serez prévenu dès que ce sera prévu.',
	conversationHighlightsDeepNoticeClose: 'D’accord',
	conversationHighlightsPrintBook: 'Je veux imprimer mon livre',
	conversationHighlightsPrintNow: 'J’imprime maintenant',

	conversationImagesCount: `{count} {count, plural,
		=0 {photo}
		=1 {photo}
		other {photos}
  	}`,

	conversationImportFileNotSupportedError: 'Votre fichier n\'est pas valide en tant qu\'archive ! Veuillez sélectionner une archive valide (.zip)',
	conversationImportFileSummary: 'Votre nom est {name} et vous avez {count} conversations dans cette archive.',
	conversationImportFileTooBigError: 'Votre fichier est trop lourd ! (plus de 4Go). Veuillez nous contacter pour résoudre ce problème',
	conversationImportProviderNext: 'Transférer ma conversation',
	conversationImportTutorialGoNext: 'Voir la suite',
	conversationImportTutorialStep: 'Étape n°{step}',
	conversationImportDetailToggle: 'Voir le guide détaillé avec captures',
	conversationImportDetailCardTitle: 'Première fois ?',
	conversationImportDetailCardSubtitle: 'Guide illustré en {count} étapes, captures d\'écran incluses',
	conversationImportDetailCardAction: 'Ouvrir le guide',
	conversationImportDetailTitle: 'Guide pas à pas détaillé',
	conversationImportDetailStepOf: 'Étape {current} sur {total}',
	conversationImportDetailPrev: 'Précédent',
	conversationImportDetailNext: 'Suivant',
	conversationImportDetailClose: 'Fermer',
	conversationImportSelectionSummary: `Conversation sélectionnée: {name} (contient {count} {count, plural,
			=0 {message}
			=1 {message}
			other {messages}
		})`,
	conversationImportSelectionSummary2: 'Conversation sélectionnée: {name}',
	conversationImportSelectionText: 'Tapez le nom de votre ami...',
	conversationImportSelectionTitle: 'Sélectionnez votre conversation',
	conversationImportStepCreation: 'Création de votre livre',
	conversationImportStepExtraction: 'Analyse de votre fichier',
	conversationImportStepFinal: 'Dernières touches',
	conversationImportStepImages: 'Transfert des photos',
	conversationImportStepMedias: 'Transfert des vidéos et audio',
	conversationImportStepMessages: 'Enregistrement des messages',
	conversationImportTransferStatMessages: 'Messages',
	conversationImportTransferStatPhotos: 'Photos',
	conversationImportTransferStatMedias: 'Vidéos et audio',
	conversationImportTransferEyebrow: 'Presque terminé',
	conversationImportTransferTitle: 'Nous préparons votre livre',
	conversationImportTransferSubtitle: 'Quelques instants de patience : votre histoire prend forme.',
	conversationImportTransferStay: 'Restez sur cette page jusqu\'à la fin du transfert.',
	conversationImportResumeTitle: 'Un transfert précédent a été interrompu.',
	conversationImportResumeTextFile: 'Re-sélectionnez le même fichier ({name}) pour reprendre là où il s\'est arrêté.',
	conversationImportResumeText: 'Re-sélectionnez le même fichier pour reprendre là où il s\'est arrêté.',
	conversationImportResumeButton: 'Reprendre le transfert',
	conversationImportResumeDiscard: 'Recommencer',
	conversationImportDuplicateTitle: 'Cette conversation est déjà sur votre compte',
	conversationImportDuplicateEyebrow: 'Conversation identique',
	conversationImportDuplicateLead: 'Nous avons trouvé une conversation identique. Vous pouvez ouvrir celle déjà présente pour éviter un transfert en double.',
	conversationImportDuplicateQuestion: 'Que souhaitez-vous faire ?',
	conversationImportDuplicateUseExisting: 'Utiliser celle déjà présente',
	conversationImportDuplicateImportAnyway: 'Importer à nouveau',
	conversationImportSuccess: 'Félicitations ! <br></br>Votre conversation a bien été importée !',
	conversationImportValidationWaiting: 'Validation en cours...',
	conversationMediaAudioOpusWarning: 'Si vous ne pouvez pas lire ce fichier, utilisez un autre navigateur compatible (comme Google Chrome)',
	conversationMediasCount: `{count} {count, plural,
		=0 {média}
		=1 {média}
		other {médias}
	}`,
	conversationMerge: 'Fusionner les conversations',
	conversationMergeSelect: 'Sélectionner cette conversation',
	conversationMergeUnselect: 'Désélectionner cette conversation',
	conversationMergeInfo: 'Sélectionnez les conversations à fusionner, puis cliquer sur le bouton situé sous la liste:',
	conversationMergeRequestSuccess: 'Les conversations seront bientôt fusionnées ! Vous recevrez un e-mail lorsque la fusion sera terminée.',
	conversationMergeHintEyebrow: 'Bon à savoir',
	conversationMergeHintTitle: 'Regrouper en une seule conversation',
	conversationMergeHintSingle: 'Plusieurs fils de discussion ? Importez chaque conversation avec le +, puis fusionnez-les en une seule conversation.',
	conversationMergeHintReady: 'Vous pouvez fusionner vos conversations en une seule conversation, classée chronologiquement.',
	conversationMessages: 'Messages',
	conversationMessagesCount: `{count} {count, plural,
		=0 {message}
		=1 {message}
		other {messages}
	}`,
	conversationMessagesCount2: `{count, plural,
		=0 {message}
		=1 {message}
		other {messages}
	}`,
	conversationMessagesImagesCount: `{count} {count, plural,
		=0 {image}
		=1 {image}
		other {images}
	}`,
	conversationMessagesImagesCount2: `{count, plural,
		=0 {image}
		=1 {image}
		other {images}
	}`,
	conversationMessagesLoadingAlert: 'Récupération des messages...',
	conversationMessagesMediasCount: `{count} {count, plural,
		=0 {média}
		=1 {média}
		other {médias}
	}`,
	conversationMessagesMediasCount2: `{count, plural,
		=0 {média}
		=1 {média}
		other {médias}
	}`,
	conversationNoData: 'Vous n\'avez pas encore créé de conversation !',
	conversationOptionWithImagesHelp1: 'Actuellement, vos livres seront AVEC vos images ou photos',
	conversationOptionWithImagesHelp2: 'Actuellement, vos livres seront SANS vos images ou photos',
	conversationOptionWithImagesHelp3: 'Suivant le nombre de photos cela peut ralentir le transfert de la conversation, veuillez rester sur cette page durant le chargement, cela peut prendre jusqu\'à 10min. Si vous rencontrez malgré tout des difficultés, envoyez-nous votre archive via www.fromsmash.com à l\'adresse hello@monlivresms.com avec le nom du contact ou du groupe, on vous trouvera une solution.',
	conversationOptionWithImagesLabel: 'Inclure les images de la conversation ?',
	conversationOptionWithMediaHelp: 'Vous pourrez redécouvrir vos videos/audio/gif grâce aux QRCodes imprimés dans votre livre. Le stockage de vos données vous est offert pendant 10ans.',
	conversationOptionWithMediasLabel: 'Inclure les videos/audios/gifs de la conversation ?',
	conversationOrder: 'Commande',
	conversationOrderButton: 'Commander maintenant',
	conversationOrderButtonEbook: 'Recevoir mon PDF',
	conversationOrderButtonEbookWithPrice: 'Recevoir mon PDF · {price}',
	conversationOrderButtonWithPrice: 'Commander · {price}',
	conversationOrderButtonWithPriceVolumes: 'Commander mes {count} livres · {price}',
	conversationOrderDiscountLabel: '-{discount}% de réduction sur cette conversation en commandant {threshold} exemplaires et plus',
	conversationOrderQuantity: 'Nombre d\'exemplaires',
	conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
			=1 {livre}
			other {livres}
		} · {bookTotal} {discount, plural,
			=0 {}
			other {: {discount}% de réduction inclus}
		}`,
	conversationOrderSummary2: `Votre commande comporte {bookCount} {bookCount, plural,
				=0 {livre}
				=1 {livre}
				other {livres}
			} & {pdfCount} {pdfCount, plural,
				=0 {eBook}
				=1 {eBook}
				other {eBooks}
			} {freeCount, plural,
				=0 {}
				=1 {+1 eBook gratuit}
				other {+{freeCount} eBooks gratuits}
			} pour {pdfTotal}`,
	conversationOrderSummaryBestof: '1 livre Best Of · {bestofTotal}',
	conversationOrderSummaryPdf: '1 eBook intégral · {pdfTotal}',
	conversationParticipantColorHelp: 'Cliquez ici pour changer la couleur de la bulle',
	conversationParticipantColorBlushClair: 'Blush clair',
	conversationParticipantColorCielClair: 'Ciel clair',
	conversationParticipantColorLavandeClaire: 'Lavande claire',
	conversationParticipantColorPruneClaire: 'Prune claire',
	conversationParticipantColorPecheClaire: 'Pêche claire',
	conversationParticipantColorSaugeClair: 'Sauge clair',
	conversationParticipantColorMiel: 'Miel',
	conversationParticipantColorPerle: 'Perle',
	conversationParticipantNameHelp: 'Cliquez ici pour modifier le nom du participant',
	conversationParticipantNameError: 'Le prénom est trop long (max. {max} caractères)',
	conversationParticipantPositionHelp: 'Cliquez pour modifier la position du participant (à droite ou à gauche)',
	conversationParticipantPositionLeft: 'Gauche',
	conversationParticipantPositionRight: 'Droite',
	conversationParticipants: 'Participants',
	conversationOrders: 'Commandes',
	conversationPrinterMode: 'Mode imprimeur',
	conversationParticipantsLuxEyebrow: 'Votre conversation',
	conversationParticipantsLuxHint: 'Modifiez les prénoms, les couleurs des bulles et la position gauche/droite de chaque participant.',
	conversationParticipantsLuxSavePreview: 'Enregistrer · retour à l’aperçu',
	conversationParticipantsLuxSaved: 'Enregistré',
	conversationParticipantsSameSideHint: 'Plusieurs participants sont du même côté. Vérifiez la position gauche/droite.',
	conversationParticipantsEditTitle: 'Édition des participants',
	conversationPauseButton: 'Mettre en pause ma commande',
	conversationPauseConfirmText: 'La génération de vos livres sera mise en pause. Vous pourrez la reprendre à tout moment.',
	conversationPreviewBookNumber: `{index}{index, plural,
			  =0 {}
			  =1 {er}
			  =2 {nd}
			  other {ème}
		  } livre`,
	conversationPreviewBestofHelpButton: 'Comment fonctionne la sélection ?',
	conversationPreviewBestofHelpText: 'Notre formule analyse chaque moment de votre conversation : la densité des échanges, la qualité du dialogue (un vrai aller-retour ou un monologue ?), la richesse du contenu (photos, texte, émojis). Les premiers et derniers messages sont toujours préservés. Seuls les moments qui ont vraiment compté entrent dans le livre. Vos messages restent privés : notre formule n\'analyse jamais leur contenu, uniquement la structure de vos échanges.',
	conversationPreviewBookSelection: 'Sélection des livres',
	conversationPreviewBooksSelectAllBooks: 'Sélectionner tous les livres papiers',
	conversationPreviewBooksSelectAllEBooks: 'Sélectionner tous les ebooks',
	conversationPreviewBooksUnselectAll: 'Tout désélectionner',
	conversationPreviewBrowserWarning: 'Votre navigateur peut ralentir l\'affichage. Pour une expérience optimale, nous recommandons Google Chrome.',
	conversationPreviewFormatSelection: 'Sélection du format',
	conversationPreviewPagesDivideEquallyLabel: 'Scinder équitablement les pages entre les livres ?',
	conversationPreviewPagesSetMaxBookPagesLabel: 'Souhaitez-vous des livres de {max} pages de préférence ?',
	conversationPreviewTitle: 'Votre histoire, en livre.',
	conversationPreviewSubtitle: 'Personnalisez couverture, prénoms, dates et messages avant de choisir votre édition.',
	conversationPreviewHeroTitle: 'Vos mots, reliés pour toujours.',
	conversationPreviewBookCaption: 'Tournez les pages pour découvrir votre livre.',
	conversationPreviewCustomizeEyebrow: 'À votre image',
	conversationPreviewEditionEyebrow: 'Votre édition',
	conversationPreviewPricePerVolume: '{price}/tome',
	conversationPreviewCollectionPriceNote: '{count} tomes · {price}/tome',
	conversationPreviewCollectionUntilLabel: 'Quels tomes',
	conversationPreviewCollectionUntilAll: 'Du premier au dernier tome',
	conversationPreviewCollectionUntilOpen: 'Choisir',
	conversationPreviewCollectionUntilClose: 'Fermer',
	conversationPreviewCollectionUntilPartial: '{count, plural, one {Le premier tome} other {Les {count} premiers tomes}}',
	conversationPreviewCollectionUntilSuffix: '{count, plural, one {Le dernier tome} other {Les {count} derniers tomes}}',
	conversationPreviewCollectionUntilSingle: 'Le tome {number}',
	conversationPreviewCollectionUntilWindow: 'Du tome {from} au tome {to}',
	conversationPreviewCollectionUntilPeriod: 'Du {start} au {end}',
	conversationPreviewCollectionUntilHint: 'Les autres tomes restent dans la conversation, pour une prochaine commande.',
	conversationPreviewCollectionUntilAriaStart: 'Premier tome à imprimer',
	conversationPreviewCollectionUntilAriaEnd: 'Dernier tome à imprimer',
	conversationPreviewTypeBookTaglinePartial: '{count, plural, one {Le premier tome de votre conversation.} other {Les {count} premiers tomes de votre conversation.}}',
	conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {Le dernier tome de votre conversation.} other {Les {count} derniers tomes de votre conversation.}}',
	conversationPreviewTypeBookTaglineWindowSingle: 'Le tome {number} de votre conversation.',
	conversationPreviewTypeBookTaglineWindow: 'Les tomes {from} à {to} de votre conversation.',
	conversationPreviewStickyCollectionVolumes: 'Collection · {count} tomes',
	conversationPreviewSocialProofCount: '{count}+ avis',
	conversationPreviewSocialProofAria: 'Noté {rating} sur 5 sur Trustpilot, sur plus de {count} avis',
	conversationPreviewCustomizeTitle: 'Personnaliser mon livre',
	conversationPreviewCustomizeDone: 'Terminer la personnalisation',
	conversationPreviewCustomizeClose: 'Fermer la personnalisation',
	conversationPreviewEditionScrollLabel: 'Aller à la section édition',
	conversationPreviewEditionBelowHint: 'Choisissez votre édition plus bas',
	conversationPreviewCustomizeHint: 'Touchez une carte pour modifier.',
	conversationPreviewCardsHintTitle: 'Prénoms, dates, messages',
	conversationPreviewCardsHintText: 'Ici vous changez les prénoms, la période et les messages.',
	conversationPreviewCustomizeTopics: 'Couverture · prénoms · dates · messages',
	conversationPreviewEditionTitle: 'Choisir votre édition',
	conversationPreviewEditionHint: 'Comparez les options et choisissez celle qui vous convient.',
	conversationPreviewPausedEyebrow: 'Commande en pause',
	conversationPreviewPausedTitle: 'Vos modifications sont prêtes ?',
	conversationPreviewPausedHint: 'Votre commande est en pause. Modifiez votre livre puis validez pour relancer la fabrication.',
	conversationPreviewPausedScrollHint: 'Valider mes modifications',
	conversationPreviewMissingMediasBanner: 'Certains médias (photos, fichiers) de votre conversation sont manquants ou n\'ont pas pu être récupérés. Vérifiez vos messages avant de valider.',
	conversationPreviewMissingMediasCta: 'Compléter les médias',
	bookMissingPhotoLabel: 'Photo indisponible',
	conversationMissingMediasBadge: 'Médias manquants',
	conversationMissingMediasCta: 'Compléter les médias',
	conversationResumeWithoutMediasButton: 'Continuer sans ces photos',
	conversationResumeMissingMediasConfirmText: 'Certaines photos sont encore manquantes. Votre livre partira en fabrication sans elles. Préférez compléter les médias si vous le pouvez.',
	orderMissingMediasAlert: 'Des photos manquent dans une conversation de cette commande. Complétez-les pour que la fabrication puisse reprendre.',
	missingMediasRecoveryTitle: 'Médias manquants ({count})',
	missingMediasRecoveryIntro: '{count, plural, one {# photo est manquante} other {# photos sont manquantes}} dans votre livre. Vous pouvez redéposer vos fichiers ou traiter chaque média ci-dessous.',
	missingMediasRecoveryFirstDate: 'Premier média manquant : {date}.',
	missingMediasRecoveryArchiveTitle: 'Compléter via un nouvel export',
	missingMediasRecoveryRecommended: 'Recommandé',
	missingMediasRecoveryArchiveHelp: 'Déposez à nouveau l\'export {provider} (zip). Seules les photos manquantes seront ajoutées : vos messages et modifications restent inchangés.',
	missingMediasRecoveryArchiveCta: 'Déposer le fichier d\'export',
	missingMediasRecoveryArchiveWorking: 'Recherche des photos manquantes dans votre fichier…',
	missingMediasRecoveryArchiveError: 'Impossible de lire ce fichier. Vérifiez qu\'il s\'agit bien de l\'export de votre messagerie.',
	missingMediasRecoveryNoMatch: 'Aucun fichier correspondant aux médias manquants n\'a été trouvé.',
	missingMediasRecoveryListTitle: 'Traiter média par média',
	missingMediasRecoveryRescan: 'Revérifier',
	missingMediasRecoveryEmpty: 'Aucun média manquant détecté pour le moment.',
	missingMediasRecoveryAddPhoto: 'Ajouter une photo',
	missingMediasRecoveryIgnore: 'Ignorer',
	missingMediasRecoveryContact: 'Nous écrire',
	missingMediasRecoveryResolved: 'Tous les médias manquants ont été traités. Votre livre repart en fabrication.',
	missingMediasRecoverySuccessEyebrow: 'Tout est bon',
	missingMediasRecoverySuccessTitle: 'Bravo, vos photos sont complètes',
	missingMediasRecoverySuccessText: 'Tous les médias manquants ont été traités. Votre livre repart en fabrication.',
	missingMediasRecoverySuccessCta: 'Retour à mon aperçu',
	conversationMissingMediasFixedSuccess: 'Bravo : tous les médias manquants sont complétés. Votre livre repart en fabrication.',
	conversationMissingMediasFixedHint: 'Plus rien à faire de votre côté : la fabrication reprend automatiquement.',
	missingMediasRecoveryError: 'Une erreur est survenue. Réessayez ou contactez-nous.',
	missingMediasRecoverySmsTitle: 'Transfert SMS / iPhone',
	missingMediasRecoverySmsStepIcloud: 'Sur iPhone : ouvrez la conversation dans Messages, touchez le contact, faites défiler puis téléchargez les photos iCloud.',
	missingMediasRecoverySmsStepBackup: 'Faites une nouvelle sauvegarde locale non chiffrée (Mac/PC), puis relancez notre logiciel pour renvoyer les médias de cette conversation.',
	missingMediasRecoverySmsStepAndroid: 'Sur Android : rouvrez l\'application MonLivreSMS et renvoyez la conversation (les photos déjà présentes ne seront pas écrasées inutilement).',
	conversationPreviewEditionMetaLabel: 'Détails de l\'édition',
	conversationPreviewBestofLearnMore: 'Comprendre la sélection Best-Of',
	conversationPreviewBestofHint: 'Aperçu Best Of illustratif : la sélection de vos meilleurs messages se fait après commande, lors de la génération du PDF.',
	conversationPreviewBestofHintDismiss: 'Fermer',
	conversationPreviewBestofHintLearnMore: 'En savoir plus',
	conversationPreviewBestofPriceNote: 'Sélection après commande',
	conversationPreviewTypeBestofTaglineCompare: 'Alternative plus légère : vos meilleurs moments en 1 volume.',
	conversationPreviewMetaEbook: 'eBook offert',
	conversationPreviewMetaVolume: '{count} tome',
	conversationPreviewMetaVolumes: '{count} tomes',
	conversationPreviewMetaPages: '{pages} pages',
	conversationPreviewMetaMessages: '{count} messages',
	conversationPreviewMetaBestofPages: '~400 pages',
	conversationPreviewMetaBestofSelection: 'Sélection intelligente',
	conversationPreviewMetaPdfInstant: 'PDF immédiat',
	conversationPreviewMetaPdfCredit: 'Crédit pour le livre',
	conversationPreviewPdfPriceNote: 'Déduit si vous passez au livre',
	conversationPreviewPdfLearnMore: 'Comment ça marche ?',
	conversationPreviewPdfHelpText: 'Vous payez {ebookPrice} et recevez votre PDF. Si plus tard vous commandez le livre imprimé à {bookPrice}, ces {ebookPrice} sont déduits : il reste {remainingPrice}. Le crédit reste sur votre compte.',
	conversationPreviewReassurancePdfCredit: 'Ces {price} seront déduits si vous passez au livre',
	conversationPreviewStickyPdfCredit: 'Crédit de {price} si vous passez au livre',
	conversationPreviewEbookCreditBanner: 'Vous avez {amount} de crédit sur cette conversation. Ils seront déduits automatiquement si vous commandez le livre imprimé.',
	conversationPreviewEbookCreditOrderHint: '{credit} de crédit déduits · prix catalogue {fullPrice}',
	conversationPreviewStickyEbookCredit: '{credit} de crédit appliqués',
	paymentMethodEbookCreditHint: 'Crédit ebook sur le livre imprimé',
	cartTotalsEbookCredit: 'Crédit ebook',
	cartTotalsCredit: 'Crédit',
	conversationPreviewTypeBookTaglineSingle: 'Votre histoire complète, page après page.',
	conversationPreviewTypeBookTaglineMulti: 'Votre conversation entière en {count} livres imprimés',
	conversationPreviewHeroHeading: 'Aperçu de votre livre',
	conversationPreviewHelpTourButton: 'Afficher l\'aide de la page',
	conversationPreviewCardLabelCover: 'Couverture',
	conversationPreviewCardLabelParticipants: 'Participants',
	conversationPreviewCardLabelDates: 'Dates',
	conversationPreviewCardLabelMessages: 'Messages',
	conversationPreviewZoneDone: 'Déjà exploré',
	conversationPreviewZoneHintCover: 'Couleur, photo, titre, préface',
	conversationPreviewZoneHintParticipants: 'Prénoms et couleurs des bulles',
	conversationPreviewZoneHintDates: 'Période couverte par le livre',
	conversationPreviewZoneHintMessages: 'Masquer ou corriger des messages',
	conversationHelpPreviewCustomizeTitle: 'Prénoms, dates et messages',
	conversationHelpPreviewCustomizeText: 'Touchez une carte pour modifier les prénoms, les dates ou les messages.',
	conversationBookNavPrev: 'Page précédente',
	conversationBookNavNext: 'Page suivante',
	conversationBookBackToCover: 'Revenir à la couverture',
	conversationPreviewTypeBookPagesHint: ' · {pages} pages',
	conversationPreviewTypeBookMessagesHint: ' · {count} messages',
	conversationOrderTotal: 'Total',
	conversationPreviewTypeBestofDescription: '400 pages, vos meilleurs échanges. eBook offert.',
	conversationPreviewTypeBestofTitle: 'Best Of',
	conversationPreviewTypeBookDescription: '{count} tome · Histoire complète. eBook offert.',
	conversationPreviewTypeBookDescriptionWithPrice: '{count} tomes · {unitBreakdown} · Intégrale. eBook offert.',
	conversationPreviewReassuranceShipping: 'Livraison offerte dans le monde',
	conversationPreviewExpressDeliveryLead: 'Livraison express {where} dès le',
	conversationPreviewExpressDeliveryDate: '{date}',
	conversationPreviewTypeBookTitle: 'Collection complète',
	conversationPreviewTypeHighlight: 'Recommandé',
	conversationPreviewTypePdfDescription: 'Gardez votre conversation en PDF. Ce montant compte pour le livre, si vous le voulez plus tard.',
	conversationPreviewTypePdfTitle: 'Numérique',
	conversationPreviewTypeSelectionTitle: 'Choisissez votre format',
	conversationProgress: 'Avancement',
	conversationProviderButton: 'Accéder aux paramètres',
	conversationProviderType: 'Type',
	conversationRemoveButton: 'Supprimer la conversation',
	conversationRemoveConfirmText: 'En supprimant votre conversation, vos médias seront supprimés et ne pourront plus être récupérés !',
	conversationRemoveConfirmTitle: 'Supprimer la conversation',
	conversationRemoveFlagConfirmMessage: 'Voulez-vous retirer ce drapeau de la conversation ?',
	conversationRemoveSuccess: 'Conversation supprimée !',
	conversationRestartProcess: 'Redémarrer',
	conversationResumeButton: 'Valider et imprimer',
	conversationResumeConfirmText: 'Votre conversation sera marquée comme "vérifiée" et sera prochaînement générée et lancée en impression.',
	conversationValidateModificationsButton: 'Valider mes modifications',
	conversationValidateModificationsConfirmTitle: 'Valider mes modifications ?',
	conversationValidateModificationsConfirmBook: 'Votre livre va repartir en fabrication avec vos modifications.',
	conversationValidateModificationsConfirmEbook: 'Votre e-book va être régénéré avec vos modifications et vous sera renvoyé par email.',
	conversationValidateModificationsConfirmMissingMedias: 'Certains médias de votre conversation sont manquants. Vérifiez-les avant de valider : votre livre partira en fabrication avec vos modifications actuelles.',
	conversationValidateModificationsSuccessBook: 'Vos modifications ont été prises en compte. Votre livre repart en fabrication.',
	conversationValidateModificationsSuccessEbook: 'Vos modifications ont été prises en compte. Votre e-book régénéré vous sera renvoyé par email.',
	conversationValidateModificationsBackToList: 'Retour à mes conversations',
	conversationSelectThread: 'Sélectionner une discussion',
	conversationShareCancelButton: 'Pas maintenant',
	conversationShareConfirmButton: 'Révéler mes records',
	conversationShareConfirmTitle: 'Regardez ce qu\'on a trouvé...',
	conversationShareConfirmText: 'Votre conversation cache des records incroyables. Nous les avons mis en images juste pour vous, prêts à être partagés.',
	conversationStatusConfigured: 'En attente de génération',
	conversationStatusDone: 'Terminé',
	conversationStatusOngeneration: 'En cours de génération',
	conversationStatusOnproduction: 'En production',
	conversationStatusOnvalidation: 'En attente d\'impression',
	conversationStatusPending: 'En attente',
	conversationTypeAndroidDownloadAlt: 'Ou copier/coller le lien dans votre navigateur préféré',
	conversationTypeAndroidDownloadButton: 'Téléchargez l\'application',
	conversationTypeAndroidIntroText1: 'Pour imprimer votre Livre Sms avec un téléphone Android, il est nécessaire d\'utiliser votre smartphone (samsung, HTC, huawei, par exemple).',
	conversationTypeAndroidIntroText2: 'Installez sur votre téléphone mobile Android l\'application Mon Livre SMS en cliquant sur le lien suivant : (application non disponible sur le GooglePlay)',
	conversationTypeAndroidIntroText3: 'Choisissez le co-auteur de votre livre sms souvenir, ainsi que les dates de début et de fin de votre récit.',
	conversationTypeAndroidIntroText4: 'Choisissez les noms des héros de votre histoire, écrivez son résumé et personnalisez votre couverture',
	conversationTypeAndroidIntroText5: 'Pour terminer votre livre sms, créez un compte et finalisez votre achat grâce à notre serveur de paiement sécurisé !',
	conversationTypeInstagramFileText1: 'Instagram va vous envoyer un mail pour télécharger l\'archive',
	conversationTypeInstagramFileText2: 'Téléchargez-la sur votre appareil',
	conversationTypeInstagramFileText3: 'Cliquez sur le bouton ci-dessous, puis sélectionnez l\'archive dans vos fichiers sans l’ouvrir en la laissant en .zip exemple de nom : *votrenom*_*datedujour*.zip (seule la conversation sélectionnée sera envoyée vers nos services d\'impression)',
	conversationTypeInstagramProviderText1: 'Récupérez une copie de vos données Instagram en accédant aux paramètres généraux de votre compte',
	conversationTypeInstagramProviderText2: 'Entrez votre adresse email associée à votre compte Instagram et choisir le format JSON',
	conversationTypeInstagramProviderText3: 'Puis renseignez votre mot de passe, et cliquez sur <strong>Demander un téléchargement</strong> pour déclencher la génération de votre sauvegarde sur Instagram.',
	conversationTypeIosIntroText1: 'Branchez votre iPhone à votre ORDINATEUR et réalisez une sauvegarde iTunes non chiffrée (non cryptée). (cochez "Cet ordinateur", DÉCOCHEZ "Chiffrer la sauvegarde de l\'iPhone" et cliquez sur "Sauvegarder maintenant")',
	conversationTypeIosIntroText2: 'Téléchargez le logiciel Mon Livre SMS en cliquant sur le lien correspondant au système d\'exploitation de votre ordinateur :',
	conversationTypeIosIntroText3: '<strong>ATTENTION, si le logiciel ne détecte pas de sauvegarde:</strong><br></br> - Pour MAC :<br></br>allez dans préférence système > sécurité et confidentialité > accès complet au disque et rajouter l’application MonLivreSMS en déverrouillant le cadenas en bas à gauche.<br></br> - Pour PC : <br></br>Pour votre sécurité Apple, empêche la lecture de votre sauvegarde sans votre autorisation.',
	conversationTypeMessengerFileText1: 'Facebook va vous envoyer un mail pour télécharger l\'archive',
	conversationTypeMessengerFileText2: 'Téléchargez-la sur votre appareil',
	conversationTypeMessengerFileText3: 'Cliquez sur le bouton ci-dessous, puis sélectionnez l\'archive dans vos fichiers en la laissant en .zip exemple : facebook-*votrenom*.zip (seule la conversation sélectionnée sera envoyée vers nos services d\'impression)',
	conversationTypeMessengerProviderText1: 'Récupérez une copie de vos données Facebook en accédant aux paramètres généraux de votre compte',
	conversationTypeMessengerProviderText2: 'Cliquez sur Télécharger vos informations',
	conversationTypeMessengerProviderText3: `Puis, définissez les options suivantes:<br></br>
			  <strong>Période</strong> : (celle de votre choix)<br></br>
			  <strong>Format</strong> : JSON<br></br>
			  <strong>Qualité des photos</strong> : Faible (cela est suffisant et moins long lors des transferts)<br></br>
			  <strong>Vos informations</strong> : Messages (déselectionnez les autres)`,
	'conversationTypeMessengerProviderText4': 'Attention: Veuillez bien sélectionner le format de données en JSON (non HTML) !',
	'conversationTypeSnapchatProviderText1.1': 'Ouvrez l\'application Snapchat sur votre appareil.',
	'conversationTypeSnapchatProviderText1.2': 'Cliquez sur votre avatar (ou Bitmoji) en haut à gauche de l\'écran pour accéder à votre profil.',
	'conversationTypeSnapchatProviderText1.3': 'Cliquez sur l\'icône en forme de roue dentée en haut à droite pour ouvrir les paramètres.',
	'conversationTypeSnapchatProviderText2.1': 'Faites défiler vers le bas jusqu\'à la section "Confidentialité".',
	'conversationTypeSnapchatProviderText2.2': 'Sélectionnez "Mes Données".',
	'conversationTypeSnapchatProviderText3.1': 'Il est possible qu\'on vous demande de vous connecter pour vérifier votre identité.',
	'conversationTypeSnapchatProviderText4.1': 'Sur la page "Mes Données", vous trouverez une liste de données que vous pouvez télécharger, y compris vos messages.',
	'conversationTypeSnapchatProviderText4.2': 'Cliquez sur "Envoyer une Demande" en bas de la page.',
	'conversationTypeSnapchatProviderText5.1': 'Une fois votre demande envoyée, Snapchat traitera votre demande de téléchargement de données.',
	'conversationTypeSnapchatProviderText5.2': 'Cela peut prendre un certain temps, généralement quelques heures à un jour.',
	'conversationTypeSnapchatProviderText5.3': 'Vous recevrez un e-mail de Snapchat avec un lien pour télécharger vos données lorsque votre archive sera prête.',
	'conversationTypeSnapchatProviderText6.1': 'Cliquez sur le lien dans l\'e-mail pour accéder à la page de téléchargement.',
	'conversationTypeSnapchatProviderText6.2': 'Téléchargez le fichier ZIP contenant vos données.',
	'conversationTypeSnapchatProviderText7.1': 'Une fois le fichier ZIP téléchargé, ne l\'ouvrez pas.',
	'conversationTypeSnapchatProviderText7.2': 'Déposez le fichier ZIP complet, tel quel, dans la section désignée.',
	'conversationTypeSnapchatProviderText7.3': 'Vous pourrez choisir la conversation de votre choix pour créer votre livre.',
	conversationTypeSnapchatProviderTitle1: '1. Accédez aux Paramètres de Snapchat :',
	conversationTypeSnapchatProviderTitle2: '2. Demande de Données :',
	conversationTypeSnapchatProviderTitle3: '3. Authentification :',
	conversationTypeSnapchatProviderTitle4: '4. Téléchargement de vos Données :',
	conversationTypeSnapchatProviderTitle5: '5. En Attente de l\'E-mail :',
	conversationTypeSnapchatProviderTitle6: '6. Téléchargement de l\'Archive :',
	conversationTypeSnapchatProviderTitle7: '7. Extraction et Utilisation des Données pour MonLivreSMS :',
	'conversationTypeTelegramProviderText1.1': 'Installez l\'application Telegram pour ordinateur sur votre PC ou Mac depuis https://desktop.telegram.org/.',
	'conversationTypeTelegramProviderText1.2': 'Ouvrez l\'application Telegram sur votre ordinateur.',
	'conversationTypeTelegramProviderText2.1': 'Dans l\'application, ouvrez la conversation que vous souhaitez transformer en livre en cliquant sur le nom de votre partenaire de chat.',
	'conversationTypeTelegramProviderText3.1': 'Cliquez sur les trois points dans le coin supérieur droit de la conversation.',
	'conversationTypeTelegramProviderText3.2': 'Choisissez « Exporter l\'historique du chat ».',
	'conversationTypeTelegramProviderText4.1': 'Dans la fenêtre des paramètres, sélectionnez tous les types de fichiers souhaités (images, vidéos, messages vocaux, etc.).',
	'conversationTypeTelegramProviderText4.2': 'Ajustez la taille maximale du fichier pour l\'exportation, si nécessaire.',
	'conversationTypeTelegramProviderText4.3': 'Cliquez sur « Exporter » en bas de la fenêtre.',
	'conversationTypeTelegramProviderText5.1': 'Localisez les données exportées et compressez-les en un fichier ZIP (clic droit > Envoyer vers > Dossier compressé (zippé)).',
	'conversationTypeTelegramProviderText6.1': 'Téléchargez le fichier ZIP complet',
	conversationTypeTelegramProviderTitle1: '1. Installation de l\'Application Telegram pour Ordinateur :',
	conversationTypeTelegramProviderTitle2: '2. Sélection de la Conversation :',
	conversationTypeTelegramProviderTitle3: '3. Exportation de l\'Histoire de la Conversation :',
	conversationTypeTelegramProviderTitle4: '4. Paramètres d\'Exportation de la Conversation :',
	conversationTypeTelegramProviderTitle5: '5. Compression en Fichier ZIP :',
	conversationTypeTelegramProviderTitle6: '6. Téléchargement sur MonLivreSMS :',
	conversationTypeTitle: 'Créer un livre à partir de {name}',
	conversationTypeWhatsappFileText1: 'Récupérer votre conversation WhatsApp',
	conversationTypeWhatsappFileText2: 'Choisir "Joindre un fichier"',
	conversationTypeWhatsappFileText3: 'Télécharger la conversation',
	conversationTypeWhatsappFileText4: 'Si celle-ci n\'est pas au format "zip" compressez la',
	conversationTypeWhatsappFileText5: 'Si vous ne souhaitez que le contenu texte de votre conversation déposez seulement le fichier .txt',
	conversationTypeWhatsappProviderText1: 'Exporter une copie de votre conversation WhatsApp',
	conversationTypeWhatsappProviderText2: '<strong>Depuis un Android:</strong><br></br>Ouvrir l\'application WhatsApp<br></br>Aller sur votre fil de discussion<br></br>Cliquer sur "Options"',
	conversationTypeWhatsappProviderText3: '<strong>Depuis iOs:</strong><br></br>Ouvrir l\'application WhatsApp<br></br>Aller sur votre fil de discussion<br></br>Toucher le nom du contact ou le sujet du groupe dans la barre menu<br></br>Faites défiler jusqu\'en bas et sélectionnez "Exporter discussion"',
	conversations: 'Conversations',
	conversationsMy: 'Mes conversations',
	conversationBackToList: 'Retour à mes conversations',
	conversationsLuxEyebrow: 'Vos histoires',
	conversationsLuxHint: 'Retrouvez vos conversations et transformez-les en un beau livre.',
	ordersLuxEyebrow: 'Votre atelier',
	ordersLuxHint: 'Retrouvez vos livres et suivez leur voyage, de l\'atelier jusqu\'à chez vous.',
	ordersLuxDetailTitle: 'Votre livre',
	ordersLuxDetailHint: 'Suivez votre livre, de l\'atelier jusqu\'à votre porte.',
	ordersLuxViewFollow: 'Suivre mon livre',
	ordersLuxEmptyTitle: 'Votre première histoire n\'attend plus que vous.',
	ordersLuxEmptyHint: 'Transformez une conversation en un livre que vous aurez envie d\'ouvrir encore et encore.',
	ordersLuxStepReceived: 'Reçue',
	ordersLuxStepAtelier: 'Atelier',
	ordersLuxStepPrint: 'Impression',
	ordersLuxStepShipped: 'En route',
	ordersLuxStepHome: 'Chez vous',
	ordersLuxStoryPendingpayment: 'Votre commande n\'attend plus que le règlement pour entrer en atelier.',
	ordersLuxStoryPending: 'Nous avons bien reçu votre commande. L\'atelier s\'en occupe déjà.',
	ordersLuxStoryOnpreparation: 'Votre livre prend forme. Chaque page est préparée avec soin.',
	ordersLuxStoryOnfabrication: 'Votre livre s\'imprime. Bientôt, il quittera l\'atelier.',
	ordersLuxStoryShipped: 'Votre livre est en route. Il voyage jusqu\'à chez vous.',
	ordersLuxStoryComplete: 'Votre livre est arrivé. Il n\'attend plus que vos mains.',
	ordersLuxStoryCanceled: 'Cette commande a été annulée. Vos souvenirs restent précieusement chez nous.',
	userProfileLuxEyebrow: 'Votre espace',
	userProfileLuxHint: 'Retrouvez vos informations, vos connexions et vos préférences.',
	userProfileValueEmpty: 'Non renseigné',
	userProfileNotLinked: 'Non lié',
	userProfileNewsletterOn: 'Vous recevez déjà nos actualités et nos offres.',
	userProfilePasswordOn: 'Défini',
	addressesLuxEyebrow: 'Votre espace',
	addressesLuxHint: 'Retrouvez vos adresses de livraison et de facturation.',
	addressesLuxEditHint: 'Cette adresse pourra servir à la livraison ou à la facturation.',
	conversationsNewApp: 'Nouvelles conversations sur l\'application',
	conversationsOldApp: 'Anciennes conversations sur l\'application',
	dashboardTitle: 'Tableau de bord',
	date: 'Date',
	dateActivated: 'Date d\'activation',
	dateCreated: 'Date de création',
	dateLastCguAccept: 'Date de dernière validation des CGU',
	dateLastEdit: 'Date de dernière modification',
	dateLastLogin: 'Date de dernière connexion',
	dateSelect: 'Sélectionner une date',
	dateSelectPlaceholder: 'Cliquez ici pour sélectionner une date...',
	dateStatus: 'Date de statut',
	dateValidation: 'Date de validation',
	dates: 'Dates',
	days: 'Jour(s)',
	daysCount: `{count} {count, plural,
		=0 {jour}
		=1 {jour}
		other {jours}
	}`,
	delete: 'Supprimer',
	deleteRequestError: 'Erreur de suppression !',
	deleteRequestSuccess: 'Supprimé !',
	description: 'Description',
	detailsInformation: 'Détails',
	domain: 'Domaine',
	download: 'Télécharger',
	edit: 'Modifier',
	editViewAdvanced: 'Édition avancée',
	editViewSimplified: 'Édition simplifiée',
	elementNoItems: 'Aucun élément',
	elementsCount: `{count} {count, plural,
			  =0 {élément}
			  =1 {élément}
			  other {éléments}
		  }`,
	example: 'Exemple',
	examples: 'Exemples',
	file: 'Fichier',
	fileDeleteError: 'Impossible de supprimer ce fichier',
	fileDeleteSuccess: 'Fichier supprimé !',
	fileSelected: 'Fichier sélectionné: {file}',
	fileSwitch: 'Changer de fichier',
	fileUploadError: 'Impossible de charger ce fichier !',
	fileUploadProcessStartOnSave: 'Le chargement du fichier démarrera à la sauvegarde.',
	fileUploadRestrictionTypeError: 'Format de fichier non accepté ! Autorisé: {types}',
	fileUploadSuccess: 'Fichier uploadé !',
	files: 'Fichiers',
	filtersTitle: 'Filtres',
	finish: 'Terminer',
	flags: 'Drapeaux',
	free: 'Gratuit',
	generalInformation: 'Informations générales',
	help: 'Aide',
	hours: 'Heures',
	hoursCount: `{count} {count, plural,
		=0 {heure}
		=1 {heure}
		other {heures}
	}`,
	imageDeleteError: 'Impossible de supprimer cette image !',
	imageDeleteSuccess: 'Image supprimée !',
	imageUploadError: 'Impossible de charger cette image',
	imageUploadRestrictionSize: 'L\'image doit avoir un format de {format} maximum',
	imageUploadRestrictionType: 'L\'image doit être en {types}',
	imageUploadRestrictionTypeError: 'Format d\'image non accepté ! Autorisé: {types}',
	import: 'Importer',
	importModelDownloadButton: 'Téléchargez le modèle',
	importRequestError: 'Une erreur est apparue lors de l\'importation !',
	importRequestSomeFailAlert: 'Une ou plusieurs entrées n\'ont pu être importées !',
	importRequestSuccess: 'Données importées !',
	identifier: 'Identifiant',
	importerFileButton: 'Importer les données',
	importerFileHelp: 'Vous pouvez générer un fichier CSV à l\'aide de votre logiciel d\'édition de tableur (Excel, OpenOffice, ...)',
	importerFileInfo: 'Sélectionner un fichier CSV (Valeurs séparées par des virgules)',
	importerNoItemsAlert: 'Aucun élément à importer',
	importerTitle: 'Import de données',
	information: 'Information',
	informationsDetails: 'Détails',
	informationsGeneral: 'Informations générales',
	invoicePrint: 'Imprimer la facture',
	invoicesPrint: 'Imprimer les factures',
	isActive: 'Actif ?',
	isPublic: 'Est public ?',
	isUnlimited: 'Illimité ?',
	label: 'Intitulé',
	language: 'Langue',
	languageAR: 'Arabe',
	languageBN: 'Bengali',
	languageDE: 'Allemand',
	languageEN: 'Anglais',
	languageES: 'Espagnol',
	languageFR: 'Français',
	languageHI: 'Hindi',
	languageIT: 'Italien',
	languageJA: 'Japonais',
	languagePT: 'Portugais',
	languageRU: 'Russe',
	languageZH: 'Chinois',
	learnMoreButton: 'En savoir plus',
	limitLabel: 'Type de limite',
	limitTextForm1: 'doit avoir une',
	listTitle: 'Liste',
	loading: 'Chargement...',
	loadMore: 'Charger plus…',
	copiedToClipboard: 'Copié !',
	logo: 'Logo',
	minutes: 'Minute(s)',
	name: 'Nom',
	next: 'Suivant',
	no: 'Non',
	of: 'de',
	options: 'Options',
	order: 'Commande',
	orderAdd: 'Ajouter une commande',
	orderAddTitle: 'Ajouter une commande',
	orderAddressPrivacyInfo: ' Votre adresse ne sera pas publique ! Seuls les autres participants à cette commande peuvent afficher cette adresse.',
	orderAddressShippingValid: 'Valider l\'adresse de livraison',
	orderBilling: 'Facturation',
	orderConfirmationPaymentError: 'Une erreur s\'est produite.... Merci de nous contacter !',
	orderConfirmationPaymentWaiting: 'Veuillez patienter... Nous finalisons votre paiement pour valider votre commande',
	orderConfirmationPaymentWaitingHint: 'Cela ne prend généralement que quelques secondes.',
	orderConfirmationPendingText: 'Votre commande est en attente de paiement pour être complète ! Veuillez cliquer sur le lien ci-dessous pour finaliser votre commande en validant le paiement.',
	orderConfirmationPendingText2: 'ATTENTION : Si vous payez par carte bancaire, un délai de validation du paiement peut être nécessaire, veuillez patienter quelques instants pour les vérifications.',
	orderConfirmationPendingTitle: 'Commande en attente de paiement !',
	orderConfirmationOrderNumber: 'Commande n° {code}',
	orderConfirmationNextStepsTitle: 'Et ensuite ?',
	orderConfirmationStepEmail: 'Confirmation par email',
	orderConfirmationStepEmailDesc: 'Un récapitulatif vous a été envoyé à {email}',
	orderConfirmationStepEmailDescNoEmail: 'Un récapitulatif vous sera envoyé par email',
	orderConfirmationStepPreparation: 'Préparation de votre livre',
	orderConfirmationStepPreparationDesc: 'Nous imprimons et assemblons votre ouvrage avec soin',
	orderConfirmationStepShipping: 'Expédition',
	orderConfirmationStepShippingDesc: 'Vous recevrez un email dès l\'envoi de votre colis',
	orderConfirmationSummaryTitle: 'Votre commande',
	orderConfirmationViewOrderCta: 'Suivre ma commande',
	orderConfirmationHomeCta: 'Retour à l\'accueil',
	orderConfirmationGuestTitle: 'Restez informé',
	orderConfirmationSocialText: 'Suivez-nous sur votre réseau social préféré pour rester informé des dernières nouveautés, des nouveaux produits et même de quelques réductions...',
	orderConfirmationSocialTitle: 'Restez en contact !',
	orderConfirmationText: 'Votre commande a été enregistrée et sera préparée. Vous recevrez un email pour vous informer de son expédition.',
	orderConfirmationTitle: 'Bien reçu !',
	orderContent: 'Contenu de la commande',
	orderDetails: 'Détails',
	orderId: 'Identifiant',
	orderInfoCommentAlertTitle: 'Message important',
	orderInvoice: 'Facture',
	orderInvoicePrintButton: 'Imprimer la facture',
	orderItemsEmpty: 'Il n\'y a aucun article dans votre commande',
	orderItemViewBook: 'Voir mon livre',
	orderItemsTotal: 'Total des articles :',
	orderMassStatusConfirmMessage: 'Mettre à jour le statut de {count} commande(s) ?',
	orderMassExportInvoiceDetails: 'Exporter le détail des factures',
	orderMassUpdateStatus: 'Mettre à jour le statut',
	orderMassSendEmail: 'Envoyer un e-mail',
	orderAdminListHint: 'Suivez et traitez les commandes par statut. Utilisez les filtres pour affiner par pays, produit ou date de validation.',
	orderNoItems: 'Vous n\'avez pas encore commandé !',
	orderFlags: 'Drapeaux',
	orderNote: 'Note',
	orderNoteCustomer: 'Note client',
	orderNoteAdmin: 'Note interne (admin)',
	orderNoteAdminAdd: 'Ajouter une note',
	orderNoteAdminEmpty: 'Aucune note interne pour cette commande.',
	orderNoteAdminPlaceholder: 'Note interne visible uniquement par l\'équipe (expédition, support…)',
	orderPaymentChooseMethodLabel: 'Choisir un mode de paiement',
	orderPaymentFinishTitle: 'Terminer votre paiement',
	orderPaymentValidButton: 'Valider le paiement',
	orderPaymentMethod: 'Mode de paiement',
	orderPayments: 'Paiements',
	orderProcessInvitationText: 'Invitez vos amis à remplir la case',
	orderProcessInvitationTextBefore1: 'Directos.eu est un service d\'achat groupé entre particuliers, il vous permet d\'acheter des produits directement auprès des fabricants. afin de vous faire économiser, tant sur le prix des produits ET que sur les frais de livraison !',
	orderProcessInvitationTextBefore2: 'Ne vous inquiétez pas ! Nous avons une solution :',
	orderPublicAccess: 'Accès public',
	orderProductAdd: 'Ajouter un produit ',
	orderRefunds: 'Remboursements',
	orderShipping: 'Livraison',
	orderShippingAdd: 'Ajouter l\'expédition',
	orderSendStatusNotificationEmail: 'Envoyer l\'e-mail de notification',
	orderShippingFee: 'Frais d\'expédition',
	orderShippingRemoveConfirmMessage: 'Êtes-vous sûr de vouloir retirer cette livraison de la commande ?',
	orderShippingTrackingTitle: 'Suivez votre commande',
	orderShippingTrackingButton: 'Suivre mon colis',
	orderShippingTrackingHint: 'Le suivi peut prendre quelques heures à apparaître chez le transporteur.',
	orderShippings: 'Expéditions',
	orderStatus: 'Statut',
	orderStatusCanceled: 'Annulée',
	orderStatusComplete: 'Terminée',
	orderStatusOnpreparation: 'En préparation',
	orderStatusOnprogress: 'En cours',
	orderStatusPending: 'En attente',
	orderStatusPendingpayment: 'En attente de paiement',
	orderStatusShipped: 'Expédiée',
	orderSubtotalDiscount: 'Remise',
	orderSubtotalExclTax: 'Sous-total HT',
	orderSubtotalInclTax: 'Sous-total TTC',
	orderTax: 'TVA',
	orderThanks: 'Merci pour votre commande',
	attributionPaidLine: 'C\'est payé',
	attributionSkip: 'Voir ma commande',
	attributionSourceTitle: 'Qu\'est-ce qui vous a donné envie de ce livre ?',
	attributionSourceLead: 'Votre commande est déjà lancée. Une réponse nous dit ce qui vous a touché.',
	attributionSearchTitle: 'Avant de chercher, vous connaissiez déjà MonLivreSMS ?',
	attributionSearchLead: 'Un nom déjà entendu, ou une vraie découverte.',
	attributionOccasionTitle: 'Pour quelle occasion est ce livre ?',
	attributionOccasionLead: 'Celle que vous avez en tête.',
	attributionOtherPlaceholder: 'Quelques mots, si vous voulez',
	attributionOtherContinue: 'Continuer',
	attributionSaveError: 'Cette réponse n\'a pas pu être enregistrée. Réessayez.',
	attributionOpt_bouche_a_oreille: 'Un proche m\'en a parlé',
	attributionOpt_vu_objet: 'J\'ai vu le livre, chez quelqu\'un',
	attributionOpt_receveur_devenu_client: 'On m\'en a offert un, à mon tour',
	attributionOpt_recherche: 'En cherchant sur Google',
	attributionOpt_instagram: 'Instagram',
	attributionOpt_tiktok: 'TikTok',
	attributionOpt_facebook: 'Facebook',
	attributionOpt_pinterest: 'Pinterest',
	attributionOpt_qvema: 'Qui veut être mon associé',
	attributionOpt_medias: 'Un article, une émission ou un podcast',
	attributionOpt_client_existant: 'J\'avais déjà commandé ici',
	attributionOpt_autre: 'Autre chose',
	attributionOpt_decouverte_pure: 'Plutôt un hasard',
	attributionOpt_pre_bao: 'Un proche m\'en avait parlé',
	attributionOpt_pre_tv: 'Je l\'avais vu à la télé',
	attributionOpt_pre_social: 'Je l\'avais vu sur les réseaux',
	attributionOpt_pre_inconnu: 'Je ne sais plus',
	attributionOpt_anniv_couple: 'L\'anniversaire de notre rencontre',
	attributionOpt_noel: 'Noël',
	attributionOpt_saint_valentin: 'La Saint-Valentin',
	attributionOpt_anniversaire: 'Un anniversaire',
	attributionOpt_deuil: 'Les messages de quelqu\'un que j\'ai perdu',
	attributionOpt_naissance: 'Une naissance',
	attributionOpt_distance: 'Quelqu\'un qui part, ou qui vit loin',
	attributionOpt_pour_soi: 'Pour moi, pas pour l\'offrir',
	attributionOpt_autre_occasion: 'Un autre moment',
	bookIntentTitle: 'Ce livre, c\'est pour...',
	bookIntentLead: 'Une réponse, et on commence.',
	bookIntentSkip: 'Passer',
	bookIntentOpt_anniv_couple: 'L\'anniversaire de notre rencontre',
	bookIntentOpt_anniversaire: 'L\'anniversaire de quelqu\'un',
	bookIntentOpt_noel: 'Noël',
	bookIntentOpt_saint_valentin: 'La Saint-Valentin',
	bookIntentOpt_souvenir: 'Quelqu\'un qui n\'est plus là',
	bookIntentOpt_plus_tard: 'Plus tard',
	bookIntentOpt_autre: 'Un autre moment',
	bookIntentDate_anniv_couple: 'Quelle est la date ?',
	bookIntentDateLead_anniv_couple: 'Le jour de votre rencontre, ou celui que vous fêtez à deux.',
	bookIntentDate_anniversaire: 'C\'est quel jour, son anniversaire ?',
	bookIntentDateLead_anniversaire: 'L\'anniversaire de la personne à qui vous l\'offrez.',
	bookIntentDate_plus_tard: 'Vers quelle date ?',
	bookIntentDateLead_plus_tard: 'Le jour que vous avez en tête.',
	bookIntentDateDefer: 'Je la préciserai plus tard',
	bookIntentDateBack: 'Retour',
	bookIntentDateContinue: 'Continuer',
	bookIntentSaveError: 'Cette réponse n\'a pas pu être enregistrée. Réessayez.',
	inboxPromptTitle: 'Pour votre livre',
	inboxPromptSignup: 'On vient de vous envoyer un mail, « {subject} ». C\'est le début de votre livre, pas une pub. {provider} le met parfois de côté. Marquez-le comme « {mark} ». Grâce à ce geste, la suite vous arrivera correctement, avec ce qu\'il faut pour le faire vraiment bien.',
	inboxPromptTransfer: 'On vient de vous envoyer un mail, « {subject} ». C\'est le lien vers votre conversation, pas une pub. {provider} le met parfois de côté. Marquez-le comme « {mark} ». Grâce à ce geste, vous aurez tout sous la main pour en faire le livre que vous voulez.',
	inboxPromptMarkGmail: 'Non indésirable',
	inboxPromptMarkYahoo: 'Ce n\'est pas un indésirable',
	inboxPromptButton: 'Je valide dans {provider}',
	inboxPromptClose: 'Fermer',
	inboxPromptConfirm: 'On vient de vous envoyer un mail, « {subject} ». Il ouvre votre compte. {provider} le met parfois de côté. Marquez-le comme « {mark} ». Grâce à ce geste, la suite vous arrivera.',
	emailConfirmPageTitle: 'Confirmez votre adresse',
	emailConfirmTitle: 'Regardez vos mails',
	emailConfirmLead: 'On vient de vous envoyer un mail pour ouvrir votre compte. Le bouton à l’intérieur confirme votre adresse.',
	emailConfirmResend: 'Renvoyer le mail',
	emailConfirmResent: 'Le mail est reparti.',
	emailConfirmExpired: 'Ce lien a expiré. Demandez-en un nouveau depuis votre compte.',
	emailConfirmInvalid: 'Ce lien ne correspond à aucun compte.',
	emailConfirmWorking: 'Ouverture du compte…',
	orderTotal: 'TOTAL',
	orderTotalTTC: 'Total TTC',
	orderTotalTax: 'T.V.A. {rate}%',
	orderTotalToPay: 'Montant total à payer: {total}€',
	orderTotals: 'Totaux',
	orderUserRegisterAlert: 'Vous devez renseigner votre email afin de vous joindre en cas de problème avec votre commande.',
	orderView: 'Voir la commande',
	orderViewShort: 'Commande',
	orderWeight: 'Poids',
	orderitemAddProductTitle: 'Modifier les données de l\'article',
	orders: 'Commandes',
	ordersEditSuccess: 'Commandes mises à jour !',
	ordersContactTitle: 'Contacter par commandes',
	ordersMy: 'Mes commandes',
	ordersMyViewButton: 'Voir mes commandes',
	packingInformation: 'Informations d\'emballage',
	parcelGroupInfo: ' Regrouper le colis par nombre de colis',
	parcelGroupLabel: 'Groupe de colis',
	parcelGroupWeightInfo: 'Kg par groupe de colis',
	parcelGroupWeightLabel: 'Regrouper le colis par poids',
	paymentCardInputLabel: 'Veuillez saisir les informations de votre carte de crédit pour valider votre commande.',
	paymentMethodCreditbalanceDescription1: 'Déduit automatiquement du total',
	paymentMethodCreditbalanceDescription2: 'Reste à payer',
	paymentMethodCreditbalancePay: 'Valider avec mon crédit',
	paymentMethodCreditbalanceTitle: 'Crédit déjà appliqué',
	paymentFailError: 'Votre paiement n\'a pas abouti ! Réessayez s\'il vous plaît',
	paymentMethod: 'Mode de paiement',
	paymentMethodBancontactLabel: 'Bancontact',
	paymentMethodBankcheckLabel: 'Chèque bancaire',
	paymentMethodBanktransferLabel: 'Virement bancaire',
	paymentMethodCardLabel: 'Carte bancaire',
	paymentMethodCreditcardLabel: 'Carte bancaire',
	paymentMethodCreditDescription1: 'Ce montant est automatiquement déduit du montant restant à payer du montant total de votre panier. ',
	paymentMethodGiropayLabel: 'Giropay',
	paymentMethodIdealLabel: 'iDEAL',
	paymentMethodPhoneLabel: 'Téléphone',
	paymentMethodCreditPay: 'Payer avec mes avoirs',
	paymentMethodCreditTitle: 'Vous avez déjà payé une partie de votre commande :',
	paymentValidButton: 'Valider mon paiement',
	previous: 'Précédent',
	priceInformation: 'Informations sur les prix',
	priceRoundAlertTooltip: 'Ce prix peut être arrondi en raison de la conversation sur les devises',
	printButton: 'Imprimer',
	process: 'Process',
	productAnnexes: 'Annexes',
	productAnnexesNewProductError: 'Veuillez d\'abord enregistrer votre nouveau produit avant d\'ajouter des annexes !',
	productAttributes: 'Attributs',
	product: 'Produit',
	productAdd: 'Ajouter un produit',
	productAdminListHint: 'Gérez le catalogue, les prix et la disponibilité de la boutique.',
	productConversationTypeMissingAlert: 'Il n\'y a aucun produit associé au type sélectionné. Merci de nous contacter pour résoudre ce problème !',
	productCostHT: 'Coût HT. taxe',
	productDescription: 'Description',
	productEdit: 'Modifier le produit',
	productImages: 'Images',
	productImagesNewProductError: 'Veuillez enregistrer d\'abord votre nouveau produit avant d\'ajouter des images !',
	productIsActive: 'Actif ?',
	productName: ' Nom',
	productPictureDelete: 'Supprimer l\'image',
	productPriceHT: 'Prix HT. taxe',
	productPriceTTC: 'Prix incl. taxe',
	productReference: 'Référence',
	productSlug: 'Slug',
	productSpecialPriceQuantityDiscountInfo: 'Économisez {percent}% sur votre panier en ajoutant {quantity} copies !',
	productTaxCalculate: 'Calculer',
	productTaxRate: 'Taux de taxe',
	productTaxRateFormHelp: 'Pour une taxe de 20% remplir le taux de taxe à 0,2',
	productUseForConversationBook: 'Utiliser pour les livres papier ?',
	productUseForConversationEBook: 'Utiliser pour les E-books ?',
	productUseForCredit: 'Utiliser pour les crédits utilisateur ?',
	products: 'Produits',
	productsView: 'Voir les produits',
	quantity: 'Quantité',
	refresh: 'Rafraichir',
	refundCreateTitle: 'Créer un remboursement',
	refundCreateConfirmMessage: 'Confirmez-vous la création de ce remboursement ?',
	remove: 'Supprimer',
	retry: 'Recommencer',
	save: 'Enregistrer',
	saveBeforeAlert: 'Veuillez enregistrer d\'abord...',
	saveRequestError: 'Erreur d\'enregistrement !',
	saveRequestSuccess: 'Enregistré !',
	saving: 'Enregistrement...',
	searchFor: 'Rechercher',
	seconds: 'Seconde(s)',
	select: 'Sélectionner',
	selectAll: 'Tout sélectionner',
	selectFile: 'Sélectionner un fichier',
	selectImage: 'Sélectionnez une image',
	selectOptions: 'Sélectionner une option',
	selectUnAll: 'Tout désélectionner',
	seoOrderViewTitle: 'Commande n°{code}',
	seoTitle: 'Impression de SMS&Conversation en livre',
	shippingAddressEdit: 'Modifier l\'adresse de livraison',
	shippingAddressMissingError: 'Vous n\'avez pas renseigné votre adresse de livraison.',
	shippingCalculation: 'Calcul',
	shippingCalculationInfo: 'Si le calcul est en boucle, il est préférable d\'utiliser la limite maximale inclusive.',
	shippingCarrier: 'Transporteur',
	shippingChronopostPickupError: 'Impossible de récupérer les points de livraison ! Veuillez vérifier le pays et le code postal avant de réessayer.',
	shippingChronopostPickupNoResult: 'Nous n\'avons trouvé aucun point-relais proche de vous. Veuillez rechercher avec une autre adresse.',
	shippingChronopostPickupOpeningHours: 'Horaires d\'ouverture',
	shippingChronopostPickupOpeningHoursView: 'Voir les horaires d\'ouverture',
	shippingChronopostPickupViewList: 'Voir la liste',
	shippingChronopostPickupViewMap: 'Voir la carte',
	shippingPickupError: "Impossible d'ouvrir le sélecteur de point relais. Veuillez réessayer plus tard.",
	shippingPickupChange: 'Changer de point relais',
	shippingPickupChoose: 'Choisir un point relais',
	shippingCountrySelect: 'Pays de livraison',
	shippingDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette méthode de livraison ?',
	shippingDeliveryEstimationDate1: 'Date de livraison estimée: {date}',
	shippingDeliveryEstimationDate2: 'Date de livraison estimée: entre le {date1} et le {date2}',
	shippingDeliveryEstimationText: 'Ceci est une estimation des frais de livraison. La sélection du lieu de livraison se fera à l\'étape suivante.',
	shippingDeliveryTime: 'Délai de livraison (en jours)',
	shippingDeliveryTimeInfo: 'Livraison en {days} jours ouvrés',
	shippingDescription: 'Description',
	shippingExcludeDepartmentInfo: 'Séparez les codes postaux à exclure par une virgule (,). Utilisez "*" comme joker',
	shippingExcludeDepartmentLabel: 'Exclure les codes postaux',
	shippingExtraFeeCalculation: 'Calcul des frais supplémentaires d\'expédition',
	shippingExtraFeeLabel: 'étiquette de frais supplémentaires d\'expédition',
	shippingExtraFees: 'Frais supplémentaires',
	shippingFeeCalculatorTitle: 'Calculez vos frais d\'envois',
	shippingFeeFreeDelivery: 'Livraison offerte',
	shippingFeeNotFoundError: '',
	shippingFeeWithBookResult: 'Commandez maintenant et recevez votre ebook en quelques minutes, puis vos livres papier en {countryName} entre le {deliveryDateFrom} et le {deliveryDateTo}',
	shippingFeeWithoutBookResult: 'Commandez maintenant et recevez votre ebook en quelques minutes',
	shippingFreeStep: 'Étape de livraison gratuite',
	shippingFreeTreshold: 'Seuil de livraison gratuite',
	shippingFreeInfo: 'Livraison gratuite dès {value}',
	shippingIdentifier: 'Identifiant d\'expédition',
	shippingIsPriceTTC: 'Le prix d\'expédition comprend-il les taxes ?',
	shippingLabelGenerateButton: 'Générer l\'étiquette',
	shippingLabelGenerateButton2: 'Régénérer l\'étiquette',
	packingCheckTitle: 'Livres de cette commande',
	packingCheckHint: 'Présentez un livre à la fois, dos vers la caméra. Quand le compteur avance, posez-le hors du champ, puis le suivant.',
	packingCheckProgress: '{seen} / {expected}',
	packingCheckForeign: 'Ce livre est la commande {code}. Sortez-le du colis.',
	packingCheckReady: 'C\'est bon. Vous pouvez imprimer l\'étiquette.',
	packingCheckOverflow: 'Trop de livres lus. Recommencez.',
	packingCheckRestart: 'Recommencer',
	packingCheckCameraStart: 'Ouvrir la caméra',
	packingCheckCameraDenied: 'La caméra est bloquée. Autorisez-la, ou scannez avec la douchette.',
	packingCheckLocked: 'Scannez tous les livres avant d\'imprimer l\'étiquette.',
	packingCheckWedgeLabel: 'Ou scannez le QR avec la douchette',
	packingCheckLoading: 'On charge les livres de la commande.',
	prepBooksCardTitle: 'Livres',
	prepBooksCount: '{count, plural, one {# livre} other {# livres}}',
	prepBooksPageEyebrow: 'Préparation',
	prepBooksPageTitle: 'Commande {code}',
	prepBooksPageHint: 'Les livres qui partent dans ce colis.',
	prepModeClient: 'Vue client',
	prepModePreparation: 'Vue préparation',
	shippingAdd: 'Ajouter un mode',
	shippingAdminListHint: 'Configurez les transporteurs, pays et règles tarifaires pour les livraisons.',
	shippingMethod: 'Mode de livraison',
	shippingMethodCalculating: 'Calcul de vos frais...',
	shippingMethodConditions: 'Conditions d\'expédition',
	shippingMethodMissingAlert: 'Nous n\'avons pas de transporteur valide pour votre panier. Merci de modifier votre expédition pour sélectionner un transporteur',
	shippingMethodNotAvailable: 'Aucun mode de livraison disponible pour votre adresse...',
	shippingRatesError: 'Le calcul des frais de livraison s\'est interrompu. Réessayez dans un instant. Si cela recommence, écrivez-nous et nous regardons avec vous.',
	shippingMethodPricing: 'Tarif',
	shippingMethodPricingSystem: 'Système de tarification',
	shippingMethodSearch: 'Recherche des modes de livraison',
	shippingMethodSelectTitle: 'Sélectionnez votre livraison',
	shippingGroupRelay: 'Point relais',
	shippingGroupHome: 'À domicile',
	shippingTierClassic: 'Livraison classique',
	shippingTierExpress: 'Livraison express',
	shippingTierClassicDesc: 'Délai standard',
	shippingTierExpressDesc: 'La plus rapide',
	shippingTierPriceRelayFree: 'Gratuit en point relais',
	shippingTierPriceRelayFrom: 'À partir de {price} en point relais',
	shippingTierPriceHomeFrom: '{price} à domicile',
	shippingChangeTier: 'Changer de vitesse de livraison',
	shippingTierModeTitle: 'Choisissez votre mode de livraison',
	shippingStepOf: 'Étape {current} sur {total}',
	shippingStepSpeedTitle: 'Quand souhaitez-vous être livré ?',
	shippingStepModeTitle: 'Où souhaitez-vous être livré ?',
	shippingMethodTrackingInfo: 'Informations de suivi',
	shippingMethods: 'Modes d\'expédition',
	shippingOrder: 'Ordre d\'expédition',
	shippingProvider: 'Fournisseur d\'expédition',
	shippingStep: 'Étape',
	shippingStepInfo: 'Cette étape DOIT être le paramètre de gauche ! Le paramètre supérieur est le code postal par défaut.',
	shippingStepLimitInfo: 'La condition laissée est-elle le minimum/maximum ?',
	shippingTaxRate: 'Taux de taxe d\'expédition',
	shippingTitle: 'Livraison',
	shippingTrackingNumber: 'Numéro de suivi',
	shippingTrackingParcelUrl: 'URL du colis de suivi d\'expédition',
	status: 'Statut',
	stepTitle: 'Étape {step}',
	submit: 'Soumettre',
	suborderitemAddProductTitle: 'Ajouter un produit',
	switchLanguage: 'Changer de langue',
	tableDownloadNoElementError: 'Aucun élément à télécharger !',
	tablePageSize: 'Par page',
	tableMassActions: 'Actions groupées',
	tableRefreshSuccessAlert: 'Synchronisé !',
	tableRefreshSuccessError: 'Erreur de synchronisation !',
	tableSelection: `{count} {count, plural,
			  =0 {sélectionné}
			  =1 {sélectionné}
			  other {sélectionnés}
		  }`,
	tag: 'Mot-clé',
	tagFillPlaceholder: 'Entrez un mot clé...',
	tags: 'Mot-clés',
	taskDescription: 'Description',
	taskAddTitle: 'Ajouter une tâche',
	taskEditTitle: 'Modifier la tâche',
	taskCountdownDate: 'Date de rappel',
	taskAssignSelf: 'M\'assigner',
	taskPriority: 'Priorité',
	taxRate: 'TVA',
	the: 'le',
	time: 'Heure',
	timezone: 'Fuseau horaire',
	title: 'Titre',
	toleranceLabel: 'Tolérance',
	total: 'Total',
	type: 'Type',
	unit: 'Unité',
	user: 'Utilisateur',
	userAccountCreditsTitle: 'Mon solde de crédits',
	userAccountDataProtection: 'Protection des données',
	userAccountDataProtectionText1: 'Nous prenons très au sérieux la protection de vos données personnelles, c\'est pourquoi nous nous engageons à les sécuriser et nous les conservons pendant une durée raisonnable et nécessaire au bon déroulement des examens.',
	userAccountDataProtectionText2: 'Nous ne vous demandons uniquement des informations qui sont nécessaires au service et nous nous engageons à ne jamais communiquer à un service tiers ou utiliser vos données personnelles à des fins commerciales sans votre consentement.',
	userAccountDataProtectionText3: 'Si vous souhaitez récupérer vos données ou utiliser votre droit à la portabilité des données, veuillez nous contacter sur {email}',
	userAccountDelete: 'Supprimer mon compte',
	userAccountDeleteActiveSuborder: 'Vous ne pouvez pas supprimer votre compte tant que les commandes auxquelles vous participez ne sont pas terminées !',
	userAccountDeleteBlockText: 'Vous ne pouvez pas supprimer votre compte pour le moment !',
	userAccountDeleteButton: 'Supprimer mon compte',
	userAccountDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer votre compte définitivement ?',
	userAccountDeleteConfirmTitle: 'Supprimer mon compte',
	userAccountDeleteError: 'Impossible de supprimer votre compte !',
	userAccountDeleteSuccess: 'Votre compte a été supprimé ! À bientôt !',
	userAccountDeleteText: 'En supprimant votre compte, vous supprimerez votre accès à vos informations sur ce site. Nous supprimerons vos données personnelles dans notre base de données. Cette action est irréversible !',
	userAccountEdit: 'Modifier mon compte',
	userAccountEditSuccess: 'Compte mis à jour',
	userAccountExistError: 'Votre adresse email n\'est associé à aucun compte !',
	userAccountExistTitle: 'Vous possédez déjà un compte ?',
	userAccountGeneral: 'Général',
	userAccountHistory: 'Historique',
	userAccountInfo: 'Vos données sont protégées et resteront strictement confidentielles.',
	userAccountInfoMyTitle: 'Mes informations',
	userAccountMy: 'Mon compte',
	userAccountNote: 'Note compte utilisateur',
	userAccountPersonnalInformation: 'Mes informations personnelles',
	userAccountPreferencesInformation: 'Mes préférences',
	userAccountResetError: 'Erreur lors de la réinitialisation du compte !',
	userAccountResetSuccess: 'Compte réinitialisé !',
	userActivityOnLine: 'En ligne',
	userAdd: 'Ajouter un utilisateur',
	userAddNew: 'Ajouter un nouvel utilisateur',
	userAdminListHint: 'Recherchez des comptes, consultez l\'activité et ouvrez un profil ou les commandes d\'un utilisateur.',
	userBridgeError: 'La connexion depuis l\'application a échoué. Veuillez réessayer.',
	userBridgeInvalid: 'Ce lien de connexion n\'est plus valide. Relancez la connexion depuis l\'application.',
	userBridgePending: 'Connexion en cours…',
	userBridgeSuccess: 'Vous êtes connecté ! Vous pouvez retourner sur l\'application.',
	userChangePasswordSuccess: 'Mot de passe modifié !',
	userConfirmationCode: 'Code de confirmation reçu par email',
	userConfirmationCodeCheckButton: 'J\'ai bien reçu le code pour réinitialiser mon mot de passe',
	userConfirmationCodeError: 'Veuillez renseigner le code de confirmation ! Consultez votre boîte mail !',
	userConnectionInfo: 'Accédez à votre compte pour valider votre commande et invitez vos amis à participer !',
	userCredits: 'Crédits',
	userCreditsBalancePositive: 'Vous avez {amount} de crédit disponible : appliqué automatiquement à l\'étape suivante.',
	userCreditsPrepaymentInviteTitle: 'Prépaiement de votre livre',
	userDeleteConfirmTitle: 'Supprimer l\'utilisateur',
	userDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
	userDeleteConfirmation: '{user} a été supprimé !',
	userEdit: 'Modifier {user}',
	userEdit2: 'Modifier l\'utilisateur',
	userEditPassword: 'Modifier mon mot de passe',
	userEmail: 'Adresse email',
	userEmailError: 'Votre adresse email est incorrecte !',
	userEmailFillInfo: 'Entrez votre adresse email',
	userEmailFormInfo: 'Renseignez votre email pour continuer',
	userEmailFormInfo2: 'Votre email sera utilisé pour créer votre compte et vous alerter des mises à jour de votre commande.',
	userLoginCodeTitle: 'Vous avez déjà un compte',
	userLoginCodeIntro: 'On vient d\'envoyer un code à 6 chiffres à {email}. Saisissez-le ici pour continuer.',
	userLoginCodeLabel: 'Code reçu par email',
	userLoginCodeSubmit: 'Valider',
	userLoginCodeInvalid: 'Ce code ne correspond pas. Vérifiez le dernier email reçu.',
	userLoginCodeExpired: 'Ce code n\'est plus valable. Demandez-en un nouveau juste en dessous.',
	userLoginCodeError: 'Oups, ça n\'a pas marché. Réessayez dans un instant.',
	userLoginCodeLinkHint: 'Le même email contient aussi un lien de connexion.',
	userLoginCodeResend: 'Renvoyer un code',
	userLoginCodeResendIn: 'Renvoyer un code dans {seconds} s',
	userLoginCodeResent: 'C\'est renvoyé. Pensez à regarder dans vos spams.',
	userLoginCodeChangeEmail: 'Utiliser une autre adresse',
	userLoginCodeCartSuccess: 'Connexion réussie. Vous pouvez finaliser votre commande.',
	userEnvironmentTestNoTest: 'Cet utilisateur n\'a passé aucun test d\'environnement !',
	userFillPlaceholder: 'Entrez le nom d\'un utilisateur...',
	userFirstName: 'Prénom',
	userForgotPassword: 'Mot de passe oublié ?',
	userForgotPasswordRetryDateError: 'Vous ne pouvez refaire une demande de mot de passe. Veuillez consultez votre boîte email pour récupérer le code de confirmation.',
	userFormInfo: 'Complétez votre profil',
	userGenderLabel: 'Genre',
	userIsActive: 'Actif ?',
	userLastName: 'Nom',
	userLogin: 'Connexion',
	userLoginAction: 'Se connecter',
	userLoginEmailSelected: 'Connexion avec l\'adresse email: {email}',
	userLoginError: 'Identifiants erronés ! Veuillez réessayer...',
	userLoginFirstButton: 'Première connexion ?',
	userLoginFirstText: 'Consultez votre boîte mail pour récupérer votre mot de passe temporaire. Utilisez ce mot de passe pour votre 1ère connexion. Vous pourrez par la suite modifier votre mot de passe.',
	userLoginBenefit1: 'Votre livre photo SMS en quelques clics',
	userLoginBenefit2: 'Livraison rapide à domicile',
	userLoginBenefit3: 'Paiement 100% sécurisé',
	userLoginIntro: 'Merci de vous identifier pour accéder à votre espace',
	userLoginWelcomeSubtitle: 'Transformez vos SMS en un beau livre photo imprimé.',
	userLoginWelcomeTitle: 'Bienvenue !',
	userLoginNoConnexion: 'Aucune connexion',
	userLoginTitle: 'Connexion',
	userLogout: 'Déconnexion',
	userName: 'Nom',
	userNewPassword: 'Nouveau mot de passe',
	userNewsletterSubscribeButton: 'S\'inscrire à la newsletter',
	userNewsletterText1: 'Recevez nos nouveautés, nos bons plans et nos promotions directement dans votre email box',
	userOldPassword: 'Ancien mot de passe',
	userOptions: 'Options de l\'utilisateur',
	userPassword: 'Mot de passe',
	userPasswordConfirmation: 'Confirmation du mot de passe',
	userPasswordConfirmationError: 'Veuillez renseigner une confirmation identique au mot de passe !',
	userPasswordConfirmationRestriction: 'La confirmation doit être identique au mot de passe renseigné',
	userPasswordEdit: 'Modifier mon mot de passe',
	userPasswordSet: 'Définir un mot de passe',
	userPasswordSetSuccess: 'Mot de passe enregistré.',
	userSocialConnectionsTitle: 'Connexions',
	userSocialContinueApple: 'Continuer avec Apple',
	userSocialContinueGoogle: 'Continuer avec Google',
	userSocialDivider: 'ou',
	userSocialError: 'La connexion a échoué. Veuillez réessayer.',
	userSocialErrorNoEmail: 'Votre compte Apple n\'a pas fourni d\'adresse email. Utilisez une autre méthode de connexion.',
	userSocialErrorUnavailable: 'Cette connexion n\'est pas encore disponible.',
	userSocialLinkApple: 'Lier Apple',
	userSocialLinkGoogle: 'Lier Google',
	userSocialLinkSuccess: 'Compte lié.',
	userSocialLinked: 'Lié',
	userSocialUnlinkApple: 'Délier Apple',
	userSocialUnlinkConfirm: 'Délier cette connexion de votre compte ?',
	userSocialUnlinkGoogle: 'Délier Google',
	userSocialUnlinkLastError: 'Ajoutez un mot de passe avant de délier votre dernière connexion.',
	userSocialUnlinkSuccess: 'Compte délié.',
	userPasswordError: 'Veuillez renseigner un mot de passe correct s\'il vous plaît !',
	userPasswordResetText: 'Veuillez renseigner votre mot de passe personnel. Confirmez-le et cliquez sur le bouton au dessous.',
	userPasswordRestriction: 'Le mot de passe doit respecter 6 caractères et contenir au moins 1 chiffre et 1 caractère spécial (@&!()$*€%) !',
	userPasswordRestrictionAlt: 'Le mot de passe doit respecter 6 caractères !',
	userPasswordTemporaryCheckButton: 'J\'ai bien reçu mon mot de passe provisoire',
	userPhone: 'Téléphone',
	userPhoneError: 'Votre numéro de téléphone n\'est pas valide !',
	userProfileMy: 'Mon profil',
	userReInitPassword: 'Réinitialiser mon mot de passe',
	userRecoverFromOldAppCheckButton: 'J\'ai bien reçu mon email pour récupérer mon mot de passe',
	userRecoverFromOldAppText: 'Votre compte vient d\'être migré vers la nouvelle application ! Consultez votre boîte mail pour récupérer votre mot de passe et activer votre nouveau compte !',
	userRegister: 'Créer mon compte',
	userRegisterError: 'Impossible de créer votre compte ! Veuillez vérifier votre adresse email et réessayer...',
	userRegisterSuccess: 'Félicitations ! Votre compte a été créé ! Vous allez recevoir un email contenant votre mot de passe temporaire !',
	userRegisterSuccessEmailNotice: 'Un email de confirmation vient de vous être envoyé à {email}.',
	userRegisterSuccessEyebrow: 'Bienvenue',
	userRegisterSuccessPageTitle: 'Bienvenue !',
	userRegisterSuccessSourcesHint: 'Sélectionnez l\'application où se trouvent vos messages.',
	userRegisterSuccessSourcesTitle: 'Par où commencer ?',
	userRegisterSuccessStep1Desc: 'Vous y trouverez le récapitulatif de votre inscription.',
	userRegisterSuccessStep1Title: 'Consultez votre boîte mail',
	userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS ou Android : choisissez votre source.',
	userRegisterSuccessStep2Title: 'Importez vos messages',
	userRegisterSuccessStep3Desc: 'Couverture, couleurs, photos : personnalisez chaque détail.',
	userRegisterSuccessStep3Title: 'Créez votre livre',
	userRegisterSuccessStepsEyebrow: 'Votre parcours',
	userRegisterSuccessText: 'Votre compte est prêt. En quelques étapes, transformez vos messages en un livre à garder précieusement.',
	userRegisterSuccessTitle: 'Votre histoire commence ici',
	userRegisterSuccessTitleNamed: 'Bienvenue, {firstName} !',
	userResetPasswordAccountButton: 'Réinitialiser le mot de passe du compte',
	userResetPasswordAskSuccess: 'Consultez votre boîte email pour cliquer sur le lien de réinitialisation de votre mot de passe !',
	userResetPasswordButton: 'Réinitialiser mon mot de passe',
	userResetPasswordError: 'Impossible de réinitialiser votre mot de passe ! Veuillez essayer plus tard...',
	userResetPasswordInfo: 'Vous allez recevoir un lien de confirmation dans votre boîte mail afin de réinitialiser votre mot de passe.',
	userResetPasswordInfo2: 'Réinitialisez votre mot de passe en remplissant les champs ci-dessous:',
	userResetPasswordSuccess: 'Mot de passe réinitialisé avec succès !',
	userRole: 'Rôle',
	userRoleAdmin: 'Administrateur',
	userRoleCustomer: 'Client',
	userSearchLabel: 'Tapez un email ou un nom d\'un utilisateur',
	userSendNewAccountEmail: 'Envoyer un email de nouveau compte à l\'utilisateur',
	userSendNewAccountEmailSuccess: 'Utilisateur averti!',
	userSwitch: 'Changer l\'utilisateur',
	userValidForgotPasswordError: 'Impossible de vous envoyer le code de réinitialisation de mot de passe !',
	userValidForgotPasswordSuccess: 'Consultez votre boîte email pour utiliser votre code de confirmation afin de réinitialiser votre mot de passe !',
	users: 'Utilisateurs',
	usersList: 'Liste des utilisateurs',
	valid: 'Valider',
	vatExempt: 'EXONÉRATION TVA',
	vatRates: 'TVA par pays',
	vatRatesAddCountry: 'Ajouter un pays',
	vatRatesAdminHint: 'Un taux de TVA par pays de livraison. Le prix payé par le client ne change jamais.',
	vatRatesEmpty: 'Aucun pays configuré : toutes les commandes sont facturées à 0% de TVA.',
	vatReport: 'Déclaration TVA',
	vatReportAdminHint: 'TVA facturée par pays sur une période, prête pour la déclaration.',
	vatReportUnknownCountry: 'Pays inconnu',
	vatRatesIntro: 'Le taux appliqué est celui du pays de livraison (pays de facturation pour un panier 100% numérique). Le prix payé reste identique : seule la répartition entre prix HT et TVA change.',
	vatRatesIntroFallback: 'Un pays absent de ce tableau est facturé à 0% de TVA. Le même taux s\'applique au livre papier, à l\'ebook et aux frais de port.',
	vatRatesInvalid: 'Vérifiez le taux de {country} : indiquez un pourcentage entre 0 et 100.',
	vatRatesSaveSuccess: 'Taux de TVA enregistrés !',
	vatRatesSimulation: 'Simulation sur un prix TTC',
	view: 'Voir',
	voucher: 'Bon d\'achat',
	voucherAdd: 'Ajouter un bon',
	voucherAdminListHint: 'Créez et gérez les codes promo, conditions et limites d\'utilisation.',
	voucherApplyButton: 'Appliquer',
	voucherApplyComplete: 'Vous ne pouvez pas ajouter d\'autre coupon de réduction !',
	voucherApplyFormLabel: 'Code promo',
	voucherApplyValidError: 'Ce coupon n\'a pas pu être appliqué à votre commande!',
	voucherCode: 'Code',
	voucherCodePlaceholder: 'Entrez votre code promo',
	voucherDeleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce bon de réduction ?',
	voucherEdit: 'Modifier le bon d\'achat',
	voucherIsAuto: 'Est auto?',
	voucherIsCumulative: 'Est cumulatif?',
	voucherIsPublic: 'Est public?',
	voucherNotExistsError: 'Ce coupon ne n\'existe pas !',
	voucherPriority: 'Priorité',
	voucherProductOffer: 'Proposés',
	voucherRemoveAllButton: 'Supprimer tous les codes promo',
	vouchers: 'Bons d\'achat',
	weight: 'Poids',
	yes: 'Oui',
	you: 'Vous',
	yourself: 'Vous',
	userNewsletterTitle: 'Newsletter',
	userNewsletterSubscribeText: 'Nous vous enverrons les nouveaux produits, promotions et nos favoris',
	userNewsletterUnSubscribeButton: 'Se désabonner de la newsletter',
	'userOrdersView': "Afficher les commandes de l'utilisateur",
	'userCanCustomizeMessages': 'Peut personnaliser les messages ?',
	'userLogAsUser': "Se connecter en tant qu'utilisateur",
	'shippingMethodProviderData': 'Informations du fournisseur',
	'productUseForCustomization': 'Utiliser pour la personnalisation ?',
	'conversationBookFormat': 'Format du livre',
	'conversationMessageSelect': 'Sélectionner ce message',
	'conversationMessagesLuxEyebrow': 'Votre livre',
	'conversationMessagesLuxHint': 'Recherchez, masquez ou modifiez des messages. Vos changements s’appliquent à votre sélection.',
	'conversationMessagesLuxSavePreview': 'Enregistrer · retour à l’aperçu',
	'conversationMessagesLuxBackPreview': 'Voir l’aperçu',
	'conversationMessagesLuxCount': '{messages, number} {messages, plural, one {message} other {messages}}, {photos, number} {photos, plural, one {photo} other {photos}} et {medias, number} {medias, plural, one {média} other {médias}} dans votre sélection',
	'conversationMessagesFilterResults': '{count, number} {count, plural, one {résultat} other {résultats}}',
	'conversationMessagesOnlyHidden': 'Masqués uniquement',
	'conversationMessagesResetFilters': 'Réinitialiser les filtres',
	'conversationMessagesShowHidden': 'Afficher les messages masqués',
	'conversationMessagesResetChanges': 'Annuler toutes les modifications',
	'conversationMessagesResetChangesButton': 'Tout annuler',
	'conversationMessagesResetChangesConfirm': 'La conversation sera restaurée dans son état importé d’origine. Toutes vos modifications (messages masqués, modifiés ou ajoutés) seront définitivement perdues. Continuer ?',
	'conversationMediaTypePhotos': 'Photos',
	'conversationMediaTypeVideos': 'Vidéos',
	'conversationMediaTypeAudios': 'Audios',
	'conversationMediaTypeLinks': 'Liens',
	'conversationMediaTypeOther': 'Autres',
	'conversationMessagesToolSearch': 'Rechercher',
	'conversationMessagesToolMedias': 'Médias',
	'conversationMessagesToolDates': 'Dates',
	'conversationMessagesToolHidePeriod': 'Masquer une période',
	'conversationMessagesToolHidden': 'Affichage',
	'conversationMessagesToolReset': 'Modifications',
	'conversationMessagesToolResetNone': 'Aucune',
	'conversationMessagesToolResetCount': '{count, number} {count, plural, one {modification} other {modifications}}',
	'conversationMessagesHiddenViewHint': 'Choisissez quels messages apparaissent dans la liste ci-dessous.',
	'conversationMessagesHiddenViewAll': 'Tous',
	'conversationMessagesHiddenViewVisible': 'Visibles',
	'conversationMessagesHiddenViewHidden': 'Masqués',
	'conversationMessagesResetChangesHint': 'Rétablit la conversation dans son état importé d’origine. Toutes vos modifications (messages masqués, modifiés ou ajoutés) seront perdues.',
	'conversationMessagesToolSearchNone': 'Aucune',
	'conversationMessagesToolMediasAll': 'Tous les messages',
	'conversationMessagesToolDatesAll': 'Toute la période',
	'conversationMessagesToolHidePeriodNone': 'Aucune période',
	'conversationMessagesToolHiddenShown': 'Affichés',
	'conversationMessagesToolHiddenMasked': 'Masqués',
	'conversationMessagesBestofCuratedHint': 'Votre Best Of est assemblé : il est déjà rempli jusqu\'à son nombre de pages maximum. Vous pouvez masquer des messages, et en réafficher d\'autres tant que le livre ne s\'allonge pas.',
	'conversationMessagesBestofFullError': 'Votre Best Of est déjà complet. Pour afficher ces messages, masquez d\'abord environ {pages, number} {pages, plural, one {page} other {pages}} ailleurs.',
	'conversationMessagesHidePeriodHint': 'Masquez (ou réaffichez) tous les messages compris entre deux dates en une seule fois.',
	'conversationMessagesHidePeriodFrom': 'Du',
	'conversationMessagesHidePeriodTo': 'Au',
	'conversationMessagesHidePeriodCount': '{count, number} {count, plural, one {message} other {messages}} sur cette période ({visible} visibles, {hidden} masqués)',
	'conversationMessagesHidePeriodConfirmHide': 'Masquer {count, number} {count, plural, one {message} other {messages}} de cette période ?',
	'conversationMessagesHidePeriodConfirmShow': 'Réafficher {count, number} {count, plural, one {message} other {messages}} de cette période ?',
	'conversationMessagesHidePeriodHide': 'Masquer cette période',
	'conversationMessagesHidePeriodShow': 'Réafficher cette période',
	'conversationMessagesHidePeriodItem': 'Période {index}',
	'conversationMessagesHidePeriodAdd': 'Ajouter une période',
	'conversationMessagesHidePeriodInvalid': 'La date de fin doit être postérieure à la date de début.',
	'conversationMessagesToolHidePeriodCount': '{count, number} {count, plural, one {période} other {périodes}}',
	'conversationMessagesSearchPlaceholder': 'Rechercher un mot, un nom…',
	'conversationMessagesEditTitle': 'Personnalisation des messages',
	'conversationMessageSelectorDateFrom': 'Sélectionner les messages après',
	'conversationMessageSelectorDateTo': 'Sélectionner les messages avant',
	'conversationTextSearch': 'Rechercher le texte du message',
	'conversationOnlyMedias': 'Afficher uniquement les médias',
	'conversationMessagesSelectVisible': 'Sélectionner cette page',
	'conversationMessagesSelectAllFiltered': 'Tout sélectionner ({count, number})',
	'unselect': 'Désélectionner',
	'conversationMessagesEditHideSelected': 'Masquer les messages sélectionnés',
	'conversationMessagesEditShowSelected': 'Afficher les messages sélectionnés',
	'conversationMessagesEditTooManySelected': 'Trop de messages sélectionnés',
	'conversationNoMessages': 'Aucun message',
	'conversationMessageEdit': 'Modifier le message',
	'conversationMessageAdd': 'Ajouter un message',
	'conversationMessageInsert': 'Insérer un message ici',
	'conversationMessageEditSelect': 'Sélectionner ce message',
	'conversationMessageEditUnselect': 'Désélectionner ce message',
	'conversationMessageHiddenAlert': 'Ce message a été masqué et n\'apparaîtra pas dans votre livre imprimé.',
	'conversationMessageSetUnVisibleButton': 'Masquer ce message du livre imprimé',
	'conversationMessageSetVisibleButton': 'Réafficher le message',
	'conversationMessagesEditEnableButton': 'Activer la personnalisation',
	'conversationMessagesEditEnableButton2': 'Activer la personnalisation pour {price}',
	'conversationMessagesEditDisableAlert': "Si vous avez besoin de personnaliser vos messages, vous devez l'activer avec un paiement.",
	'conversationMessageDateHint': 'Modifiez la date et l\'heure pour placer ce message où vous voulez dans la conversation.',
	'conversationMessageSender': 'Expéditeur',
	'conversationMessageSenderPlaceholder': 'Choisir l\'expéditeur',
	'conversationMessageSenderRequiredHint': 'Choisissez qui envoie ce message pour pouvoir enregistrer.',
	'conversationMessageAnnotation': 'Annotation',
	'conversationMessageAnnotationNoMedia': 'Une annotation n\'accepte pas de photo, vidéo ou audio.',
	'conversationMessageText': 'Texte',
	'conversationMessageTextPlaceholder': 'Saisissez votre texte',
	'conversationMessageAttachments': 'Pièces jointes',
	'conversationMessageMediaLabel': 'Photo, vidéo ou audio',
	'conversationMessageMediaDragDrop': 'Glissez une photo, une vidéo ou un audio ici',
	'conversationMessageMediaTapSelect': 'Appuyez pour choisir une photo, une vidéo ou un audio',
	'conversationMessageMediaOpenFinder': 'Choisir un fichier',
	'conversationMessageMediaPickSenderFirst': 'Choisissez d\'abord un expéditeur pour ajouter une photo, une vidéo ou un audio.',
	'conversationMessageHiddenLabel': 'Masquer le message ?',
	'conversationGenerate': 'Générer les livres',
	'conversationVerify': 'Forcer la vérification',
	'conversationLaunchButton': 'Lancer en production',
	'conversationViewButton': 'Voir la conversation',
	'reset': 'Réinitialiser',
	'cms': 'CMS',
	'cmsLinkColor': 'Couleur du bouton',
	'cmsLinkNeedObfuscate': "Besoin d'obfuscation ?",
	'cmsImageUseForMobile': "Utilisé pour l'affichage mobile ?",
	'contentEditPage': 'Modifier la page',
	'cmsRedirectionAdd': 'Ajouter une redirection',
	'cmsContentEdit': 'Modifier le contenu',
	'cmsPageIsActive': 'Actif ?',
	'cmsContentTypeLabel': 'Type de contenu',
	'cmsContentModelLabel': 'Modèle de contenu',
	'cmsContentTitle': 'Titre',
	'cmsContentSlug': 'Slug',
	'cmsPanelIsTemplate': 'Inclus dans le modèle ?',
	'cmsPageSeoTitle': 'Titre SEO',
	'cmsPageSeoDescription': 'Description SEO',
	'cmsPageSeoKeywords': 'Mots-clés SEO',
	'cmsPageSeoHideOnSitemap': 'Masquer sur le sitemap',
	'cmsPageSeoUseCustomTitleSuffix': 'Utiliser un suffixe de titre personnalisé',
	'cmsPageSeoTitleSuffix': 'Suffixe de titre',
	'affiliation': 'Affiliation',
	'affiliationInvoiceTotalAdminTitle': 'Total TTC à payer',

	conversationImportLuxEyebrow: 'Votre histoire',
	conversationImportLuxTagline: 'Un cadeau unique, pensé par vous. Que personne d\'autre ne pourra offrir.',
	conversationImportLuxPrivacy: 'Vos messages restent confidentiels : seule la conversation choisie est utilisée.',
	conversationImportProgressExport: 'Exporter',
	conversationImportProgressUpload: 'Déposer',
	conversationImportProgressCustomize: 'Personnaliser',
	conversationImportUploadSuccess: 'Archive reçue : choisissez votre conversation à l\'étape suivante',
	conversationImportUploadSuccessSingle: 'Fichier reçu : continuez pour personnaliser votre livre',
	conversationImportContinueSingle: 'Continuer',
	conversationImportSelectionTitleSingle: 'Votre conversation',
	conversationImportSelectionHintSingle: 'Une seule conversation trouvée dans votre fichier.',
	conversationImportSelectionHintMultiple: 'Choisissez la conversation à transformer en livre : utilisez la recherche pour filtrer la liste.',
	conversationImportSelectionListCount: '{shown} sur {total} conversations',
	conversationImportSelectionNoMatch: 'Aucune conversation ne correspond à votre recherche.',
	conversationImportStepPickThread: 'Choisir la conversation',
	conversationImportStepMedia: 'Options photos',
	conversationImportStepTerms: 'Accepter les CGV',
	conversationImportExtrasLockedHint: 'Choisissez une conversation ci-dessus pour débloquer ces options.',
	conversationImportPickThreadBeforeTerms: 'Il vous reste à choisir une conversation ci-dessus avant de continuer.',
	conversationImportChangeThread: 'Changer de conversation',
	conversationImportSelectionConfirmedHint: 'Parfait : vous pouvez maintenant personnaliser votre livre ci-dessous.',

	conversationImportOptionsTitle: 'Photos et souvenirs',
	conversationImportOptionsHint: 'Tout est coché par défaut : décochez uniquement ce que vous ne souhaitez pas inclure.',
	conversationImportOptionsImagesLabel: 'Photos et images',
	conversationImportOptionsImagesDesc: 'Les photos de votre conversation seront imprimées dans le livre.',
	conversationImportOptionsMediasLabel: 'Vidéos, audio et GIFs',
	conversationImportOptionsMediasDesc: 'Accessibles via QR code imprimé dans le livre (stockage offert 10 ans).',
	conversationImportOptionsTransferNote: 'Le transfert peut prendre quelques minutes selon le nombre de photos : restez sur cette page.',
	conversationImportOptionsNoMedia: 'Votre fichier ne contient pas de photos ni de médias : votre livre inclura uniquement les messages.',
	conversationImportAgreementRead: 'Consultez les conditions générales de vente',
	conversationImportCreateBook: 'Créer mon livre',
	conversationImportSelectToContinue: 'Sélectionnez une conversation pour continuer.',
	conversationImportAcceptTermsToContinue: 'Cochez la case des conditions générales pour continuer.',
	conversationImportDropHint: 'Déposez votre fichier .zip ici, ou',
	conversationImportDropFormats: '.zip complet recommandé : ne l\'ouvrez pas (photos et médias inclus)',
	conversationImportJsonOnlyHint: 'Fichier .json seul : les photos et médias ne seront pas inclus. Pour un livre illustré, déposez le .zip complet sans l\'ouvrir. Si votre navigateur a déjà extrait l\'archive, compressez le dossier « messages » en .zip.',

	conversationInstagramImportIntro: '3 étapes pour récupérer vos messages Instagram :',
	conversationInstagramImportDemoTitle: 'Exportez vos messages Instagram',
	conversationInstagramImportDemoExportMeta: 'Exporter vers Appareil · JSON',
	conversationInstagramImportDemoDownloadsAvailable: 'Téléchargements disponibles',
	conversationInstagramImportDemoStartExport: 'Commencer l\'exportation',
	conversationInstagramImportDemoCustomizeMessages: 'Messages uniquement',
	conversationInstagramImportDemoCustomize: 'Personnaliser les informations',
	conversationInstagramImportDemoConfirmTitle: 'Confirmer votre exportation',
	conversationInstagramImportDemoSave: 'Enregistrer',
	conversationInstagramImportDemoMessagesTip: 'Facultatif mais plus rapide : tout effacer, puis Messages uniquement.',
	conversationInstagramImportDemoDataPayments: 'Paiement',
	conversationInstagramImportDemoDataComments: 'Commentaires',
	conversationInstagramImportDemoClearAll: 'Tout effacer',
	conversationInstagramImportDemoActivitySection: 'Votre activité sur Instagram',
	conversationInstagramImportDemoPickSpecific: 'Choisir des informations spécifiques à exporter',
	conversationInstagramImportDemoExportExternal: 'Exporter vers un service externe',
	conversationInstagramImportDemoExportDevice: 'Exporter sur mon appareil',
	conversationInstagramImportDemoChooseDestination: 'Choisir où exporter',
	conversationInstagramImportDemoProfileAccount: 'Votre compte · Instagram',
	conversationInstagramImportDemoProfileName: 'Votre nom de compte',
	conversationInstagramImportDemoAccountShort: 'Votre compte',
	conversationInstagramImportDemoProfiles: 'Profils',
	conversationInstagramImportDemoChooseProfile: 'Choisissez un profil',
	conversationInstagramImportDemoPastActivity: 'Activité passée',
	conversationInstagramImportDemoCurrentActivity: 'Activité en cours',
	conversationInstagramImportDemoCreateExport: 'Créer une exportation',
	conversationInstagramImportDemoExportIntro: 'Créez une copie de vos informations à télécharger sur votre appareil.',
	conversationInstagramImportDemoExportTitle: 'Exporter vos informations',
	conversationInstagramImportDemoCaptionStart: 'Appuyez sur Commencer l\'exportation',
	conversationInstagramImportDemoCaptionDevice: 'Appuyez sur Exporter sur mon appareil',
	conversationInstagramImportDemoCaptionProfile: 'Choisissez votre profil Instagram',
	conversationInstagramImportDemoCaptionCreate: 'Appuyez sur Créer une exportation',
	conversationInstagramImportDemoCaptionMessages: 'Astuce : Tout effacer, puis Messages uniquement (plus rapide)',
	conversationInstagramImportDemoCaptionJson: 'Choisissez le format JSON, puis Enregistrer',
	conversationInstagramImportDemoCaptionDrop: 'Téléchargez le .zip une fois prêt, puis déposez-le ci-dessous',
	conversationInstagramImportDemoPlatform: 'Instagram',
	conversationInstagramImportDemoDataMessages: 'Messages',
	conversationInstagramImportDemoFormat: 'Format',
	conversationInstagramImportDemoMediaQuality: 'Qualité des contenus multimédias',
	conversationInstagramImportDemoQualityLow: 'Basse',
	conversationInstagramImportDemoJsonNotice: 'JSON obligatoire pour votre livre. Le HTML ne fonctionnera pas.',
	conversationInstagramImportDemoReadyHint: 'Déposez le .zip complet ci-dessous sans l\'ouvrir. Vous choisirez la conversation ensuite.',
	conversationInstagramImportCta: 'Ouvrir les paramètres Instagram',
	conversationInstagramImportStep1: 'Appuyez sur <b>Créer une exportation</b>, choisissez votre profil <b>Instagram</b>, puis <b>Exporter sur mon appareil</b>.',
	conversationInstagramImportStep2: 'Astuce pour aller plus vite : <b>Tout effacer</b>, cochez <b>Messages</b> uniquement. Choisissez le format <b>JSON</b> et une qualité <b>basse</b>.',
	conversationInstagramImportStep3: 'Appuyez sur <b>Commencer l\'exportation</b>, attendez l\'e-mail (10 min à 24 h), téléchargez le <b>.zip</b> et déposez-le ci-dessous <b>sans l\'ouvrir</b> : vous choisirez la conversation <b>après</b> le dépôt.',
	conversationInstagramImportAlert: 'Format <b>JSON</b> obligatoire (pas HTML). Astuce : exporter <b>Messages</b> uniquement accélère le téléchargement, mais ce n\'est pas obligatoire.',
	conversationInstagramImportDetailTitle: 'Export Instagram : guide détaillé',
	conversationInstagramImportDetailIntro: 'Suivez chaque étape avec les captures ci-dessous. Le bouton ci-dessus ouvre directement la page d\'export.',
	conversationInstagramImportDetailSkipApp: 'J\'ai ouvert la page avec le bouton : commencer à l\'étape 5',
	conversationInstagramImportDetailStep1: 'Ouvrez l\'application <b>Instagram</b>, puis accédez aux <b>Paramètres</b> via les trois points en haut à droite.',
	conversationInstagramImportDetailStep2: 'Sélectionnez <b>Espace Comptes</b>.',
	conversationInstagramImportDetailStep3: 'Appuyez sur <b>Vos informations et autorisations</b>.',
	conversationInstagramImportDetailStep4: 'Choisissez <b>Exporter vos informations</b>.',
	conversationInstagramImportDetailStep5: 'Allez dans <b>Télécharger ou transférer des informations</b>. Si vous avez utilisé le bouton ci-dessus, vous êtes déjà sur cette page.',
	conversationInstagramImportDetailStep6: 'Sélectionnez <b>Instagram</b>. Cette étape peut ne pas apparaître sur certains comptes.',
	conversationInstagramImportDetailStep7: 'Choisissez <b>Certaines de vos informations</b>.',
	conversationInstagramImportDetailStep8: 'Faites défiler jusqu\'à <b>Messages</b>, cochez-le, puis appuyez sur <b>Suivant</b>.',
	conversationInstagramImportDetailStep9: 'Appuyez sur <b>Télécharger sur l\'appareil</b>.',
	conversationInstagramImportDetailStep10: 'Choisissez la période souhaitée, le format <b>JSON</b> et une qualité multimédia <b>faible</b> pour un téléchargement plus rapide.',
	conversationInstagramImportDetailStep11: 'Votre archive sera prête sous <b>10 minutes à 24 heures</b>. Un e-mail vous avertira dès qu\'elle est disponible : vous pourrez aussi la retrouver sur la page du Centre de comptes.',
	conversationInstagramImportDetailStep12: 'Téléchargez le fichier <b>.zip</b> complet sur votre appareil, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>. Seule la conversation que vous choisirez ensuite sera utilisée pour votre livre.',

	conversationKakaotalkImportIntro: 'Tout commence sur votre téléphone. Indiquez si vous êtes sur iPhone ou Android :',
	conversationKakaotalkImportPlatformIphone: 'iPhone',
	conversationKakaotalkImportPlatformAndroid: 'Android',
	conversationKakaotalkImportIphoneStep1: 'Sur votre iPhone, ouvrez <b>KakaoTalk</b> et la conversation que vous voulez dans votre livre.',
	conversationKakaotalkImportIphoneStep2: 'Appuyez sur le <b>menu</b> (☰) en haut à droite, puis sur l\'icône <b>réglages</b> en bas du panneau.',
	conversationKakaotalkImportIphoneStep3: 'Appuyez sur <b>Exporter la conversation</b>, puis choisissez <b>Envoyer les messages texte uniquement</b>.',
	conversationKakaotalkImportIphoneStep4: 'Enregistrez le fichier <b>.txt</b> (Fichiers, email, AirDrop), puis déposez-le ci-dessous <b>sans le modifier</b>.',
	conversationKakaotalkImportAndroidStep1: 'Sur votre téléphone, ouvrez <b>KakaoTalk</b> et la conversation que vous voulez dans votre livre.',
	conversationKakaotalkImportAndroidStep2: 'Appuyez sur le <b>menu</b> (☰) en haut à droite, puis sur l\'icône <b>réglages</b> en bas du panneau.',
	conversationKakaotalkImportAndroidStep3: 'Appuyez sur <b>Exporter la conversation</b>, puis choisissez <b>Envoyer le texte uniquement</b>.',
	conversationKakaotalkImportAndroidStep4: 'Enregistrez le fichier <b>.txt</b> (Fichiers, Google Drive, email), puis déposez-le ci-dessous <b>sans le modifier</b>.',
	conversationKakaotalkImportAlert: 'Une conversation par export. L\'autre option enregistre aussi vos photos, mais KakaoTalk ne les relie pas aux messages : choisissez le texte seul, les photos apparaîtront sous forme d\'un simple mot.',
	conversationKakaotalkImportDesktopNote: 'Sur ordinateur (Windows ou Mac) : ouvrez le menu de la conversation, puis <b>Enregistrer la conversation</b>. Le fichier <b>.txt</b> obtenu fonctionne aussi ici.',
	conversationLineImportIntro: 'Tout commence sur votre téléphone. Indiquez si vous êtes sur iPhone ou Android :',
	conversationLineImportPlatformIphone: 'iPhone',
	conversationLineImportPlatformAndroid: 'Android',
	conversationLineImportIphoneStep1: 'Sur votre iPhone, ouvrez <b>LINE</b> et la conversation que vous voulez dans votre livre.',
	conversationLineImportIphoneStep2: 'En haut de la discussion, appuyez sur le <b>menu</b> (☰) → <b>Paramètres</b>.',
	conversationLineImportIphoneStep3: 'Appuyez sur <b>Exporter l\'historique</b>, puis choisissez comment envoyer le fichier (Fichiers, email, AirDrop).',
	conversationLineImportIphoneStep4: 'Enregistrez le fichier <b>.txt</b>, puis déposez-le ci-dessous <b>sans le modifier</b>.',
	conversationLineImportAndroidStep1: 'Sur votre téléphone, ouvrez <b>LINE</b> et la conversation que vous voulez dans votre livre.',
	conversationLineImportAndroidStep2: 'En haut de la discussion, appuyez sur le <b>menu</b> (☰) → <b>Paramètres</b>.',
	conversationLineImportAndroidStep3: 'Appuyez sur <b>Exporter l\'historique</b>, puis choisissez comment envoyer le fichier (Fichiers, Google Drive, email).',
	conversationLineImportAndroidStep4: 'Enregistrez le fichier <b>.txt</b>, puis déposez-le ci-dessous <b>sans le modifier</b>.',
	conversationLineImportAlert: 'Une conversation par export. Seuls les messages actuellement visibles dans la discussion sont enregistrés, et LINE n\'exporte ni les photos ni les stickers en image.',
	conversationLineImportDesktopNote: 'Sur ordinateur (Windows ou Mac) : ouvrez <b>Discussions</b>, double-cliquez sur la conversation, puis utilisez le <b>menu</b> en haut → <b>Enregistrer la discussion</b>. Cet export n\'existe pas sur LINE pour Chrome.',

	conversationLinkedinImportIntro: '3 étapes pour récupérer vos conversations LinkedIn :',
	conversationLinkedinImportCta: 'Ouvrir la page d\'export LinkedIn',
	conversationLinkedinImportStep1: 'Depuis un <b>navigateur web</b> (ordinateur ou téléphone), ouvrez la page ci-dessus. Sinon : <b>Vous</b> → <b>Préférences et confidentialité</b> → <b>Confidentialité des données</b> → <b>Obtenir une copie de vos données</b>.',
	conversationLinkedinImportStep2: 'Demandez une archive contenant vos <b>Messages</b> : cochez le fichier <b>Messages</b>, ou choisissez l\'archive complète, puis cliquez sur <b>Demander l\'archive</b>.',
	conversationLinkedinImportStep3: 'Téléchargez le <b>.zip</b> depuis l\'email LinkedIn (10 min à 24 h), puis déposez-le ci-dessous <b>sans l\'ouvrir</b> : vous choisirez la conversation <b>après</b> le dépôt.',
	conversationLinkedinImportAlert: 'Cet export n\'existe pas dans l\'application mobile LinkedIn : passez par un navigateur. L\'archive doit contenir le fichier <b>messages.csv</b> (LinkedIn n\'exporte ni photos ni pièces jointes).',

	conversationSnapchatImportIntro: '3 étapes pour récupérer vos conversations Snapchat :',
	conversationSnapchatImportCta: 'Ouvrir Mes Données Snapchat',
	conversationSnapchatImportStep1: 'Dans l\'app : avatar → paramètres (roue dentée) → <b>Confidentialité</b> → <b>Mes Données</b>. Vous pouvez aussi passer par le lien ci-dessus.',
	conversationSnapchatImportStep2: 'Connectez-vous si nécessaire, puis appuyez sur <b>Envoyer une demande</b> en bas de la page : Snapchat vous enverra un email quand l\'archive est prête (quelques heures à 1 jour).',
	conversationSnapchatImportStep3: 'Téléchargez le <b>.zip</b> depuis l\'email, puis déposez-le ci-dessous <b>sans l\'ouvrir</b> : vous choisirez la conversation <b>après</b> le dépôt.',
	conversationSnapchatImportAlert: 'Archive <b>.zip</b> complète obligatoire : ne l\'ouvrez pas. Vos messages seront imprimés dans le livre (l\'export Snapchat ne contient pas de photos imprimables).',
	conversationSnapchatPlaceholderMedia: '[Média]',
	conversationSnapchatPlaceholderNote: '[Note vocale]',
	conversationSnapchatPlaceholderSticker: '[Sticker]',
	conversationSnapchatPlaceholderSnap: '[Snap]',
	conversationSnapchatPlaceholderAudio: '[Audio]',
	conversationSnapchatStatusParticipantAdded: 'Un membre a été ajouté au groupe',
	conversationSnapchatStatusNameChanged: 'Le nom du groupe a changé',
	conversationSnapchatStatusConversationCreated: 'Conversation créée',
	conversationSnapchatStatusGeneric: 'Notification Snapchat',
	conversationSnapchatImportPartialContent: '{withText} messages avec du texte sur {total}. Snapchat n\'exporte pas le contenu des messages non sauvegardés.',
	conversationSnapchatImportDetailTitle: 'Export Snapchat : guide détaillé',
	conversationSnapchatImportDetailIntro: 'Suivez chaque étape avec les captures ci-dessous. Vous pouvez aussi utiliser le bouton ci-dessus pour ouvrir directement Mes Données et passer à l\'étape 4.',
	conversationSnapchatImportDetailSkipApp: 'J\'ai ouvert la page avec le bouton : commencer à l\'étape 4',
	conversationSnapchatImportDetailStep1: 'Ouvrez <b>Snapchat</b> et appuyez sur votre photo de profil.',
	conversationSnapchatImportDetailStep2: 'Appuyez sur l\'icône <b>engrenage</b> pour ouvrir les paramètres.',
	conversationSnapchatImportDetailStep3: 'Descendez jusqu\'à <b>Actions sur le compte</b>, puis appuyez sur <b>Mes données</b>. Vous pouvez aussi utiliser le bouton ci-dessus.',
	conversationSnapchatImportDetailStep4: 'Cochez <b>Historique des chats</b>, choisissez les formats <b>JSON</b> et <b>HTML</b>, puis appuyez sur <b>Suivant</b>.',
	conversationSnapchatImportDetailStep5: 'Choisissez la période souhaitée, confirmez votre adresse e-mail, puis appuyez sur <b>Envoyer</b>.',
	conversationSnapchatImportDetailStep6: 'Snapchat vous enverra un e-mail une fois l\'export terminé : cela peut prendre de quelques heures à quelques jours.',
	conversationSnapchatImportDetailStep7: 'Quand vous recevez l\'e-mail, cliquez sur le lien pour accéder à vos données.',
	conversationSnapchatImportDetailStep8: 'Sur Snapchat, appuyez sur <b>Voir l\'export</b>, puis sur <b>Télécharger</b>.',
	conversationSnapchatImportDetailStep9: 'Téléchargez le fichier <b>.zip</b> complet sur votre appareil, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>. Seule la conversation que vous choisirez ensuite sera utilisée pour votre livre.',

	conversationTelegramImportIntro: '4 étapes pour exporter une conversation Telegram :',
	conversationTelegramImportCta: 'Télécharger Telegram Desktop',
	conversationTelegramImportStep1: 'Sur PC, installez <b>Telegram Desktop</b>. Sur Mac, ne prenez pas l\'application « Telegram » de l\'App Store : téléchargez <b>Telegram Desktop</b> avec le lien ci-dessus (sur l\'App Store, elle s\'appelle Telegram Lite). Ouvrez ensuite la conversation à transformer en livre.',
	conversationTelegramImportStep2: 'Cliquez sur les <b>trois points</b> en haut à droite → <b>Exporter l\'historique du chat</b>.',
	conversationTelegramImportStep3: 'Cochez <b>photos, vidéos et fichiers</b>, choisissez le format <b>JSON</b> (le HTML est accepté aussi), puis cliquez sur <b>Exporter</b> et attendez la fin du téléchargement.',
	conversationTelegramImportStep4: 'Compressez le dossier exporté en <b>.zip</b> (clic droit → compresser), puis déposez-le ci-dessous <b>sans l\'ouvrir</b> : vous validerez les options <b>après</b> le dépôt.',
	conversationTelegramImportAlert: 'Une conversation à la fois. Incluez les <b>médias</b> à l\'export pour un livre illustré : déposez le <b>.zip</b> complet, tel quel.',
	conversationTelegramImportDetailTitle: 'Export Telegram : guide détaillé',
	conversationTelegramImportDetailIntro: 'Suivez chaque étape avec les captures ci-dessous. Utilisez le bouton ci-dessus pour télécharger Telegram Desktop, ou passez à l\'étape 2 si l\'application est déjà installée.',
	conversationTelegramImportDetailSkipApp: 'J\'ai déjà Telegram Desktop : commencer à l\'étape 2',
	conversationTelegramImportDetailStep1: 'Sur PC, <b>Telegram Desktop</b> est la bonne application. Sur Mac, téléchargez <b>Telegram Desktop</b> via le lien ci-dessus : l\'application « Telegram » de l\'App Store n\'a pas l\'export. Sur l\'App Store, le bon logiciel s\'appelle <b>Telegram Lite</b>.',
	conversationTelegramImportDetailStep2: 'Ouvrez la <b>conversation</b> que vous souhaitez transformer en livre.',
	conversationTelegramImportDetailStep3: 'Cliquez sur les <b>trois points</b> en haut à droite, puis sur <b>Exporter la conversation</b>.',
	conversationTelegramImportDetailStep4: 'Cochez <b>tous les types de fichiers</b> (photos, vidéos, messages vocaux, etc.), montez la taille max à <b>1500 Mo</b> et choisissez le format <b>JSON</b>. Si aucun choix de format n\'apparaît, l\'export HTML fonctionne aussi.',
	conversationTelegramImportDetailStep5: 'Cliquez sur <b>Exporter</b> en bas à droite pour lancer l\'export.',
	conversationTelegramImportDetailStep6: 'Sur votre téléphone, appuyez sur <b>Autoriser</b> si demandé. Compressez le dossier exporté en <b>.zip</b>, puis déposez-le ci-dessous <b>sans l\'ouvrir</b> : vous validerez les options après le dépôt.',

	conversationImportDetectedPlatform: 'Voici les étapes pour {platform}. Les autres options restent disponibles.',
	conversationWhatsappImportIntro: 'Tout commence sur votre téléphone. Indiquez si vous êtes sur iPhone ou Android :',
	conversationWhatsappImportPlatformIphone: 'iPhone',
	conversationWhatsappImportPlatformAndroid: 'Android',
	conversationWhatsappImportIphoneStep1: 'Ouvrez la conversation, appuyez sur le <b>nom en haut</b>, puis sur <b>Exporter la discussion</b>.',
	conversationWhatsappImportIphoneStep2: 'Choisissez <b>Avec médias</b> pour les photos dans le livre (ou <b>Sans média</b> pour le texte seul).',
	conversationWhatsappImportIphoneStep3: 'Enregistrez dans <b>Fichiers</b>, puis déposez le <b>.zip</b> ci-dessous <b>sans l\'ouvrir</b>.',
	conversationWhatsappImportIphoneStep4: '<b>Avec médias</b> pour un livre illustré, <b>sans média</b> pour les messages seuls : enregistrez le fichier sur votre ordinateur ou mobile, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>.',
	conversationWhatsappImportAndroidStep1: 'Ouvrez la discussion, appuyez sur <b>⋮</b> → <b>Plus</b> → <b>Exporter la discussion</b>.',
	conversationWhatsappImportAndroidStep2: 'Choisissez <b>Avec médias</b> pour les photos dans le livre (ou <b>Sans média</b> pour le texte seul).',
	conversationWhatsappImportAndroidStep3: 'Enregistrez ou partagez le fichier, puis déposez le <b>.zip</b> ci-dessous <b>sans l\'ouvrir</b>.',
	conversationWhatsappImportAndroidStep4: 'Enregistrez le fichier (Fichiers, Google Drive ou e-mail), transférez-le sur votre ordinateur ou mobile, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>.',
	conversationWhatsappImportAlert: 'Une conversation par export. Préférez <b>Avec médias</b> pour un livre illustré. Restez sur cette page jusqu\'à la fin du transfert.',
	conversationWhatsappImportAlertAndroid: 'Une conversation par export. Préférez <b>Avec médias</b>. Sur certains téléphones, seul l\'e-mail fonctionne : choisissez alors <b>Sans média</b>. Restez sur cette page jusqu\'à la fin du transfert.',
	conversationWhatsappImportIphoneDetailTitle: 'Export WhatsApp sur iPhone : guide détaillé',
	conversationWhatsappImportIphoneDetailIntro: 'Suivez chaque étape sur votre iPhone avec les captures ci-dessous, puis transférez le fichier sur votre ordinateur ou mobile avant de le déposer ici.',
	conversationWhatsappImportIphoneDetailStep1: 'Ouvrez <b>WhatsApp</b> et la conversation que vous souhaitez transformer en livre.',
	conversationWhatsappImportIphoneDetailStep2: 'Appuyez sur le <b>nom du contact</b> ou du groupe en haut de l\'écran.',
	conversationWhatsappImportIphoneDetailStep3: 'Faites défiler tout en bas de la page jusqu\'à <b>Exporter la discussion</b>.',
	conversationWhatsappImportIphoneDetailStep4: 'Appuyez sur <b>Exporter la discussion</b>.',
	conversationWhatsappImportIphoneDetailStep5: 'Choisissez <b>Avec médias</b> pour un livre illustré, ou <b>Sans média</b> pour les messages seuls.',
	conversationWhatsappImportIphoneDetailStep6: 'Enregistrez le fichier sur votre ordinateur ou mobile (par ex. dans Fichiers), puis déposez-le ci-dessous <b>sans l\'ouvrir</b>.',
	conversationWhatsappImportAndroidDetailTitle: 'Export WhatsApp sur Android : guide détaillé',
	conversationWhatsappImportAndroidDetailIntro: 'Suivez chaque étape sur votre Android avec les captures ci-dessous, puis transférez le fichier sur votre ordinateur ou mobile avant de le déposer ici.',
	conversationWhatsappImportAndroidDetailStep1: 'Ouvrez <b>WhatsApp</b> et la conversation à transformer en livre.',
	conversationWhatsappImportAndroidDetailStep2: 'Appuyez sur <b>⋮</b> (en haut à droite) → <b>Plus</b> → <b>Exporter la discussion</b>.',
	conversationWhatsappImportAndroidDetailStep3: 'Choisissez <b>Avec médias</b> pour inclure les photos, ou <b>Sans média</b> pour les messages seuls.',
	conversationWhatsappImportAndroidDetailStep4: 'Enregistrez le fichier (Fichiers, Google Drive ou e-mail), transférez-le sur votre ordinateur ou mobile, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>.',
	conversationWhatsappImportDemoTitle: 'Exporter votre conversation WhatsApp',
	conversationWhatsappImportDemoIndividual: 'Discussion individuelle',
	conversationWhatsappImportDemoGroup: 'Discussion de groupe',
	conversationWhatsappImportDemoCaptionOpen: 'Ouvrez la discussion dans WhatsApp',
	conversationWhatsappImportDemoCaptionTapName: 'Appuyez sur le nom en haut',
	conversationWhatsappImportDemoCaptionExport: 'Faites défiler, puis touchez Exporter la discussion',
	conversationWhatsappImportDemoCaptionMedia: 'Choisissez Avec médias pour les photos du livre',
	conversationWhatsappImportDemoCaptionSave: 'Enregistrez dans Fichiers, puis déposez-le ci-dessous',
	conversationWhatsappImportDemoExportLabel: 'Exporter la discussion',
	conversationWhatsappImportDemoMediaNotice: 'Avec médias crée une archive plus lourde, idéale pour un livre illustré.',
	conversationWhatsappImportDemoAttachMedia: 'Avec médias',
	conversationWhatsappImportDemoWithoutMedia: 'Sans média',
	conversationWhatsappImportDemoSaveFiles: 'Enregistrer dans Fichiers',
	conversationWhatsappImportDemoA11y: 'Guide animé : ouvrez la discussion, appuyez sur le nom, exportez, choisissez Avec médias, puis enregistrez dans Fichiers.',
	conversationWhatsappImportDemoCaptionExportGroup: 'Ouvrez le menu ⋯, puis touchez Exporter la discussion',
	conversationWhatsappImportDemoContactName: 'Léa',
	conversationWhatsappImportDemoContactMom: 'Maman',
	conversationWhatsappImportDemoGroupName: 'Week-end potes',
	conversationWhatsappImportDemoGroupWork: 'Projet : design',
	conversationWhatsappImportDemoChats: 'Discussions',
	conversationWhatsappImportDemoHeaderSubContact: 'appuyez ici pour les infos du contact',
	conversationWhatsappImportDemoHeaderSubGroup: 'appuyez ici pour les infos du groupe',
	conversationWhatsappImportDemoGroupsInCommon: 'Groupes en commun',
	conversationWhatsappImportDemoSeeAll: 'Voir tout ›',
	conversationWhatsappImportDemoAddFavorite: 'Ajouter aux favoris',
	conversationWhatsappImportDemoAddList: 'Ajouter à une liste',
	conversationWhatsappImportDemoClearChat: 'Vider la discussion',
	conversationWhatsappImportDemoBlock: 'Bloquer',
	conversationWhatsappImportDemoParticipants: '{count} participants',
	conversationWhatsappImportDemoAudio: 'Audio',
	conversationWhatsappImportDemoVideo: 'Vidéo',
	conversationWhatsappImportDemoAdd: 'Ajouter',
	conversationWhatsappImportDemoSearch: 'Rechercher',
	conversationWhatsappImportDemoMemberYou: 'Vous',
	conversationWhatsappImportDemoMemberAlex: 'Alex',
	conversationWhatsappImportDemoMemberCamille: 'Camille',
	conversationWhatsappImportDemoEditGroup: 'Modifier le nom et la photo',
	conversationWhatsappImportDemoEditDescription: 'Modifier la description',
	conversationWhatsappImportAndroidDemoIncludeMedia: 'Avec médias',
	conversationWhatsappImportAndroidDemoWithoutMedia: 'Sans média',
	conversationWhatsappImportAndroidDemoMediaNotice: 'Avec médias pour un livre illustré. Sans média : plus léger.',
	conversationWhatsappImportAndroidDemoClear: 'Effacer la discussion',
	conversationWhatsappImportAndroidDemoExport: 'Exporter la discussion',
	conversationWhatsappImportAndroidDemoReport: 'Signaler',
	conversationWhatsappImportAndroidDemoMore: 'Plus',
	conversationWhatsappImportAndroidDemoWallpaper: 'Fond d\'écran',
	conversationWhatsappImportAndroidDemoMute: 'Couper les notifications',
	conversationWhatsappImportAndroidDemoOnline: 'en ligne',
	conversationWhatsappImportAndroidDemoCaptionSave: 'Enregistrez ou partagez le fichier, puis déposez-le ci-dessous',
	conversationWhatsappImportAndroidDemoCaptionMedia: 'Choisissez Avec médias pour les photos dans le livre',
	conversationWhatsappImportAndroidDemoCaptionExport: 'Appuyez sur Plus, puis Exporter la discussion',
	conversationWhatsappImportAndroidDemoCaptionMenu: 'Appuyez sur le menu en haut à droite',
	conversationWhatsappImportAndroidDemoCaptionOpen: 'Ouvrez la conversation dans WhatsApp',
	conversationWhatsappImportAndroidDemoTitle: 'Exportez votre conversation WhatsApp sur Android',
	conversationWhatsappImportAndroidDemoShareHint: 'Puis déposez le .zip ci-dessous sans l\'ouvrir.',
	conversationWhatsappImportAndroidDemoFiles: 'Fichiers',
	conversationWhatsappImportAndroidDemoShareVia: 'Envoyer vers…',

	conversationMessengerImportIntro: 'Commencez par <b>Après 2023</b> : discussions chiffrées, sur Messenger.com. Passez à <b>Avant 2023</b> si la vôtre n\'y est pas.',
	conversationMessengerImportContext: 'Une discussion commencée avant 2023 peut continuer après l\'activation du chiffrement. Messenger la coupe alors en deux archives. Importez les deux, puis fusionnez-les depuis votre liste de conversations.',
	conversationMessengerImportPlatformClassic: 'Avant 2023',
	conversationMessengerImportPlatformEncrypted: 'Après 2023',
	conversationMessengerImportClassicCta: 'Ouvrir Meta pour exporter',
	conversationMessengerClassicImportDemoReadyHint: 'Déposez le .zip complet ci-dessous sans l\'ouvrir. Vous choisirez la conversation ensuite.',
	conversationMessengerClassicImportDemoExportMeta: 'Exporter vers Appareil · JSON',
	conversationMessengerClassicImportDemoDownloadsAvailable: 'Téléchargements disponibles',
	conversationMessengerClassicImportDemoStartExport: 'Commencer l\'exportation',
	conversationMessengerClassicImportDemoQualityLow: 'Basse',
	conversationMessengerClassicImportDemoMediaQuality: 'Qualité des contenus multimédias',
	conversationMessengerClassicImportDemoCustomizeMessages: 'Messages uniquement',
	conversationMessengerClassicImportDemoCustomize: 'Personnaliser les informations',
	conversationMessengerClassicImportDemoConfirmTitle: 'Confirmer votre exportation',
	conversationMessengerClassicImportDemoJsonNotice: 'JSON obligatoire pour votre livre. Le HTML ne fonctionnera pas.',
	conversationMessengerClassicImportDemoFormat: 'Format',
	conversationMessengerClassicImportDemoSave: 'Enregistrer',
	conversationMessengerClassicImportDemoMessagesTip: 'Facultatif mais plus rapide : tout effacer, puis Messages uniquement.',
	conversationMessengerClassicImportDemoDataMessages: 'Messages',
	conversationMessengerClassicImportDemoDataPayments: 'Paiement',
	conversationMessengerClassicImportDemoDataComments: 'Commentaires',
	conversationMessengerClassicImportDemoClearAll: 'Tout effacer',
	conversationMessengerClassicImportDemoActivitySection: 'Votre activité sur Facebook',
	conversationMessengerClassicImportDemoPickSpecific: 'Choisir des informations spécifiques à exporter',
	conversationMessengerClassicImportDemoExportExternal: 'Exporter vers un service externe',
	conversationMessengerClassicImportDemoExportDevice: 'Exporter sur mon appareil',
	conversationMessengerClassicImportDemoChooseDestination: 'Choisir où exporter',
	conversationMessengerClassicImportDemoAccountShort: 'Votre compte',
	conversationMessengerClassicImportDemoProfileAccount: 'Votre compte · Facebook',
	conversationMessengerClassicImportDemoPlatform: 'Facebook',
	conversationMessengerClassicImportDemoProfileName: 'Votre nom de compte',
	conversationMessengerClassicImportDemoProfiles: 'Profils',
	conversationMessengerClassicImportDemoChooseProfile: 'Choisissez un profil',
	conversationMessengerClassicImportDemoPastActivity: 'Activité passée',
	conversationMessengerClassicImportDemoCurrentActivity: 'Activité en cours',
	conversationMessengerClassicImportDemoCreateExport: 'Créer une exportation',
	conversationMessengerClassicImportDemoExportIntro: 'Créez une copie de vos informations à télécharger sur votre appareil.',
	conversationMessengerClassicImportDemoExportTitle: 'Exporter vos informations',
	conversationMessengerClassicImportDemoCaptionDrop: 'Téléchargez le .zip une fois prêt, puis déposez-le ci-dessous',
	conversationMessengerClassicImportDemoCaptionStart: 'Appuyez sur Commencer l\'exportation',
	conversationMessengerClassicImportDemoCaptionJson: 'Choisissez le format JSON, puis Enregistrer',
	conversationMessengerClassicImportDemoCaptionMessages: 'Astuce : Tout effacer, puis Messages uniquement (plus rapide)',
	conversationMessengerClassicImportDemoCaptionDevice: 'Appuyez sur Exporter sur mon appareil',
	conversationMessengerClassicImportDemoCaptionProfile: 'Choisissez votre profil Facebook',
	conversationMessengerClassicImportDemoCaptionCreate: 'Appuyez sur Créer une exportation',
	conversationMessengerClassicImportDemoTitle: 'Exportez vos conversations Messenger d\'avant 2023',
	conversationMessengerEncryptedImportDemoTitle: 'Exportez vos conversations Messenger d\'après 2023',
	conversationImportDemoBadgeMeta: 'Exemple : à reproduire sur Meta, avec le bouton au-dessus',
	conversationMessengerEncryptedImportDemoBadge: 'Exemple : à reproduire sur Messenger.com, avec le bouton au-dessus',
	conversationMessengerEncryptedImportDemoCaptionLogin: 'Sur ordinateur, ouvrez Messenger.com et connectez-vous',
	conversationMessengerEncryptedImportDemoCaptionSettings: 'Cliquez sur l’engrenage en bas à gauche',
	conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Ouvrez Confidentialité et sécurité',
	conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Choisissez Discussions chiffrées de bout en bout',
	conversationMessengerEncryptedImportDemoCaptionStorage: 'Ouvrez Stockage des messages',
	conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Cliquez sur Télécharger les données liées au stockage des messages',
	conversationMessengerEncryptedImportDemoCaptionRange: 'Laissez Média coché, puis choisissez la période All time',
	conversationMessengerEncryptedImportDemoCaptionDrop: 'Cliquez sur Télécharger le fichier, puis déposez le .zip ci-dessous',
	conversationMessengerEncryptedImportDemoLandingTitle: 'Un espace pour des conversations intéressantes',
	conversationMessengerEncryptedImportDemoLandingText: 'Messenger vous permet de communiquer avec vos proches.',
	conversationMessengerEncryptedImportDemoContinueAs: 'Continuer en tant que Votre nom',
	conversationMessengerEncryptedImportDemoSwitchAccount: 'Changer de compte',
	conversationMessengerEncryptedImportDemoChats: 'Discussions',
	conversationMessengerEncryptedImportDemoSearch: 'Rechercher dans Messenger',
	conversationMessengerEncryptedImportDemoContactName: 'Votre contact',
	conversationMessengerEncryptedImportDemoContactStatus: 'En ligne',
	conversationMessengerEncryptedImportDemoLockBadge: 'Chiffré de bout en bout',
	conversationMessengerEncryptedImportDemoMenuPreferences: 'Préférences',
	conversationMessengerEncryptedImportDemoMenuProfileName: 'Modifier le nom de profil',
	conversationMessengerEncryptedImportDemoMenuRestricted: 'Comptes restreints',
	conversationMessengerEncryptedImportDemoMenuAccessibility: 'Accessibilité',
	conversationMessengerEncryptedImportDemoMenuHelp: 'Aide',
	conversationMessengerEncryptedImportDemoPrivacyTitle: 'Confidentialité et sécurité',
	conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Confirmations de lecture',
	conversationMessengerEncryptedImportDemoPrivacyReported: 'Discussions signalées',
	conversationMessengerEncryptedImportDemoPrivacyKeys: 'Vérifier les clés dans la discussion',
	conversationMessengerEncryptedImportDemoEncryptedTitle: 'Discussions chiffrées de bout en bout',
	conversationMessengerEncryptedImportDemoEncryptedHint: 'Gérez les paramètres de vos discussions chiffrées de bout en bout',
	conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Alertes de sécurité',
	conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Aperçus',
	conversationMessengerEncryptedImportDemoStorageTitle: 'Stockage des messages',
	conversationMessengerEncryptedImportDemoStorageHint: 'Gérez la manière dont vous stockez et accédez à l’historique de vos discussions',
	conversationMessengerEncryptedImportDemoStorageIntro: 'Vos messages chiffrés de bout en bout sont stockés de manière sécurisée dans votre sauvegarde.',
	conversationMessengerEncryptedImportDemoStoragePin: 'Réinitialiser le code PIN',
	conversationMessengerEncryptedImportDemoStorageMethods: 'Gérer les méthodes de sécurité',
	conversationMessengerEncryptedImportDemoStorageRemember: 'Se souvenir de ce navigateur',
	conversationMessengerEncryptedImportDemoStorageDownload: 'Télécharger les données liées au stockage des messages',
	conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Téléchargez tous vos messages et pièces jointes chiffrés de bout en bout.',
	conversationMessengerEncryptedImportDemoStorageAutoImport: 'Désactiver les importations automatiques',
	conversationMessengerEncryptedImportDemoDownloadTitle: 'Télécharger vos données',
	conversationMessengerEncryptedImportDemoDownloadIntro: 'Vous pouvez à tout moment télécharger une copie de tous vos messages et pièces jointes chiffrés de bout en bout.',
	conversationMessengerEncryptedImportDemoMediaTip: 'Laissez Média coché, sinon votre livre n’aura aucune photo.',
	conversationMessengerEncryptedImportDemoFileNotice: 'La préparation du fichier peut prendre quelques minutes.',
	conversationMessengerEncryptedImportDemoDownloadFile: 'Télécharger le fichier',
	conversationMessengerEncryptedImportDemoReadyHint: 'Déposez le .zip complet ci-dessous sans l’ouvrir. Vous choisirez la conversation ensuite.',
	conversationMessengerImportEncryptedCta: 'Ouvrir Messenger.com pour exporter',
	conversationMessengerImportClassicStep1: 'Appuyez sur <b>Créer une exportation</b>, choisissez votre profil <b>Facebook</b>, puis <b>Exporter sur mon appareil</b>.',
	conversationMessengerImportClassicStep2: 'Astuce pour aller plus vite : <b>Tout effacer</b>, cochez <b>Messages</b> uniquement. Choisissez le format <b>JSON</b> et une qualité <b>basse</b>.',
	conversationMessengerImportClassicStep3: 'Appuyez sur <b>Commencer l\'exportation</b>, attendez l\'e-mail (10 min à 24 h), téléchargez le <b>.zip</b> et déposez-le ci-dessous <b>sans l\'ouvrir</b> : vous choisirez la conversation <b>après</b> le dépôt.',
	conversationMessengerImportClassicAlert: 'Conversation absente ? Passez à <b>Après 2023</b>. Format <b>JSON</b> obligatoire (pas HTML). Astuce : exporter <b>Messages</b> uniquement accélère le téléchargement, mais ce n\'est pas obligatoire.',
	conversationMessengerImportEncryptedStep1: 'Sur ordinateur, ouvrez <b>Messenger.com</b>, connectez-vous, puis cliquez sur l’<b>engrenage</b> en bas à gauche.',
	conversationMessengerImportEncryptedStep2: 'Allez dans <b>Confidentialité et sécurité</b>, puis <b>Discussions chiffrées de bout en bout</b>, puis <b>Stockage des messages</b>.',
	conversationMessengerImportEncryptedStep3: 'Cliquez sur <b>Télécharger les données liées au stockage des messages</b>. Laissez <b>Média</b> coché et choisissez la période <b>All time</b>.',
	conversationMessengerImportEncryptedStep4: 'Cliquez sur <b>Télécharger le fichier</b>, puis déposez le <b>.zip</b> ci-dessous <b>sans l’ouvrir</b> : vous choisirez la conversation <b>après</b> le dépôt.',
	conversationMessengerImportEncryptedAlert: 'Laissez <b>Média</b> coché, sinon votre livre n’aura aucune photo. Conversation absente ? Passez à <b>Avant 2023</b>.',
	conversationMessengerImportClassicDetailTitle: 'Export avant 2023 : guide détaillé',
	conversationMessengerImportClassicDetailIntro: 'Suivez chaque étape avec les captures ci-dessous. Le bouton ci-dessus ouvre directement la page d\'export.',
	conversationMessengerImportClassicDetailSkipApp: 'J\'ai ouvert la page avec le bouton : commencer à l\'étape 5',
	conversationMessengerImportClassicDetailStep1: 'Ouvrez l\'application <b>Messenger</b>, puis accédez aux <b>Paramètres</b> via les trois points.',
	conversationMessengerImportClassicDetailStep2: 'Appuyez sur l\'icône <b>engrenage</b>.',
	conversationMessengerImportClassicDetailStep3: 'Sélectionnez <b>Espace Comptes</b>.',
	conversationMessengerImportClassicDetailStep4: 'Appuyez sur <b>Vos informations et autorisations</b>.',
	conversationMessengerImportClassicDetailStep5: 'Choisissez <b>Télécharger vos informations</b>.',
	conversationMessengerImportClassicDetailStep6: 'Allez dans <b>Télécharger ou transférer des informations</b>. Si vous avez utilisé le bouton ci-dessus, vous êtes déjà sur cette page.',
	conversationMessengerImportClassicDetailStep7: 'Sélectionnez <b>Facebook</b>. Cette étape peut ne pas apparaître sur certains comptes.',
	conversationMessengerImportClassicDetailStep8: 'Choisissez <b>Certaines de vos informations</b>.',
	conversationMessengerImportClassicDetailStep9: 'Cochez <b>Messages</b> uniquement, puis appuyez sur <b>Suivant</b>.',
	conversationMessengerImportClassicDetailStep10: 'Appuyez sur <b>Télécharger sur l\'appareil</b>.',
	conversationMessengerImportClassicDetailStep11: 'Choisissez la période souhaitée, le format <b>JSON</b> et une qualité <b>faible</b>. Votre archive sera prête sous <b>10 minutes à 24 heures</b> : un e-mail vous avertira.',
	conversationMessengerImportClassicDetailStep12: 'Téléchargez le fichier <b>.zip</b> complet sur votre appareil, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>. Seule la conversation que vous choisirez ensuite sera utilisée pour votre livre.',
	conversationMessengerImportEncryptedDetailTitle: 'Export après 2023 : guide détaillé',
	conversationMessengerImportEncryptedDetailIntro: 'Suivez chaque étape avec les captures ci-dessous. Vous pouvez aussi utiliser le bouton ci-dessus pour ouvrir Messenger.com et passer à l\'étape 2.',
	conversationMessengerImportEncryptedDetailSkipApp: 'Je suis déjà sur Messenger.com : commencer à l\'étape 2',
	conversationMessengerImportEncryptedDetailStep1: 'Sur ordinateur, ouvrez <b>Messenger.com</b> et cliquez sur votre photo de profil en bas à gauche.',
	conversationMessengerImportEncryptedDetailStep2: 'Appuyez sur <b>Confidentialité et sécurité</b>.',
	conversationMessengerImportEncryptedDetailStep3: 'Appuyez sur <b>Discussions chiffrées de bout en bout</b>.',
	conversationMessengerImportEncryptedDetailStep4: 'Appuyez sur <b>Stockage sécurisé</b>.',
	conversationMessengerImportEncryptedDetailStep5: 'Appuyez sur <b>Télécharger les données du stockage sécurisé</b>.',
	conversationMessengerImportEncryptedDetailStep6: 'Appuyez sur <b>Télécharger le fichier</b>.',
	conversationMessengerImportEncryptedDetailStep7: 'Saisissez votre mot de passe Facebook, puis appuyez sur <b>Confirmer</b>.',
	conversationMessengerImportEncryptedDetailStep8: 'Appuyez sur <b>Télécharger</b>. La préparation du fichier peut prendre quelques minutes.',
	conversationMessengerImportEncryptedDetailStep9: 'Téléchargez le fichier <b>.zip</b> complet sur votre ordinateur, puis déposez-le ci-dessous <b>sans l\'ouvrir</b>. Seule la conversation que vous choisirez ensuite sera utilisée pour votre livre.',
	conversationMessengerImportMissingTip: 'Conversation absente de la liste ? Revenez en arrière et essayez l\'export <b>Après 2023</b>.',
	conversationMessengerImportEmptyTitle: 'Aucune conversation trouvée dans cette archive',

	conversationSmsImportTagline: 'Pas de fichier à déposer ici : tout se fait depuis notre logiciel ou notre application.',
	conversationSmsImportIntro: 'Pas de dépôt de fichier sur cette page. Tout se fait depuis notre logiciel (iPhone) ou notre application (Android). Indiquez votre configuration :',
	conversationSmsImportContext: 'Notre application Android n\'est <b>pas sur Google Play</b> : l\'accès aux SMS y est restreint. Pour l\'ouvrir, Android et Play Protect demandent une confirmation.',
	conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
	conversationSmsImportPlatformIphonePc: 'iPhone + PC',
	conversationSmsImportPlatformAndroid: 'Android',
	conversationSmsImportMacCta: 'Télécharger le logiciel Mac',
	conversationSmsImportPcCta: 'Télécharger le logiciel PC',
	conversationSmsImportAndroidCta: 'Télécharger l\'application Android',
	conversationSmsImportMacStep1: 'Téléchargez le logiciel Mac.',
	conversationSmsImportMacStep2: 'Installez-le et <b>laissez-vous guider</b> : le logiciel vous indique la marche à suivre.',
	conversationSmsImportMacStep3: 'Choisissez la <b>conversation</b> à envoyer sur votre compte, puis restez sur l\'écran jusqu\'à la fin du transfert.',
	conversationSmsImportMacStep4: 'Installez le logiciel ci-dessous, accordez-lui un <b>accès complet au disque</b> dans Réglages système → Confidentialité, puis choisissez la conversation à envoyer sur votre compte.',
	conversationSmsImportMacHelp: 'Si le logiciel ne trouve pas votre sauvegarde : Réglages système → Confidentialité et sécurité → <b>Accès complet au disque</b> → ajoutez MonLivreSMS (déverrouillez le cadenas en bas à gauche).',
	conversationSmsImportMacAlert: 'Pas de dépôt de fichier ici : le transfert part du logiciel, qui vous guide à l\'écran.',
	conversationSmsImportPcStep1: 'Téléchargez le logiciel PC.',
	conversationSmsImportPcHelp: 'Dans iTunes, vérifiez que <b>Chiffrer la sauvegarde locale</b> est bien décochée avant de cliquer sur <b>Sauvegarder maintenant</b>. Repère visuel ci-dessus.',
	conversationSmsImportHelpToggle: 'Besoin d\'aide plus détaillée ?',
	conversationSmsImportPcStep2: 'Installez-le et <b>laissez-vous guider</b> : le logiciel vous indique la marche à suivre.',
	conversationSmsImportPcStep3: 'Choisissez la <b>conversation</b> à envoyer sur votre compte, puis restez sur l\'écran jusqu\'à la fin du transfert.',
	conversationSmsImportPcStep4: 'Installez le logiciel ci-dessous, lancez-le (autorisez l\'exécution si Windows le demande), puis choisissez la conversation à envoyer sur votre compte.',
	conversationSmsImportPcAlert: 'Pas de dépôt de fichier ici : le transfert part du logiciel, qui vous guide à l\'écran.',
	conversationSmsImportAndroidStep1: 'Sur votre téléphone Android, téléchargez notre <b>application hors Store</b> ci-dessous : l\'accès aux SMS n\'est pas autorisé sur Google Play.',
	conversationSmsImportAndroidStep2: 'Ouvrez le fichier téléchargé. Si Android refuse l\'installation, appuyez sur <b>Paramètres</b>, activez <b>Autoriser cette source</b>, puis revenez en arrière.',
	conversationSmsImportAndroidStep3: 'Si <b>Play Protect</b> s\'affiche, appuyez sur <b>Plus de détails</b>, puis sur <b>Installer quand même</b>. Appuyez ensuite sur <b>Installer</b>, puis sur <b>Ouvrir</b>.',
	conversationSmsImportAndroidStep4: 'Dans l\'application, acceptez l\'accès aux <b>SMS</b> et aux <b>contacts</b>.',
	conversationSmsImportAndroidStep5: 'Choisissez la <b>conversation</b> et validez. Restez sur l\'écran jusqu\'à la fin du transfert : les messages partent directement vers votre compte.',
	conversationSmsImportAndroidAlert: 'Pas de fichier à déposer ici. Restez sur l\'écran de transfert dans l\'app pour que toutes les photos soient bien récupérées.',
	conversationSmsImportFooter: 'Une fois le transfert terminé, personnalisez votre livre sur ce site : l\'application vous redirigera automatiquement.',
	conversationSmsImportAndroidDetailIntro: 'Suivez chaque étape sur votre téléphone Android. L\'application n\'est <b>pas sur Google Play</b>. Android, puis Play Protect, demandent une confirmation avant de l\'ouvrir : c\'est normal.',
	conversationSmsImportAndroidDetailSkipApp: 'J\'ai déjà téléchargé l\'app : commencer à l\'étape 2',
	conversationSmsImportAndroidDetailStep1: 'Téléchargez notre application d\'extraction SMS hors Google Play (bouton ci-dessous) : l\'accès aux SMS n\'y est pas autorisé.',
	conversationSmsImportAndroidDetailStep2: 'Après le téléchargement, appuyez sur <b>Ouvrir</b>.',
	conversationSmsImportAndroidDetailStep3: 'Appuyez sur <b>Paramètres</b> pour autoriser l\'installation.',
	conversationSmsImportAndroidDetailStep4: 'Activez <b>Autoriser cette source</b>, puis revenez en arrière pour retrouver l\'installation.',
	conversationSmsImportAndroidDetailStep5: 'Si <b>Play Protect</b> s\'affiche, appuyez sur <b>Plus de détails</b>, puis sur <b>Installer quand même</b>. Installez, ouvrez l\'application, et acceptez l\'accès aux SMS et aux contacts.',
	conversationSmsImportAndroidDetailStep6: 'Sélectionnez la <b>conversation</b> de votre choix.',
	conversationSmsImportAndroidDetailStep7: 'Validez et confirmez : restez sur l\'écran de transfert jusqu\'à la fin pour que toutes les photos soient bien récupérées. Vous serez redirigé automatiquement pour personnaliser votre livre.',
	conversationSmsImportAndroidDetailTitle: 'Export SMS Android : guide détaillé',
	conversationSmsImportMacDetailIntro: 'Téléchargez le logiciel et laissez-vous guider à l\'écran. Les captures ci-dessous aident surtout pour l\'installation.',
	conversationSmsImportMacDetailSkipSoftware: 'J\'ai déjà téléchargé le logiciel : commencer à l\'étape 8',
	conversationSmsImportMacDetailStep1: 'Branchez votre iPhone à votre Mac avec un câble USB.',
	conversationSmsImportMacDetailStep10: 'Ouvrez les <b>Réglages système</b> → <b>Confidentialité et sécurité</b>.',
	conversationSmsImportMacDetailStep11: 'Descendez en bas de la page et cliquez sur <b>Ouvrir quand même</b>.',
	conversationSmsImportMacDetailStep12: 'Sur l\'alerte de sécurité, cliquez sur <b>Autoriser</b>.',
	conversationSmsImportMacDetailStep13: 'Cliquez sur <b>Ouvrir</b>.',
	conversationSmsImportMacDetailStep14: 'Cliquez sur <b>Continuer</b>.',
	conversationSmsImportMacDetailStep15: 'Cliquez à nouveau sur <b>Continuer</b>.',
	conversationSmsImportMacDetailStep16: 'Cliquez sur <b>Installer</b>.',
	conversationSmsImportMacDetailStep17: 'Sur l\'alerte de sécurité, cliquez à nouveau sur <b>Autoriser</b>.',
	conversationSmsImportMacDetailStep18: 'Cliquez sur <b>Fermer</b> pour quitter l\'assistant.',
	conversationSmsImportMacDetailStep19: 'Ouvrez le <b>Finder</b> → <b>Applications</b>, puis lancez <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'Pour un livre illustré : ouvrez l\'app <b>Messages</b>, sélectionnez la conversation, puis appuyez sur le <b>nom du contact</b>.',
	conversationSmsImportMacDetailStep20: 'Cliquez sur la <b>pomme</b> en haut à gauche → <b>Réglages système</b>.',
	conversationSmsImportMacDetailStep21: 'Ouvrez <b>Confidentialité et sécurité</b> → <b>Accès complet au disque</b>.',
	conversationSmsImportMacDetailStep22: 'Faites glisser l\'icône MonLivreSMS dans la liste (clic prolongé), puis cochez <b>Accès complet au disque</b>.',
	conversationSmsImportMacDetailStep23: 'Cliquez sur <b>Ouvrir</b> pour confirmer.',
	conversationSmsImportMacDetailStep24: 'Cliquez à nouveau sur <b>Ouvrir</b> si une seconde confirmation s\'affiche.',
	conversationSmsImportMacDetailStep25: 'Choisissez la <b>conversation</b> à exporter : textes et photos seront envoyés sur votre compte. Restez sur l\'écran de transfert jusqu\'à la fin, avec une connexion internet stable.',
	conversationSmsImportMacDetailStep3: 'Faites défiler tout en bas de la fiche contact.',
	conversationSmsImportMacDetailStep4: 'Appuyez sur <b>Télécharger</b> pour importer toutes les photos iCloud sur l\'iPhone.',
	conversationSmsImportMacDetailStep5: 'Ouvrez le <b>Finder</b>, sélectionnez votre iPhone dans la barre latérale, décochez <b>Chiffrer la sauvegarde locale</b> et activez <b>Sauvegarder toutes les données sur ce Mac</b>.',
	conversationSmsImportMacDetailStep6: 'Cliquez sur <b>Sauvegarder maintenant</b> et attendez la fin de la sauvegarde.',
	conversationSmsImportMacDetailStep7: 'Téléchargez le logiciel MonLivreSMS pour Mac (bouton ci-dessous sur cette page).',
	conversationSmsImportMacDetailStep8: 'Double-cliquez sur le dossier <b>MonLivreSMS</b> téléchargé.',
	conversationSmsImportMacDetailStep9: 'Cliquez sur <b>OK</b> pour lancer l\'installation.',
	conversationSmsImportMacDetailTitle: 'Export SMS iPhone + Mac : guide détaillé',
	conversationSmsImportPcDetailIntro: 'Téléchargez le logiciel et laissez-vous guider à l\'écran. Les captures ci-dessous aident surtout pour l\'installation.',
	conversationSmsImportPcDetailSkipSoftware: 'J\'ai déjà téléchargé le logiciel : commencer à l\'étape 3',
	conversationSmsImportPcDetailStep1: 'Branchez votre iPhone à votre PC avec un câble USB.',
	conversationSmsImportPcDetailStep2: 'Téléchargez le logiciel MonLivreSMS pour PC (bouton ci-dessous sur cette page).',
	conversationSmsImportPcDetailStep3: 'Installez <link>iTunes</link> si ce n\'est pas déjà fait.',
	conversationSmsImportPcDetailStep4: 'Lancez iTunes.',
	conversationSmsImportPcDetailStep5: 'Connectez-vous avec votre <b>identifiant Apple</b> et validez sur l\'iPhone si demandé.',
	conversationSmsImportPcDetailStep6: 'Une fois l\'iPhone reconnu, cliquez sur <b>Continuer</b>.',
	conversationSmsImportPcDetailStep7: 'Dans <b>Résumé</b>, décochez <b>Chiffrer la sauvegarde locale</b> puis cliquez sur <b>Sauvegarder maintenant</b> (sur cet ordinateur, pas iCloud).',
	conversationSmsImportPcDetailStep8: 'Une fois la sauvegarde terminée, ouvrez le dossier MonLivreSMS. Si Windows affiche un avertissement, cliquez sur <b>Informations complémentaires</b> puis <b>Exécuter quand même</b>. Choisissez ensuite la conversation à envoyer sur votre compte.',
	conversationSmsImportPcDetailTitle: 'Export SMS iPhone + PC : guide détaillé',
	offerErrorRequired: 'Merci de remplir les champs obligatoires.',
	offerErrorEmail: 'Vérifiez votre adresse email.',
	offerErrorGiftEmail: 'Vérifiez l\'adresse email de votre proche.',
	offerErrorGiftSameEmail: 'L\'email de votre proche doit être différent du vôtre.',
	offerErrorGeneric: 'Oups, ça n\'a pas marché. Réessayez dans un instant.',
	offerStepWhoEyebrow: 'C\'est parti',
	offerStepWhoTitle: 'Qui va créer le livre ?',
	offerStepWhoHint: 'Vous le composez vous-même, pour vous ou pour l\'offrir. La carte cadeau, c\'est si l\'autre personne le crée.',
	offerWhoSelf: 'Je vais le créer',
	offerWhoSelfHint: 'Pour moi, ou pour l\'offrir une fois imprimé',
	offerWhoGift: 'J\'offre une carte cadeau',
	offerWhoGiftHint: 'La personne reçoit un lien et crée son livre',
	offerStepOccasionEyebrow: 'L\'occasion',
	offerStepOccasionHint: 'Le moment auquel vous pensez.',
	offerStepGiftEyebrow: 'Votre cadeau',
	offerStepGiftTitle: 'À qui l\'offrez-vous ?',
	offerStepGiftHint: 'On envoie le cadeau par email, avec un lien pour créer le livre. Rien à imprimer, rien à emballer.',
	offerGiftName: 'Son prénom',
	offerGiftEmail: 'Son email',
	offerGiftEmailHelp: 'Le cadeau arrive dans cette boîte mail juste après le paiement.',
	offerGiftFromName: 'Votre prénom',
	offerGiftFromNameHelp: 'Pour savoir de qui vient ce cadeau.',
	offerGiftMessage: 'Un petit mot (facultatif)',
	offerGiftMessagePlaceholder: 'Pour que ces messages restent toujours près de toi.',
	offerContinue: 'Continuer',
	offerStepMessengerEyebrow: 'Vos messages',
	offerStepMessengerTitleGift: 'Où sont les messages du livre pour {name} ?',
	offerStepMessengerTitle: 'Où sont vos plus beaux messages ?',
	offerStepMessengerHint: 'Choisissez-en une. Vous pourrez changer plus tard.',
	offerStepMessengerHintGift: 'Votre conversation avec {name}, ou la sienne avec un être cher. Un doute sur l\'appli ? {name} pourra en choisir une autre.',
	offerStepEmailEyebrow: 'Presque fini',
	offerStepEmailTitle: 'Votre compte',
	offerStepEmailHintGift: 'Google, Apple, ou votre e-mail. Un mail confirme l\'adresse, puis vous payez la carte.',
	offerStepEmailHint: 'Google, Apple, ou votre e-mail. Un mail confirme l\'adresse, puis vous importez la conversation.',
	offerStepEmailHintPay: 'Google, Apple, ou votre e-mail. Un mail confirme l\'adresse, puis vous payez le livre.',
	offerEmailLabel: 'Adresse email',
	offerEmailPlaceholder: 'vous@exemple.com',
	offerEmailSubmit: 'Passer au paiement',
	offerEmailSubmitAccount: 'Créer mon compte',
	offerEmailPrivacy: 'Juste votre livre. Pensez à regarder dans vos spams.',
	offerStepSentEyebrow: 'Ravis de vous revoir',
	offerStepSentTitle: 'Vous avez déjà un compte',
	offerStepSentCodeHint: 'On vient d\'envoyer un code à 6 chiffres à {email}. Saisissez-le ici : votre commande vous attend, prête à payer. Pensez à regarder dans vos spams.',
	offerStepSentCodeHintAccount: 'On vient d\'envoyer un code à 6 chiffres à {email}. Saisissez-le ici pour ouvrir votre compte et commencer le livre. Pensez à regarder dans vos spams.',
	offerStepPayEyebrow: 'Dernière étape',
	offerStepPayTitleGift: 'Le livre pour {name}',
	offerStepPayTitle: 'Votre livre imprimé',
	offerLoggedAs: 'Compte : {email}',
	offerSwitchAccount: 'Ce n\'est pas vous ?',
	offerTrustReviews: 'Plus de {count} avis sur Trustpilot',
	offerTrustGuarantee: 'Satisfait ou remboursé',
	offerTrustShipping: 'Livraison offerte',
	offerPageTitle: 'Votre livre de messages',
	offerBack: 'Retour',
	offerItemName: 'Livre imprimé à personnaliser',
	offerPayBenefitBook: 'Votre livre imprimé, mis en page avec vos messages et vos photos',
	offerPayBenefitBookGift: 'Un vrai livre imprimé, avec les messages et les photos de son choix',
	offerPayBenefitMedia: 'Les vocaux et les vidéos aussi, à revivre grâce aux QR codes imprimés',
	offerPayBenefitCustom: 'Couverture, photo, titre, couleurs, préface : tout se personnalise',
	offerPayBenefitPdf: 'Le PDF offert avec le livre',
	offerPayBenefitShipping: 'Livraison offerte',
	offerPayTotal: 'Total',
	offerPayNextGift: 'Juste après le paiement, {name} reçoit votre cadeau par email.',
	offerPayNextSelf: 'Juste après le paiement, vous importez la conversation. Quelques minutes.',
	offerPayDreamSelf: 'Ces messages que vous relisez sur votre téléphone, bientôt entre vos mains. Pour toujours.',
	offerPayDreamGift: 'Le jour où {name} l\'ouvrira, tous ces messages prendront vie entre ses mains.',
	offerPayButton: 'Payer {price}',
	offerPaySecure: 'Paiement sécurisé. Sans abonnement.',
	offerConfirmStepsTitle: 'Comment ça marche',
	offerConfirmGiftStep1: '{name} ouvre l\'email et clique sur le lien',
	offerConfirmGiftStep2: '{name} importe la conversation en quelques minutes',
	offerConfirmGiftStep3: 'Nous imprimons le livre et l\'expédions',
	offerConfirmGiftTitle: 'C\'est envoyé à {name} !',
	offerConfirmGiftLead: '{name} vient de recevoir votre cadeau sur {email}, avec un lien pour créer le livre. Il est déjà payé, livraison comprise.',
	offerConfirmViewOrder: 'Voir ma commande',
	offerConfirmGiftNote: 'Pas reçu ? Demandez-lui de regarder dans ses spams, ou écrivez-nous.',
	offerConfirmStep1: 'Exportez votre conversation depuis {messenger}',
	offerConfirmStep1Generic: 'Exportez votre conversation depuis votre messagerie',
	offerConfirmStep2: 'Importez-la ici : on s\'occupe de toute la mise en page',
	offerConfirmStep3: 'Validez votre livre : on l\'imprime et on vous l\'envoie',
	offerConfirmTitle: 'Bravo, votre livre est payé !',
	offerConfirmLead: 'Plus qu\'une chose à faire : importer votre conversation {messenger}. On vous guide pas à pas, ça ne prend que quelques minutes.',
	offerConfirmLeadGeneric: 'Plus qu\'une chose à faire : importer votre conversation. On vous guide pas à pas, ça ne prend que quelques minutes.',
	offerConfirmCta: 'Importer ma conversation {messenger}',
	offerConfirmCtaGeneric: 'Importer ma conversation',
	offerConfirmChangeMessenger: 'Mes messages sont sur une autre appli',
	offerConfirmEmailNote: 'Votre reçu et votre lien de connexion ont été envoyés à {email}.',
	userMagicTitle: 'Connexion',
	userMagicWorking: 'Connexion en cours…',
	userMagicExpired: 'Ce lien a expiré. Recevez-en un nouveau en un clic.',
	userMagicInvalid: 'Ce lien n\'est plus valide. Recevez-en un nouveau en un clic.',
	userMagicSent: 'Si un compte existe avec cette adresse, un nouveau lien est en route. Pensez à regarder dans vos spams.',
	userMagicEmailLabel: 'Votre adresse email',
	userMagicSend: 'Recevoir un nouveau lien',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Inclus',
	conversationPreviewCollectionPrepaidNote: '{count} tomes · {paid, plural, one {# déjà payé} other {# déjà payés}}',
	conversationPreviewBookCreditBannerBestof: 'Votre livre est déjà payé : le Best Of est inclus. Vous préférez la collection complète ? Vous ne payez que la différence.',
	conversationPreviewBookCreditBanner: 'Votre livre est déjà payé, livraison standard comprise. Personnalisez-le, puis finalisez votre commande.',
	conversationOrderButtonBookCreditRemaining: 'Finaliser mon livre · reste {price}',
	conversationOrderButtonBookCreditIncluded: 'Finaliser mon livre · Inclus',
	conversationPreviewBookCreditOrderHint: '{credit} déjà payés · prix catalogue {fullPrice}',
	conversationOrderButtonBookCredit: 'Finaliser mon livre',
	conversationPreviewStickyBookCredit: 'Livre déjà payé',
	paymentMethodBookCreditHint: 'Votre livre est déjà payé',
	cartTotalsBookCredit: 'Livre déjà payé',
	paymentMethodBookcredit: 'Livre payé d\'avance',
  },
};

// comment: `user {name} {value, plural,
//       =0 {does not have any comments}
//       =1 {has # comment}
//       other {has # comments}
//     } (in real app this would be translated to French)`,
